{
  "ai": {
    "actions": {
      "addAttachments": "Add photos or files"
    },
    "attachments": {
      "imageAlt": "Image",
      "remove": "Remove"
    },
    "conversation": {
      "emptyDescription": "Start a conversation to see messages here",
      "emptyTitle": "No messages yet"
    },
    "core": {
      "placeholder": "What would you like to know?",
      "stop": "Stop",
      "submit": "Submit",
      "uploadFiles": "Upload files"
    },
    "sources": {
      "usedCount": "Used {count, plural, one {{count} source} other {{count} sources}}"
    },
    "tool": {
      "errorHeading": "Error",
      "parameters": "Parameters",
      "statusAwaitingApproval": "Awaiting Approval",
      "statusCompleted": "Completed",
      "statusDenied": "Denied",
      "statusError": "Error",
      "statusPending": "Pending",
      "statusResponded": "Responded",
      "statusRunning": "Running"
    }
  },

  "auth": {
    "appleNativeSheet": {
      "appleFailed": "Apple sign in failed. Please try again in a moment.",
      "appleInvalidResponse": "Apple sent back a response we couldn't read. Please try again.",
      "appleNotHandled": "Apple couldn't handle the sign in request. Please try again.",
      "appleNotInteractive": "Apple couldn't show the sign in sheet. Please try again.",
      "appleUnavailable": "Apple couldn't start sign in. Check that you're signed in to your Apple Account in iOS Settings, then try again."
    },
    "appleSignInButton": {
      "continue": "Continue with Apple",
      "errorFallback": "An error occurred during Apple sign in",
      "signingIn": "Signing in..."
    },
    "authScreen": {
      "confirmPasswordLabel": "Confirm password",
      "confirmPasswordPlaceholder": "Re-enter your password",
      "errorPasswordTooShort": "Password must be at least 8 characters",
      "errorPasswordsMismatch": "Passwords do not match",
      "newPasswordLabel": "New password",
      "newPasswordPlaceholder": "Minimum 8 characters",
      "passwordResetDescription": "Your password has been reset successfully.",
      "passwordResetTitle": "Password reset",
      "signIn": "Sign in"
    },
    "errors": {
      "accountNotFound": "Account not found",
      "changeEmailDisabled": "Change email is disabled",
      "credentialAccountNotFound": "Credential account not found",
      "emailAlreadyVerified": "Email is already verified",
      "emailCanNotBeUpdated": "Email can not be updated",
      "emailMismatch": "Email mismatch",
      "emailNotVerified": "Email not verified",
      "failedToUnlinkLastAccount": "You can't unlink your last account",
      "invalidEmail": "Invalid email",
      "invalidEmailOrPassword": "Invalid email or password",
      "invalidOtp": "Invalid OTP",
      "invalidPassword": "Invalid password",
      "invalidToken": "Invalid token",
      "linkedAccountAlreadyExists": "Linked account already exists",
      "otpExpired": "OTP expired",
      "passwordAlreadySet": "User already has a password set",
      "passwordTooLong": "Password too long",
      "passwordTooShort": "Password too short",
      "sessionExpired": "Session expired. Re-authenticate to perform this action.",
      "sessionNotFresh": "Session is not fresh",
      "socialAccountAlreadyLinked": "Social account already linked",
      "tokenExpired": "Token expired",
      "tooManyAttempts": "Too many attempts",
      "tooManyRequests": "Too many attempts. Wait a moment and try again.",
      "userAlreadyExists": "User already exists.",
      "userAlreadyExistsUseAnotherEmail": "User already exists. Use another email.",
      "userAlreadyHasPassword": "User already has a password. Provide that to delete the account.",
      "userNotFound": "User not found"
    },
    "filingExceptionNotice": {
      "worksFromDayOne": "Guest messages, the calendar, tasks and the AI assistant work from your first day."
    },
    "forgotPassword": {
      "backToSignIn": "Back to sign in",
      "codeLabel": "Reset code",
      "descriptionCode": "We sent a code to {email}. Enter it below with your new password.",
      "descriptionEmail": "Enter your email and we'll send you a 6-digit reset code",
      "emailLabel": "Email",
      "emailPlaceholder": "name@example.com",
      "errorCodeIncomplete": "Enter the 6-digit code from your email",
      "errorEmailRequired": "Email is required",
      "resend": "Didn't get a code? Resend",
      "resetting": "Resetting...",
      "sendCode": "Send reset code",
      "submit": "Reset password",
      "titleCode": "Enter reset code",
      "titleEmail": "Forgot password"
    },
    "googleSignInButton": {
      "continue": "Continue with Google",
      "signingIn": "Signing in..."
    },
    "legalConsent": {
      "agreement": "By creating an account, you agree to our <terms>Terms of Service</terms> and <privacy>Privacy Policy</privacy>."
    },
    "oauthConsent": {
      "allow": "Allow access",
      "allowing": "Allowing...",
      "deny": "Deny",
      "denying": "Denying...",
      "errorRequestInvalid": "This connection request is no longer valid. Close this tab and reconnect from your AI app.",
      "errorSessionEnded": "Your Vidimo session ended. Sign in again, then reconnect from your AI app.",
      "errorUnreachable": "Could not reach Vidimo. Check your connection and try again.",
      "expiredDescription": "This connection request is invalid or has expired. Close this tab and reconnect from your AI app.",
      "expiredTitle": "Connection request expired",
      "goToSignIn": "Go to sign in",
      "guestsDetail": "contact details, filing status",
      "guestsLabel": "Guests & registration",
      "loading": "Loading...",
      "occupancyDetail": "metrics, rooms, team",
      "occupancyLabel": "Occupancy & property info",
      "importHeading": "Import your existing bookings",
      "importScope": "Owners and managers can let it copy bookings from your previous system into a property that is still preparing in Vidimo. It can update or cancel only bookings imported from your previous system, and nothing it imports reaches guests, channels or the authorities.",
      "readOnlyHeading": "Read-only access to",
      "readOnlyScope": "Only what your role can already see in the app. It can't create, change, send, or delete anything.",
      "readOnlyScopeExceptImport": "Only what your role can already see in the app. Apart from importing bookings, it can't create, change, send, or delete anything.",
      "readableItem": "<strong>{label}</strong><muted> — {detail}</muted>",
      "reservationsDetail": "bookings, dates, free rooms",
      "reservationsLabel": "Reservations & availability",
      "signInRequiredDescription": "Your Vidimo session has ended. Sign in, then restart the connection from your AI app.",
      "signInRequiredTitle": "Sign in required",
      "signedInAs": "Signed in as {email}. You can disconnect any time from {name}.",
      "signedInAsUnnamed": "Signed in as {email}. You can disconnect any time from your AI app.",
      "tasksDetail": "cleaning and maintenance",
      "tasksLabel": "Tasks",
      "title": "Allow access to your Vidimo data?",
      "touristTaxDetail": "amounts owed and paid",
      "touristTaxLabel": "Tourist tax & balances",
      "wantsToConnect": "<app>{name}</app> wants to connect to your Vidimo account.",
      "wantsToConnectUnnamed": "An AI app wants to connect to your Vidimo account."
    },
    "resetPassword": {
      "backToSignIn": "Back to sign in",
      "description": "Enter your new password below",
      "errorTokenMissing": "Invalid or missing reset token",
      "resetting": "Resetting...",
      "submit": "Reset password",
      "title": "Reset password"
    },
    "signIn": {
      "description": "Enter your email below to sign in to your account",
      "emailLabel": "Email",
      "emailPlaceholder": "name@example.com",
      "errorCredentialsRequired": "Email and password are required",
      "forgotPassword": "Forgot password?",
      "noAccount": "Don't have an account?",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Enter your password",
      "signUp": "Sign up",
      "signingIn": "Signing in...",
      "submit": "Sign in",
      "title": "Sign in"
    },
    "signUp": {
      "creatingAccount": "Creating account...",
      "description": "Sign up to get started with Vidimo",
      "emailLabel": "Email",
      "emailPlaceholder": "name@example.com",
      "errorCredentialsRequired": "Email and password are required",
      "errorNameRequired": "Display name is required",
      "errorPasswordTooShort": "Password must be at least 8 characters",
      "haveAccount": "Already have an account?",
      "nameLabel": "Display name",
      "namePlaceholder": "John Doe",
      "passwordHint": "Must be at least 8 characters",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Minimum 8 characters",
      "signIn": "Sign in",
      "submit": "Create account",
      "title": "Create an account"
    },
    "socialSignIn": {
      "divider": "Or continue with"
    },
    "verifyEmail": {
      "backToSignIn": "Back to sign in",
      "continue": "Continue",
      "errorLinkExpired": "That verification link has expired. Send a new one.",
      "errorLinkFailed": "That verification link didn't work.",
      "errorLinkInvalid": "That verification link is no longer valid.",
      "errorLinkNotVerified": "That verification link didn't work. Send a new one.",
      "errorNoSessionEmail": "No user email found in session",
      "errorNotConfirmed": "We couldn't confirm that your email was verified.",
      "errorTokenMissing": "Invalid or missing verification token",
      "failedTitle": "Verification failed",
      "goToSignIn": "Go to sign in",
      "resend": "Resend verification email",
      "resent": "Sent — check your inbox for a fresh link.",
      "sendAnother": "Send another",
      "successDescription": "Your email has been verified. You will be signed in automatically.",
      "successTitle": "Email verified",
      "unconfirmedDescription": "You're signed out, so we can't confirm the result here. Sign in — if the link worked, your email is already verified.",
      "unconfirmedTitle": "Check your verification link"
    }
  },

  "calendar": {
    "agendaData": {
      "arrival": "Arrival",
      "balanceDue": "{amount} due",
      "departure": "Departure",
      "due": "Due {date}",
      "eta": "ETA {time}",
      "guest": "Guest",
      "inHouse": "In-house",
      "paid": "Paid",
      "until": "Until {date}"
    },
    "calendarAgendaView": {
      "arrivals": "Arrivals",
      "departures": "Departures",
      "emptyDescription": "No arrivals, departures, or in-house guests for {date}.",
      "emptyDescriptionToday": "No arrivals, departures, or in-house guests for today.",
      "emptyTitle": "Nothing scheduled",
      "inHouse": "In-house",
      "syncing": "Syncing your agenda…",
      "tasksFor": "Tasks for {guestName}",
      "unassigned": "Unassigned",
      "unconfirmed": "Unconfirmed"
    },
    "calendarAvailabilityBand": {
      "free": "Free",
      "freeRoomsPerNight": "Free rooms per night",
      "roomsFree": "{count, plural, one {room free} other {rooms free}}",
      "spokenDatePrefix": "{date}: "
    },
    "calendarLegend": {
      "markBase": "Base price",
      "markChanged": "Just changed",
      "markChosen": "Chosen to change",
      "markChosenClosed": "Chosen, not for sale",
      "markClosed": "Not for sale",
      "markMinStay": "Minimum stay",
      "markSeason": "From a season",
      "markSet": "Set for that night",
      "rates": "Rates",
      "reservations": "Reservations",
      "tapActivity": "Who changed what is under the property's Settings, Team, Activity.",
      "tapDate": "Tap a date to change that night for every unit type of the property.",
      "tapNight": "Tap a night to change it.",
      "tapOtherRow": "Tap a night in another row to add that unit type.",
      "tapSpan": "Tap a second night in the same row for a span of nights.",
      "tasks": "Tasks",
      "title": "Legend"
    },
    "calendarPage": {
      "createFirstUnit": "Create your first unit",
      "emptyDescription": "Add a unit to your property to start tracking reservations on the calendar.",
      "emptyTitle": "No units yet",
      "legend": "Calendar legend",
      "newReservation": "New reservation",
      "newTask": "New task",
      "tasksMissingTitle": "Tasks are missing from the calendar",
      "title": "Calendar",
      "unavailableDescription": "Vidimo can't load your units on this device. Try again; this reloads the app.",
      "unavailableTitle": "The calendar can't be shown right now"
    },
    "calendarView": {
      "blockDates": "Block dates",
      "blockingHint": "Drag across a room's row to hold the nights you cover. Swipe the dates or room names to scroll. To open a stay, tap {done} first.",
      "doneBlocking": "Done blocking",
      "errorBlockFailed": "Couldn't block those nights. Try again.",
      "jumpToDate": "Jump to date",
      "next": "Next",
      "noUnits": "No units to display",
      "previous": "Previous",
      "staffEmptyDescription": "Staff view shows each team member's assigned tasks and time off.",
      "staffEmptyTitle": "No team members to show",
      "syncing": "Syncing your calendar…",
      "today": "Today",
      "unassignedLane": "Unassigned",
      "unknownProperty": "Unknown property"
    },
    "calendarViewMenu": {
      "title": "View",
      "triggerLabel": "View: {view}"
    },
    "propertyEmptyState": {
      "acceptInvitation": "Accept invitation",
      "back": "Back",
      "createDescription": "Set up a new property to manage guests and staff.",
      "createInstead": "Create a property instead",
      "createTitle": "Create a property",
      "errorCreateFailed": "Couldn't create the property. Try again.",
      "getStartedDescription": "Create a new property or join an existing one with an invite code.",
      "getStartedTitle": "Get started",
      "invitedAs": "Invited as {role}",
      "invitedDescription": "{count, plural, one {You've been invited to a property. Accept to get started.} other {You've been invited to these properties. Accept one to get started.}}",
      "invitedTitle": "You're invited",
      "joinDescription": "Enter the invite code you received to join your team.",
      "joinTitle": "Join a property",
      "syncing": "Setting up your property…",
      "syncingSlow": "This is taking longer than usual. Your property is set up and will appear once your connection catches up.",
      "toastCreated": "Property created"
    },
    "timelineData": {
      "away": "Away"
    },
    "todayPage": {
      "nextDay": "Next day",
      "pickDay": "Pick a day",
      "previousDay": "Previous day"
    },
    "transportSelector": {
      "changeTransport": "Change transport",
      "menuLabel": "Select transport"
    },
    "unitReadinessControl": {
      "errorUpdateFailed": "Couldn't update the room's status. Try again.",
      "hint": "Saved as you change it. Finishing a cleaning task sets this to Clean, and a checkout sets it to Dirty — except for Out of order, which only you can clear.",
      "label": "Readiness",
      "outOfOrderHint": "Out of order also stops new bookings being placed in the room and pauses the door code for anyone already staying in it."
    }
  },

  "checkIn": {
    "guestRegistration": {
      "anotherGuest": "another guest",
      "heldByOther": "{documentNumber} already used by {holderName}."
    },
    "useRegistrationOutbox": {
      "deferred": "{count, plural, one {{guests}'s registration was taken by another sign-in. It files when they next sign in here.} other {Registrations for {guests} were taken by other sign-ins. They file when those users next sign in here.}}",
      "dropped": "{count, plural, one {Couldn't file {guests}'s registration. Open the reservation to fix it.} other {Couldn't file registrations for {guests}. Open the reservations to fix them.}}",
      "filed": "{count, plural, one {A pending guest registration has been filed.} other {# pending guest registrations have been filed.}}",
      "guestsOneNameAndOthers": "{first} and {count, plural, one {# other} other {# others}}",
      "guestsTwoNames": "{first} and {second}",
      "guestsTwoNamesAndOthers": "{first}, {second} and {count, plural, one {# other} other {# others}}",
      "guestsUnnamed": "{count, plural, one {a guest} other {# guests}}"
    }
  },

  "common": {
    "countryPicker": {
      "emptyLabel": "No countries match",
      "placeholder": "Select country",
      "searchLabel": "Search countries"
    },
    "dateRangePicker": {
      "nights": "{nights, plural, one {# night} other {# nights}}",
      "placeholder": "Select dates"
    },
    "detailsDrawer": {
      "close": "Close",
      "copyLinkLabel": "Copy link to this record",
      "edit": "Edit"
    },
    "dialog": {
      "close": "Close"
    },
    "errors": {
      "generic": "Something went wrong. Please try again.",
      "networkUnreachable": "No connection. Check your network and try again.",
      "subscriptionRequired": "This needs an active subscription, and this property doesn't have one.",
      "unreadableNumber": "Type a number like {example, number}."
    },
    "insetForm": {
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving..."
    },
    "loading": "Loading",
    "personCard": {
      "call": "Call",
      "callLabel": "Call {name}",
      "idOnFile": "ID on file",
      "message": "Message",
      "openLabel": "Open {name}"
    },
    "phoneNumberInput": {
      "country": "Country code",
      "international": "International",
      "invalid": "Check the number, and pick its country from the flag."
    },
    "picker": {
      "done": "Done",
      "noMatches": "No matches",
      "search": "Search"
    }
  },

  "communications": {
    "connectRefusalDrafts": {
      "account_claimed": "Hi, I'm trying to connect an account that's already connected to another property. Can you help?",
      "number_claimed": "Hi, I'm trying to connect a number that's already connected to another property. Can you help?",
      "property_preparing": "Hi, I'd like to connect a channel while my property is still preparing. Can you help?",
      "setup_broken": "Hi, connecting a channel stopped on a setup the app can't continue. Can you help?",
      "subscription_required": "Hi, connecting a channel asks for an active subscription. Can you help?"
    },
    "activeCallView": {
      "activeCall": "Active call",
      "hangUp": "Hang up",
      "minimiseCall": "Minimise call",
      "mute": "Mute",
      "resume": "Resume",
      "roomStatus": "Room {unitCode} · {status}",
      "speakerOff": "Speaker off",
      "speakerOn": "Speaker on",
      "transfer": "Transfer",
      "unmute": "Unmute"
    },
    "aiChatListView": {
      "emptyDescription": "Start a new conversation with your AI assistant",
      "emptyTitle": "No AI conversations",
      "newChat": "New chat"
    },
    "aiChatView": {
      "aiAssistant": "AI Assistant",
      "chooseProperty": "Choose a property",
      "choosePropertyDescription": "The assistant answers for one property at a time, so pick the one you want to ask about.",
      "choosePropertyTitle": "Which property?",
      "emptyDescription": "Ask me about guest information, reservation updates, or operational tasks",
      "emptyTitle": "How can I help you today?",
      "errorAmbiguousScopeDetail": "The assistant answers for one property at a time. Pick one from the header and ask again.",
      "errorAmbiguousScopeTitle": "Choose a property",
      "errorEmptyScopeDetail": "Your property scope doesn't include an accessible property. Widen it from the header and try again.",
      "errorEmptyScopeTitle": "Nothing in scope",
      "errorPausedDetailNative": "AI is included with an active subscription for this property.",
      "errorPausedTitle": "AI is paused",
      "errorSend": "Couldn't send your message. Try again.",
      "errorTranscribe": "Couldn't transcribe your recording",
      "errorUnreachableDetail": "Check your connection and try again.",
      "errorUnreachableTitle": "The assistant couldn't respond",
      "newChat": "New chat",
      "retry": "Try again",
      "retryTooltip": "Retry the last message",
      "suggestionCheckIns": "Show today's check-ins",
      "suggestionMaintenance": "Any maintenance issues?",
      "suggestionOccupancy": "What was our occupancy last month?"
    },
    "aiMessageParts": {
      "copied": "Copied to clipboard",
      "copyTooltip": "Copy message",
      "errorCopy": "Couldn't copy the message",
      "moreActions": "More actions",
      "regenerate": "Regenerate",
      "sourceFallbackTitle": "Reservation Reference"
    },
    "aiPromptComposer": {
      "placeholder": "Ask anything",
      "placeholderTranscribing": "Transcribing..."
    },
    "callEventBubble": {
      "callEnded": "Call ended",
      "callWithDuration": "Call · {duration}",
      "calling": "Calling…",
      "incomingCall": "Incoming call",
      "incomingCallRinging": "Incoming call…",
      "missedCall": "Missed call",
      "ongoingCall": "Ongoing call · {duration}",
      "outgoingCall": "Outgoing call",
      "outgoingMissedCall": "Outgoing missed call"
    },
    "callWaiting": {
      "accept": "Accept",
      "callEnded": "Call ended",
      "callEndedWith": "Call with {name} ended",
      "callOnHold": "Call on hold",
      "decline": "Decline",
      "endAndAccept": "End & Accept",
      "holdAndAccept": "Hold & Accept",
      "onCall": "On a call",
      "onCallWith": "On a call with {name}",
      "onHoldWith": "{name} on hold",
      "swap": "Swap"
    },
    "chatHeader": {
      "back": "Back",
      "badgeGuest": "Guest",
      "badgeInternal": "Internal",
      "badgeSupport": "Support",
      "call": "Call {name}",
      "linkReservation": "Link reservation",
      "openReservation": "Open reservation",
      "unknownName": "Unknown"
    },
    "chatInputBar": {
      "placeholder": "Type a message...",
      "recordVoice": "Record a voice message",
      "sendDocument": "Send a document",
      "sendPhotoOrVideo": "Send a photo or video",
      "transcribing": "Transcribing..."
    },
    "chatItem": {
      "chatWith": "Chat with {name}",
      "noMessages": "No messages yet",
      "unknownName": "Unknown"
    },
    "chatMessageBubble": {
      "copied": "Copied to clipboard",
      "copyMessage": "Copy message",
      "dismissReactionPicker": "Dismiss reaction picker",
      "errorCopy": "Couldn't copy the message",
      "messagePlaceholder": "Message",
      "senderAndTime": "{sender} · {time}"
    },
    "chatView": {
      "emptyDescription": "Send a message to begin your conversation",
      "emptyTitle": "Start a Conversation",
      "scrollToNewest": "Scroll to newest message"
    },
    "chatsTabBar": {
      "ai": "AI",
      "guests": "Guests",
      "openDialer": "Open dialer",
      "staff": "Staff",
      "unread": "{count, plural, one {{count} unread} other {{count} unread}}"
    },
    "chatsView": {
      "emptyDescription": "Pick a guest, staff, or AI chat from the list",
      "emptyTitle": "Select a conversation",
      "hideConversationList": "Hide conversation list",
      "showConversationList": "Show conversation list"
    },
    "deliveryErrorCopy": {
      "genericFailure": "Couldn't deliver this message.",
      "instagramGeneric": "Couldn't send this reply on Instagram.",
      "instagramLateReplyRefused": "Not sent: Instagram hasn't yet approved Vidimo to reply more than 24 hours after the guest's last message.",
      "instagramNoIdentity": "Not sent: this guest can't be reached on Instagram.",
      "instagramNotConnected": "Not sent: Instagram isn't connected for this property. Reconnect it in Settings > Messaging.",
      "instagramUndeliverable": "Instagram wouldn't deliver this message. The guest may have blocked the account or deleted the chat.",
      "instagramWindowClosed": "Not sent: Instagram's reply window has closed. The guest needs to message again.",
      "invalidNumber": "The guest's phone number looks invalid. Check the guest's contact details.",
      "optedOut": "The guest has opted out of messages from this number. Sending stays blocked unless they opt back in.",
      "phoneUnreachable": "The guest's phone is unreachable — it may be off or out of coverage. Try again later.",
      "whatsappWindowClosed": "WhatsApp's 24-hour reply window has closed. Re-engage the guest with an approved template message."
    },
    "dialerDrawer": {
      "call": "Call",
      "calling": "Calling…",
      "cancel": "Cancel",
      "description": "Dial a number or search for an existing guest.",
      "errorAlreadyInCall": "You're already in a call",
      "errorCallingUnsupported": "Calling is only available on the mobile app",
      "errorPermissionRequest": "Couldn't send the permission request. Try again.",
      "errorStartCall": "Couldn't start the call",
      "guest": "Guest",
      "noMatches": "No matches",
      "permissionRequestSent": "Permission request sent via WhatsApp",
      "phoneNumber": "Phone number",
      "phoneNumberPlaceholder": "Enter phone number",
      "refusal": {
        "invalid_phone_number": "This isn't a valid phone number. Enter it with its country code, such as +44.",
        "whatsapp_not_connected": "This property has no connected WhatsApp number. Connect one in Settings, then try again."
      },
      "requestCallPermission": "Request call permission (WhatsApp)",
      "search": "Search",
      "searchPlaceholder": "Search name or number",
      "sending": "Sending…",
      "staff": "Staff",
      "title": "Place a call"
    },
    "entityShareCard": {
      "guestFallbackName": "Guest",
      "kindBooking": "Booking",
      "kindGuest": "Guest",
      "kindTask": "Task",
      "noUpcomingStay": "No upcoming stay",
      "sharedBooking": "Shared a booking",
      "sharedGuest": "Shared a guest",
      "sharedTask": "Shared a task",
      "stayDates": "{checkIn} - {checkOut}",
      "unassigned": "Unassigned",
      "unscheduled": "Unscheduled"
    },
    "guestChatDetails": {
      "erasedStaffSender": "Former team member",
      "errorAccountLoading": "Still loading your account — try again in a moment",
      "errorNoMembership": "Couldn't resolve your membership for this property",
      "errorNoProperty": "Select a property first",
      "errorNotSent": "Couldn't send your message. Try again.",
      "errorNotStarted": "Couldn't start this chat. Try again.",
      "guestFallback": "Guest",
      "linkOnlyStaffDescription": "Guests can't open it, so there's nothing to send.",
      "linkOnlyStaffTitle": "That link only works in staff chats",
      "linkRemovedDescription": "It only works in staff chats, so the guest won't see it.",
      "linkRemovedTitle": "Record link removed"
    },
    "guestChatInputBar": {
      "waitingForGuest": "Waiting for the guest to message"
    },
    "guestChatListView": {
      "emptyDescription": "Waiting for new guest messages",
      "emptyTitle": "No guest chats found",
      "fallbackName": "Guest"
    },
    "guestChatMessageBubble": {
      "attachment": "Attachment",
      "copyErrorForSupport": "Copy error for support",
      "draftReply": "Draft reply",
      "drafting": "Drafting...",
      "errorCopied": "Error copied for support",
      "errorCopyFailed": "Couldn't copy the error",
      "retry": "Retry",
      "retrySendFailed": "Couldn't retry sending — please try again",
      "retryTranscriptionFailed": "Couldn't retry transcription — please try again",
      "showOriginal": "Show original",
      "showTranslation": "Show translation",
      "statusDelivered": "Delivered",
      "statusFailed": "Failed",
      "statusPending": "Pending",
      "statusRead": "Read",
      "statusSent": "Sent",
      "translate": "Translate",
      "translateMessage": "Translate message",
      "translating": "Translating..."
    },
    "guestChatView": {
      "draftFailed": "Couldn't draft a reply. Try again.",
      "placeholderCheckingAccess": "Checking your access...",
      "placeholderDiverted": "Reply by {transport} — {divertedFrom} can't send",
      "placeholderLoadingChannels": "Loading channels...",
      "placeholderNoChannel": "No channel here can send yet",
      "placeholderReply": "Reply to guest...",
      "placeholderUnreachable": "Guest is not reachable on any channel",
      "voiceNoteFailed": "Couldn't send the voice note"
    },
    "guestChats": {
      "linkFailed": "Couldn't link this conversation to the booking.",
      "refusal": {
        "chat_not_found": "This conversation no longer exists.",
        "no_room": "This booking has no room to add a guest to.",
        "party_full": "This booking already has everyone it says it is expecting. To add this guest, raise its Adults, Children or Infants first.",
        "reservation_not_active": "Guests can no longer be added to this booking.",
        "reservation_not_found": "This booking no longer exists."
      }
    },
    "guestDetails": {
      "age": "{age, plural, one {{age} years old} other {{age} years old}}",
      "call": "Call",
      "guestInformation": "Guest Information",
      "loadError": "Could not load this guest profile.",
      "merge": "Merge",
      "message": "Message",
      "notFoundDescription": "This guest may belong to a property that isn't currently selected. Switch property and try again.",
      "notFoundTitle": "Guest not found",
      "relatedBookings": "Related Bookings"
    },
    "guestDirectoryView": {
      "allStatuses": "All statuses",
      "allUnits": "All units",
      "arrivalDates": "Arrival dates",
      "callGuest": "Call {name}",
      "clear": "Clear",
      "emptyDescription": "Guests appear here once they book or check in.",
      "emptyTitle": "No guests yet",
      "filteredCount": "{count, plural, one {{filtered} of {count}} other {{filtered} of {count}}}",
      "guestCount": "{count, plural, one {{count} guest} other {{count} guests}}",
      "noMatchesDescription": "No guests match these filters.",
      "noMatchesTitle": "No matches",
      "openGuest": "Open {name}",
      "searchPlaceholder": "Search name, phone, or email…",
      "statusFilterLabel": "Filter by reservation status",
      "syncing": "Syncing your guests…",
      "title": "Guests",
      "unitFilterLabel": "Filter by unit"
    },
    "guestReplyDeniedBar": {
      "cannotReply": "Your role at this property can't reply to guests",
      "preparing": "This property is preparing, so its current system still replies to guests"
    },
    "guestTransports": {
      "emailNotConfigured": "The email channel isn't configured yet.",
      "inboundOnly": "{platform} messages arrive here, but replies can't be sent yet.",
      "instagramNotSetUp": "Instagram isn't set up yet.",
      "smsNotConnected": "No SMS number is connected to this property yet.",
      "smsUnavailable": "SMS isn't available yet.",
      "whatsAppNotConnected": "WhatsApp isn't connected to this property yet.",
      "whatsAppSettingUp": "WhatsApp is still setting up. This usually takes a few minutes."
    },
    "inCallOverlay": {
      "activeCall": "Active call",
      "expandActiveCall": "Expand active call",
      "hangUp": "Hang up",
      "mute": "Mute",
      "resume": "Resume",
      "speakerOff": "Speaker off",
      "speakerOn": "Speaker on",
      "unmute": "Unmute"
    },
    "incomingCallView": {
      "headerPhone": "Incoming · Phone",
      "headerWhatsApp": "Incoming · WhatsApp",
      "hintCheckingInToday": "Checking in today",
      "hintCheckingInTomorrow": "Checking in tomorrow",
      "hintCheckingOutToday": "Checking out today",
      "hintCheckingOutTomorrow": "Checking out tomorrow",
      "hintInDays": "{count, plural, one {In # days} other {In # days}}",
      "roomStatus": "Room {unit} · {status}",
      "roomStatusWithHint": "Room {unit} · {status} · {hint}",
      "unknownCaller": "Unknown caller"
    },
    "incomingStaffCallView": {
      "header": "Incoming · Internal",
      "internal": "Internal",
      "internalAtProperty": "Internal · {property}",
      "internalCall": "Internal call"
    },
    "instagramWindowNotice": {
      "closed": "Instagram's reply window has closed. The guest needs to message again before you can reply.",
      "closesOn": "Instagram closes this chat on {date}.",
      "neverMessaged": "Instagram only allows replies. The guest needs to message you first."
    },
    "linkReservationPicker": {
      "description": "Choose the booking this conversation is about. {name} will be added to its guest list.",
      "noReservations": "No open bookings to link",
      "noSearchMatches": "No bookings match your search",
      "searchPlaceholder": "Search by guest, reference or unit...",
      "title": "Link reservation",
      "unnamedBooker": "Unnamed guest"
    },
    "loadEarlierMessages": {
      "label": "Load earlier messages"
    },
    "media": {
      "tooLarge": "That file is too large. Keep it under {max}."
    },
    "mergeGuestPickerModal": {
      "descriptionNamed": "Merge this guest into another profile. Select the profile to merge into. {name}'s details will be added to their profile.",
      "descriptionUnnamed": "Merge this guest into another profile. Select the profile to merge into. This guest's details will be added to their profile.",
      "noOtherGuests": "No other guests to merge",
      "noSearchMatches": "No guests match your search",
      "searchPlaceholder": "Search by guest name...",
      "suggestedByAi": "Suggested by AI",
      "title": "Merge guests"
    },
    "messageAttachment": {
      "document": "Document",
      "photo": "Photo",
      "photoUnavailable": "Photo unavailable",
      "videoUnavailable": "Video unavailable"
    },
    "messageContextMenu": {
      "dismissMenu": "Dismiss menu",
      "moreActions": "More actions",
      "react": "React"
    },
    "messageReactionPicker": {
      "moreReactions": "More reactions",
      "reactWith": "React with {emoji}"
    },
    "microphone": {
      "permissionMessage": "To make and receive calls, Vidimo needs access to your microphone. Tap Settings and turn on Microphone.",
      "permissionTitle": "Microphone access needed",
      "settingsGuidance": "Open Settings > Apps > Vidimo and turn on Microphone."
    },
    "nativeListeners": {
      "errorCallFailed": "Call failed. Please try again."
    },
    "reactionPills": {
      "reaction": "{count, plural, one {{emoji} reaction, {count}} other {{emoji} reaction, {count}}}"
    },
    "recordingErrorBar": {
      "dismiss": "Dismiss",
      "error": "Error",
      "retry": "Retry"
    },
    "sendAttachment": {
      "errorConnection": "Check your connection and try again.",
      "errorNotSent": "Couldn't send the attachment",
      "refusal": {
        "outside_service_window": "WhatsApp only allows attachments within 24 hours of the guest's last message. Send it by email, or send a template to reopen the conversation.",
        "outside_service_window_voice": "WhatsApp only allows voice messages within 24 hours of the guest's last message. Send it by email instead.",
        "oversize": "This {kind, select, image {photo} video {video} voice {voice message} other {file}} is {size}. {transport, select, email {Email accepts {max}.} sms {MMS accepts {max}. Send it by email instead.} staff {This chat accepts {max}.} whatsapp {WhatsApp accepts {max}. Send it by email instead.} other {This chat accepts {max}. Send it by email instead.}}",
        "sms_no_media": "SMS can't carry attachments. Switch this conversation to WhatsApp or email.",
        "unsupported_channel": "This channel doesn't support attachments."
      },
      "rejectedTitle": "Can't send that here",
      "rejectedType": "{type} can't be sent in a chat.",
      "rejectedUnknownType": "That file type can't be sent in a chat."
    },
    "staffChatDetails": {
      "groupChatFallbackName": "Group chat",
      "internal": "Internal",
      "manageMembers": "Manage members in property settings",
      "memberCount": "{count, plural, one {{count} member} other {{count} members}}",
      "noMembers": "No members in this chat."
    },
    "staffChatDetailsPage": {
      "directMessageFallback": "Direct Message",
      "errorNoMembership": "Couldn't resolve your membership for this property",
      "errorNoSharedProperty": "You don't share a property with them",
      "errorNotSent": "Couldn't send your message. Try again.",
      "errorNotStarted": "Couldn't start this chat. Try again.",
      "errorSignedOut": "Sign in to send messages",
      "errorStillLoading": "Still loading — try again in a moment",
      "staffChatFallback": "Staff Chat"
    },
    "staffChatListView": {
      "emptyDescription": "Start a conversation with your staff",
      "emptyTitle": "No staff chats found"
    },
    "staffChatMessageBubble": {
      "attachmentPlaceholder": "Attachment",
      "deleteMessage": "Delete message",
      "deletedByOther": "This message was deleted",
      "deletedByYou": "You deleted this message",
      "retryTranscriptionFailed": "Couldn't retry transcription — please try again"
    },
    "staffChatView": {
      "cancel": "Cancel",
      "delete": "Delete",
      "deleteDialogDescription": "It will be removed for everyone in this chat. The conversation keeps its place in the thread and shows that a message was deleted.",
      "deleteDialogTitle": "Delete this message?",
      "deleteFailed": "Couldn't delete the message",
      "replyPlaceholder": "Reply to {name}…",
      "sendPlaceholder": "Send a message…",
      "voiceNoteSendFailed": "Couldn't send the voice note"
    },
    "staffDetails": {
      "activeTasks": "{count, plural, one {Active Tasks ({count})} other {Active Tasks ({count})}}",
      "call": "Call",
      "completedOn": "Completed {date}",
      "message": "Message",
      "noTasksAssigned": "No tasks assigned",
      "recentlyCompleted": "Recently Completed",
      "staffInformation": "Staff Information"
    },
    "suggestionActions": {
      "arrivalUpdated": "Expected arrival updated to {time}",
      "checkOutUpdated": "Check-out updated to {time}",
      "guestAdded": "{guestName} added to the booking",
      "guestAlreadyOnBooking": "{guestName} was already on that booking; their conversation is now linked to it",
      "missingLink": "This suggestion is missing the conversation or booking to link.",
      "missingTimeChange": "This suggestion is missing what it needs to apply.",
      "noStayDate": "That booking has no date to place the time on.",
      "noTask": "This suggestion has no task to create.",
      "rateChangeMissing": "This notice no longer names the change it was about.",
      "taskCreated": "Task created: {title}"
    },
    "suggestionCard": {
      "accept": "Accept",
      "dismiss": "Dismiss",
      "dismissLabel": "Dismiss: {title}"
    },
    "supportChatDetails": {
      "errorNotSent": "Couldn't send your message. Try again."
    },
    "supportChatView": {
      "addPhoto": "Add a photo",
      "dictate": "Dictate a message",
      "dictationFailed": "Couldn't hear that. Try again.",
      "dictationNeedsSubscription": "Dictation needs an active subscription. You can still type.",
      "emptyDescription": "Tell us what you need, in your own language, by typing, speaking or sending a photo. We see which property and screen you wrote from, so you don't have to explain it.",
      "emptyTitle": "Write to the Vidimo team",
      "photo": "Photo",
      "photoUnavailable": "Photo unavailable",
      "placeholder": "Write to the Vidimo team…",
      "removePhoto": "Remove photo",
      "send": "Send",
      "showOriginal": "Show original",
      "showTranslation": "Show translation",
      "stopDictating": "Stop dictating",
      "supportSession": "In a support session, reply from the CRM.",
      "teamNameWithProperty": "Vidimo team · {propertyName}",
      "transcribing": "Transcribing…"
    },
    "supportReplyBanner": {
      "open": "Open"
    },
    "transcribe": {
      "failed": "Couldn't transcribe the recording. Please try again."
    },
    "transferPicker": {
      "empty": "No other staff members in this property to transfer to.",
      "title": "Transfer call to"
    },
    "useGuestCall": {
      "errorAlreadyInCall": "You're already in a call",
      "errorNotStarted": "Couldn't start the call"
    },
    "useOpenChat": {
      "errorNoProperty": "Select a property first",
      "errorNoSharedProperty": "You don't share a property with them",
      "errorNotSwitched": "Couldn't switch to that property",
      "errorSelf": "You can't message yourself",
      "errorStillLoading": "Still loading — try again in a moment",
      "switched": "Switched property",
      "switchedTo": "Switched to {name}"
    },
    "useShareAudienceGap": {
      "one": "{name} can't open this",
      "people": "{count, plural, one {{count} people can't open this} other {{count} people can't open this}}",
      "two": "{first} and {second} can't open this"
    },
    "useVoiceRecording": {
      "micBlockedInBrowser": "Microphone access is blocked. Allow it in your browser settings and try again.",
      "micPermissionMessage": "To record a voice message, Vidimo needs access to your microphone. Tap Settings and turn on Microphone.",
      "micUnavailable": "Could not access microphone. Please check permissions.",
      "transcriptionFailed": "Transcription failed",
      "transcriptionTimedOut": "Transcription timed out. Check your connection and try again."
    },
    "voiceContext": {
      "errorNoActiveCall": "No active call to transfer",
      "errorNotHungUp": "Couldn't hang up the call. Try again.",
      "errorNotResumed": "Couldn't resume the call. Try again.",
      "errorNotSwitched": "Couldn't switch calls. Try again.",
      "errorNotTransferred": "Couldn't transfer the call. Try again.",
      "errorUnsupported": "Calling is only available on mobile"
    },
    "voiceNoteAttachment": {
      "noSpeech": "No speech detected",
      "pause": "Pause voice note",
      "play": "Play voice note",
      "seek": "Seek voice note",
      "transcribing": "Transcribing…",
      "transcript": "Transcript",
      "transcriptUnavailable": "Transcript unavailable",
      "tryAgain": "Try again"
    }
  },

  "connect": {
    "connectScreen": {
      "contactSupport": "Contact support",
      "returnToVidimo": "Return to Vidimo"
    },
    "instagramConnectResult": {
      "cancelled": {
        "detail": "The connection was cancelled. You can start again from Vidimo whenever you like.",
        "title": "Instagram not connected"
      },
      "connected": {
        "detail": "Your feed and direct messages are ready. Head back to Vidimo to pick up from here.",
        "title": "Instagram connected"
      },
      "connectedElsewhere": {
        "detail": "This Instagram account is already connected to another property. Disconnect it there first, or connect a different account.",
        "title": "Already connected elsewhere"
      },
      "expired": {
        "detail": "This connect link is no longer valid. Start again from the Vidimo app.",
        "title": "Link expired"
      },
      "failed": {
        "detail": "Something went wrong completing the connection. Try again from the Vidimo app.",
        "title": "Instagram not connected"
      },
      "invalidLink": {
        "detail": "This connect link is missing information. Start again from the Vidimo app.",
        "title": "Invalid link"
      },
      "subscriptionRequired": {
        "detail": "An active subscription is required to connect a channel.",
        "title": "Subscription required"
      }
    },
    "whatsappConnect": {
      "expiredBody": "For security these connect links are only valid for a short time, and this one has expired. Go back to Vidimo and start again from the WhatsApp card in Messaging. Nothing on your property has changed.",
      "expiredTitle": "Link expired",
      "failedBody": "We couldn't load the WhatsApp setup. Try again, or start again from the Vidimo app.",
      "failedTitle": "Something went wrong",
      "loading": "Loading…",
      "noNumberBody": "Go back to Vidimo, enter your WhatsApp number on the WhatsApp card in Messaging, then connect again. If the card doesn't ask for it, restart Vidimo first to update it. Nothing on your property has changed.",
      "noNumberTitle": "Enter the number in Vidimo",
      "openFromApp": "This page can only be opened from the Vidimo app.",
      "title": "Connect WhatsApp",
      "tryAgain": "Try again",
      "unavailableBody": "WhatsApp connection is not set up on this environment.",
      "unavailableTitle": "Not available here"
    },
    "whatsappEmbeddedSignup": {
      "buttonContinue": "Continue with Facebook",
      "buttonFinishing": "Finishing setup…",
      "buttonInPopup": "Continue in the popup…",
      "buttonLoading": "Loading…",
      "buttonTryAgain": "Try again",
      "cancelled": "Signup was cancelled. You can start again whenever you like.",
      "closeAnytime": "You can close this window anytime. Nothing on your property changes until WhatsApp setup is finished.",
      "errorConnectFailed": "We couldn't finish connecting WhatsApp. Nothing on your property has changed. Try again.",
      "errorNoAccount": "Couldn't read your WhatsApp account from Meta. Please try again.",
      "errorUnconfirmed": "We couldn't confirm WhatsApp is connected. Check Settings, then Messaging, in Vidimo before trying again.",
      "expiredBody": "This connect link ran out before the signup finished. Go back to Vidimo and start again from the WhatsApp card in Messaging. Nothing on your property has changed.",
      "introConnect": "You'll set up WhatsApp Business messaging on <number>{phone}</number> for <name>{property}</name>. Meta's signup takes a few minutes and runs in a popup.",
      "introReconnect": "Your WhatsApp connection on <number>{phone}</number> needs to be confirmed again for <name>{property}</name>. Meta's signup takes a few minutes and runs in a popup.",
      "nextStepCheck": "WhatsApp checks your number. This usually takes a few minutes.",
      "nextStepCode": "If WhatsApp texts or calls a code to your number, enter it on the WhatsApp card in Messaging.",
      "nextStepsHeading": "What happens next",
      "pendingBody": "WhatsApp is setting up the number for {property}.",
      "pendingTitle": "All set, we'll take it from here",
      "reload": "Reload",
      "sdkUnavailableBody": "If you use a content blocker, turn it off for this page, then reload it. Nothing on your property has changed.",
      "sdkUnavailableTitle": "Meta's signup didn't load",
      "stepConfirmCode": "Confirm the verification code Meta sends to that number. If it arrives after you close this page, enter it in the Vidimo app.",
      "stepPickAccount": "Pick or create your WhatsApp Business account, and add this same number. You keep it, with no porting involved.",
      "stepSignIn": "Sign in with the Facebook account that manages (or will manage) your business.",
      "successBody": "Your WhatsApp Business number is now linked to {property}.",
      "successTitle": "WhatsApp connected",
      "thisProperty": "this property",
      "titleReconnect": "Reconnect WhatsApp"
    }
  },

  "labels": {
    "balanceDue": "{amount} due",
    "blockReason": {
      "maintenance": "Maintenance",
      "manual": "Closed manually",
      "owner": "Owner stay"
    },
    "blockReasonUnknown": "Closed",
    "boardBasis": {
      "all_inclusive": "All inclusive",
      "bed_and_breakfast": "Bed & breakfast",
      "full_board": "Full board",
      "half_board": "Half board",
      "room_only": "Room only"
    },
    "callStatus": {
      "connected": "Connected",
      "connecting": "Connecting…",
      "onHold": "On hold",
      "reconnecting": "Reconnecting…",
      "ringing": "Ringing…"
    },
    "cancellationPolicyDescription": {
      "flexible": "Free cancellation until 1 day before check-in.",
      "moderate": "Free cancellation until 5 days before check-in.",
      "non_refundable": "This booking is non-refundable.",
      "strict": "Free cancellation until 14 days before check-in."
    },
    "cleaningKind": {
      "post-checkout": "Post-checkout",
      "pre-checkin-refresh": "Pre-arrival refresh",
      "turnover": "Turnover"
    },
    "drawerTitle": {
      "breakfast-service": "Breakfast",
      "guest": "Guest",
      "reservation-unit": "Reservation",
      "staff": "Team member",
      "staff-chat": "Chat members",
      "task": "Task"
    },
    "guestIdentity": {
      "detail": {
        "authorityRejected": "The authority rejected the details",
        "filedOtherYourself": "You filed the other report yourself",
        "noAutomaticFiling": "Vidimo isn't filing this one",
        "otherFacility": "Filed under another RNO number",
        "reconnectCredentials": "Filing credentials need reconnecting"
      },
      "status": {
        "actionNeeded": "Action needed",
        "fileManually": "File manually",
        "filedByYou": "Filed by you",
        "filing": "Filing",
        "idOnFile": "ID on file",
        "noIdOnFile": "No ID on file",
        "notCheckedIn": "Not checked in",
        "notFiledByVidimo": "Not filed by Vidimo",
        "notFiledYet": "Not filed yet",
        "registered": "Registered",
        "rejected": "Rejected",
        "reportCancelled": "Report cancelled",
        "submitted": "Submitted"
      }
    },
    "mealInclusion": {
      "complimentary": "Complimentary",
      "included": "Included in the rate"
    },
    "mealPlace": {
      "breakfast_area": "Breakfast area",
      "in_room": "In the room",
      "takeaway_box": "Takeaway box"
    },
    "regimeException": {
      "alloggiati-web": "Vidimo collects each guest's Alloggiati Web details at check-in and can't compile or send your ISTAT figures yet; automatic Alloggiati Web filing is still in preparation.",
      "declaration-meuble-de-tourisme": "Vidimo doesn't file your meublé de tourisme declaration for you.",
      "eturizem": "Vidimo prepares your eTurizem reports. Automatic submission to AJPES is still in preparation.",
      "evisitor": "Vidimo can't register your guests in eVisitor for you yet.",
      "imposta-di-soggiorno": "Vidimo can't work out your Comune's tourist tax yet.",
      "istat-ross-1000": "Vidimo can't compile or send your ISTAT figures to your Region yet.",
      "ses-hospedajes": "Vidimo can't file your SES.Hospedajes reports for you yet.",
      "siba": "Vidimo can't send your SIBA forms for you yet."
    },
    "registrationCredentialField": {
      "alloggiati_web": {
        "idAppartamento": "Apartment ID",
        "password": "Password",
        "username": "Username",
        "wskey": "Web-service key (WS Key)"
      },
      "eturizem": {
        "certificate": "Digital certificate (.p12 / KDP)",
        "certificatePassword": "Certificate passphrase",
        "password": "AJPES portal password",
        "rno": "RNO number",
        "username": "AJPES portal username"
      },
      "evisitor": {
        "password": "Password",
        "username": "Username"
      },
      "istat": {
        "password": "Password",
        "structureCode": "Structure code",
        "username": "Username"
      },
      "ses_hospedajes": {
        "clientCertificate": "SSL client certificate",
        "clientCertificatePassword": "Certificate passphrase",
        "password": "Password",
        "username": "Web-service username"
      },
      "siba": {
        "accessKey": "Access key (Chave de Acesso)",
        "establishment": "Establishment number",
        "nipc": "Tax number (NIPC)"
      }
    },
    "registrationCredentialHelp": {
      "alloggiati_web": {
        "idAppartamento": "Only if you manage multiple units under one account.",
        "username": "Issued by your local Questura.",
        "wskey": "Generated inside Alloggiati Web. Every password change needs a new one, and only one can be generated per day."
      },
      "eturizem": {
        "certificate": "Qualified Slovenian digital certificate issued to your business.",
        "certificatePassword": "Leave blank if the certificate has no passphrase.",
        "rno": "The identification number AJPES gave this accommodation in the register of accommodation establishments (RNO). Digits only.",
        "username": "The username (uporabniško ime) you sign in to the AJPES portal with, not your email address. AJPES refuses an email here. It is shown in the top-right corner of the portal once you are signed in."
      },
      "evisitor": {
        "username": "Issued by your local tourist board."
      },
      "istat": {
        "structureCode": "The code your region assigned to this property (for example B01205). It identifies the property on every report.",
        "username": "Issued by your region's tourism office, not by ISTAT."
      },
      "ses_hospedajes": {
        "clientCertificate": "Only if your Ministry setup requires a client certificate.",
        "clientCertificatePassword": "Leave blank if the certificate has no passphrase.",
        "username": "The web-service username from the Sede Electronica. It ends in WS."
      },
      "siba": {
        "accessKey": "Sent to you by letter or email.",
        "establishment": "Assigned by the UCFE when you registered the unit.",
        "nipc": "Tax number of the accommodation unit."
      }
    },
    "registrationCredentialPlaceholder": {
      "ses_hospedajes": {
        "username": "e.g. 1234567WS"
      }
    },
    "registrationField": {
      "arrivalDate": "Arrival date",
      "birthCountry": "Country of birth",
      "birthPlace": "Place of birth",
      "dateOfBirth": "Date of birth",
      "departureDate": "Departure date",
      "documentNumber": "Document number",
      "documentType": "Document type",
      "expiryDate": "Document expiry",
      "firstName": "First name",
      "issuingCountry": "Issuing country",
      "lastName": "Last name",
      "nationality": "Nationality",
      "personalNumber": "Personal/ID number",
      "residenceAddress": "Residence address",
      "residenceCountry": "Country of residence",
      "sex": "Sex",
      "stayPurpose": "Purpose of stay"
    },
    "registrationOption": {
      "documentType": {
        "id_card": "ID Card",
        "other": "Other",
        "passport": "Passport"
      },
      "sex": {
        "F": "Female",
        "M": "Male"
      },
      "stayPurpose": {
        "business": "Business",
        "education": "Education",
        "family": "Family",
        "medical": "Medical",
        "other": "Other",
        "tourism": "Tourism"
      }
    },
    "registrationSystem": {
      "alloggiati_web": {
        "authority": "Polizia di Stato (local Questura)",
        "enrollmentSteps": {
          "enterCredentials": "Enter the username, password and WS Key below.",
          "generateWsKey": "Sign in and generate a web-service key (WS Key). Every password change needs a new one, and only one can be generated per day.",
          "requestAccount": "Request an Alloggiati Web account from your local Questura. You receive a username and password."
        }
      },
      "eturizem": {
        "authority": "AJPES",
        "enrollmentSteps": {
          "checkAccess": "Check that this account has access to eTurizem. AJPES grants it separately, so a portal account without it cannot file.",
          "enterCredentials": "Enter that username and its password below, upload the certificate, and add the RNO number. Vidimo numbers the registrations it reports to eTurizem from {guestbookBase, number} (zaporedna številka prijave gosta), so the program you use now can finish the stays it already reported without one overwriting the other. Vidimo reports guests arriving from the day you connect: from then on, stop that program reporting new arrivals, or AJPES records them twice.",
          "findUsername": "Find your AJPES portal username (uporabniško ime). It is the name you chose when you created the account, not your email address: AJPES refuses an email. Sign in to the AJPES portal and it is shown in the top-right corner.",
          "obtainCertificate": "Obtain a qualified Slovenian digital certificate (.p12 / KDP) issued to your business.",
          "registerAccommodation": "Register your accommodation in the Slovenian register of accommodation establishments (Register nastanitvenih obratov, RNO) at AJPES. The register gives it an identification number: that is your RNO number."
        }
      },
      "evisitor": {
        "authority": "Croatian National Tourist Board (local tourist board)",
        "enrollmentSteps": {
          "enterCredentials": "Enter them below.",
          "receiveCredentials": "Your local tourist board issues an eVisitor username and password."
        }
      },
      "istat": {
        "authority": "Regional tourism-statistics office (ISTAT network)",
        "enrollmentSteps": {
          "enterCredentials": "Enter the structure code, username and password.",
          "requestAccess": "Ask your region's tourism office (Ufficio Turismo) for web-service access. It issues the username and password, and tells you your structure code."
        }
      },
      "ses_hospedajes": {
        "authority": "Ministerio del Interior (Sede Electronica)",
        "enrollmentSteps": {
          "enroll": "Enroll your accommodation in the Sede Electronica and opt into web-service sending.",
          "obtainCertificate": "If your setup requires it, obtain the SSL client certificate from the Ministry.",
          "receiveCredentials": "You receive a web-service username (it ends in WS) and a password."
        }
      },
      "siba": {
        "authority": "UCFE (Sistema de Segurança Interna)",
        "enrollmentSteps": {
          "enterCredentials": "Enter your tax number, establishment number and access key below.",
          "receiveAccessKey": "The UCFE issues the access key (Chave de Acesso) for that establishment; request a replacement at siba@ssi.gov.pt.",
          "register": "Register your accommodation unit with the UCFE as a SIBA user to obtain an establishment number."
        }
      }
    },
    "reservationSource": {
      "direct": "Direct",
      "other": "Other"
    },
    "reservationStatus": {
      "cancelled": "Cancelled",
      "checked_in": "Checked In",
      "checked_out": "Checked Out",
      "confirmed": "Confirmed",
      "declined": "Declined",
      "no_show": "No Show",
      "requested": "Requested"
    },
    "role": {
      "manager": "Manager",
      "operator": "Operator",
      "owner": "Owner",
      "receptionist": "Receptionist"
    },
    "roleDescription": {
      "manager": "Runs the day-to-day. Can manage staff except Owners.",
      "operator": "Field staff: sees own tasks and linked reservations only.",
      "owner": "Full control: billing, settings, deletion.",
      "receptionist": "Handles guests, bookings and tasks. No admin powers."
    },
    "roomAmenity": {
      "10": "Bathrobe",
      "105": "Stove",
      "107": "Telephone",
      "11": "Free toiletries",
      "13": "Bathtub",
      "142": "Shower",
      "144": "Soundproofing",
      "146": "Tables and chairs",
      "15": "Bath or shower",
      "162": "Wardrobe/closet",
      "166": "Climate control",
      "167": "Toaster",
      "18": "Cable TV",
      "19": "Coffee/tea maker",
      "193": "Shared bathroom",
      "2": "Air conditioning",
      "210": "Satellite TV",
      "223": "Mountain view",
      "224": "Sea view",
      "228": "Slippers",
      "245": "Private pool",
      "246": "Flat-screen TV",
      "251": "TV",
      "259": "Movies",
      "28": "Desk",
      "3": "Alarm clock",
      "32": "Dishwasher",
      "41": "Fireplace",
      "5": "Radio",
      "50": "Hairdryer",
      "5017": "Balcony",
      "55": "Ironing facilities",
      "59": "Kitchen",
      "61": "Kitchenette",
      "68": "Microwave",
      "69": "Minibar",
      "7": "Terrace",
      "77": "Oven",
      "85": "Private bathroom",
      "88": "Refrigerator",
      "92": "Safe"
    },
    "supportTeamName": "Vidimo team",
    "taskAssignmentPreset": {
      "first_available": "First available",
      "specific_staff": "A specific person",
      "unassigned": "Leave unassigned"
    },
    "taskFunction": {
      "check_in": "Check-in",
      "check_out": "Check-out",
      "cleaning": "Cleaning",
      "concierge": "Concierge",
      "maintenance": "Maintenance"
    },
    "taskRuleTrigger": {
      "any": "Any cleaning"
    },
    "taskStatus": {
      "cancelled": "Cancelled",
      "completed": "Completed",
      "in_progress": "In Progress",
      "missed": "Missed",
      "paused": "Paused",
      "pending": "Pending"
    },
    "transport": {
      "email": "Email",
      "phone": "Phone",
      "sms": "SMS"
    },
    "unitReadiness": {
      "clean": "Clean",
      "dirty": "Dirty",
      "inspected": "Inspected",
      "out_of_order": "Out of order"
    },
    "unitType": {
      "apartment": "Apartment",
      "double": "Double",
      "family": "Family",
      "quadruple": "Quadruple",
      "single": "Single",
      "studio": "Studio",
      "suite": "Suite",
      "triple": "Triple",
      "twin": "Twin",
      "villa": "Villa"
    }
  },

  "meals": {
    "breakfastService": {
      "roomNotAssigned": "Room not assigned"
    },
    "breakfastServiceBody": {
      "breakfastArea": "Breakfast area",
      "cancel": "Cancel",
      "complimentaryTag": "complimentary",
      "coverCount": "{count, plural, one {# cover} other {# covers}}",
      "done": "Done",
      "emptyBody": "Nobody staying tonight is due breakfast on {date}.",
      "emptyTitle": "No breakfast this morning",
      "errorRoomNotUpdated": "Could not update that room. Try again.",
      "errorRoomsNotMoved": "Could not move those rooms. Try again.",
      "groupCount": "{count, plural, one {# room} other {# rooms}} · {covers}",
      "loading": "Loading breakfast",
      "movedTo": "{count, plural, one {# room} other {# rooms}} · {place, select, breakfast_area {breakfast area} in_room {in the room} takeaway_box {takeaway box} other {{place}}}",
      "roomsOnDate": "{count, plural, one {# room} other {# rooms}} · {date}",
      "rowLabel": "{room}, {covers}",
      "rowLabelServed": "{room}, {covers}, served",
      "select": "Select",
      "selectedCount": "{count, plural, one {# selected} other {# selected}}",
      "serveInRoom": "Serve in room",
      "served": "Served"
    },
    "breakfastSummaryRow": {
      "ariaLabel": "Breakfast, {covers, plural, one {# cover} other {# covers}} across {rooms, plural, one {# room} other {# rooms}}",
      "inRoomCount": "{count, plural, one {# in the room} other {# in the room}}",
      "servedCount": "{count, plural, one {# served} other {# served}}",
      "title": "Breakfast · {count, plural, one {# room} other {# rooms}}"
    },
    "reservationBreakfastCard": {
      "chargeForMorning": "Charge for this morning",
      "coversAt": "{count, plural, one {# cover} other {# covers}} · {place, select, breakfast_area {breakfast area} in_room {in the room} takeaway_box {takeaway box} other {{place}}}",
      "errorMorningNotUpdated": "Could not update that morning. Try again.",
      "givenBy": "Given by {name}",
      "makeComplimentary": "Make complimentary",
      "makeComplimentaryHint": "Make complimentary — it comes off the bill",
      "markNotTaken": "Mark not taken",
      "markServed": "Mark served",
      "morningCount": "{count, plural, one {# morning} other {# mornings}}",
      "notCharged": "Not charged",
      "statusExpected": "Expected",
      "statusNotTaken": "Not taken",
      "statusServed": "Served",
      "title": "Breakfast",
      "unconfirmedCount": "{count, plural, one {# morning} other {# mornings}} unconfirmed"
    }
  },

  "notifications": {
    "activityItem": {
      "acceptedBy": "Accepted by {name}",
      "acceptedByStaff": "Accepted by staff",
      "dismissed": "Dismissed"
    },
    "attention": {
      "activityFailed": "Retrying automatically",
      "activityPending": "Queued to file",
      "activitySubmitting": "Filing now",
      "severityAtRisk": "Deadline approaching",
      "severityNeedsAction": "Action needed"
    },
    "filingAttentionSection": {
      "activityNotCheckedIn": "Not checked in, so not filed yet",
      "activityNotConfirmed": "Registration not confirmed yet",
      "activitySubmitted": "Filed, awaiting the authority's confirmation",
      "checkIn": "Check-in",
      "checkOut": "Check-out",
      "deadlinePassed": "Deadline passed",
      "detailNoDeadline": "{activity}, and the legal filing deadline is approaching.",
      "detailWithDeadline": "{activity} · {relative}",
      "directionAtProperty": "{direction} · {property}",
      "title": "Guest registration"
    },
    "notificationMenu": {
      "activity": "Activity",
      "close": "Close notifications",
      "emptyDescription": "Suggested actions and activity will appear here",
      "emptySearchDescription": "Try a different search term",
      "errorApplyFailed": "Couldn't apply this suggestion. It may be out of date.",
      "errorDismissFailed": "Couldn't dismiss this suggestion. Try again.",
      "errorMissingMergeProfiles": "This suggestion is missing the profiles to merge.",
      "errorNotCleared": "This card couldn't be cleared. Try again.",
      "errorNotClearedAfter": "{message}, but this card couldn't be cleared. Try again.",
      "noActivity": "No activity yet",
      "noPendingSuggestions": "No pending suggestions",
      "noResults": "No results",
      "searchPlaceholder": "Search suggestions and activity...",
      "suggestedActions": "Suggested Actions",
      "title": "Notifications"
    },
    "notificationPrimer": {
      "decline": "Not now",
      "description": "Turn on notifications and Vidimo will tell you about new guest and team messages, new bookings, arrivals and cancellations, and registration deadlines. Without them you'll only find out next time you open the app.",
      "enable": "Turn on notifications",
      "title": "Know the moment a guest writes"
    },
    "pushRegistration": {
      "androidChannelName": "Notifications"
    },
    "relativeDeadline": {
      "dueInDays": "{count, plural, one {due in {count}d} other {due in {count}d}}",
      "dueInHours": "{count, plural, one {due in {count}h} other {due in {count}h}}",
      "dueInMinutes": "{count, plural, one {due in {count}m} other {due in {count}m}}",
      "overdueByDays": "{count, plural, one {overdue by {count}d} other {overdue by {count}d}}",
      "overdueByHours": "{count, plural, one {overdue by {count}h} other {overdue by {count}h}}",
      "overdueByMinutes": "{count, plural, one {overdue by {count}m} other {overdue by {count}m}}"
    },
    "roomAttentionSection": {
      "assignRoom": "Assign a room",
      "noRoom": "No room yet",
      "title": "Rooms not ready"
    },
    "statisticsAttentionSection": {
      "activityNotConfirmed": "Not confirmed yet",
      "activitySubmitted": "Sent, awaiting the office's confirmation",
      "title": "Statistics reports"
    },
    "taxReturnAttentionSection": {
      "detail": "{amount} to pay by {date}",
      "dueSoon": "Due soon",
      "overdue": "Overdue",
      "title": "Tourist tax",
      "uncomputed": "{count, plural, one {# stay} other {# stays}} not worked out"
    },
    "timeOffProposalCard": {
      "confirm": "Confirm",
      "dismiss": "Dismiss",
      "errorMarkAway": "Couldn't mark them away. Try again.",
      "markedAway": "{who} marked away",
      "markedAwayReleased": "{who} marked away · {count, plural, one {# task} other {# tasks}} unassigned",
      "markedAwayReleasedDescription": "Re-assign them from the Unassigned column in Tasks.",
      "review": "Review",
      "staffMemberFallback": "Staff member",
      "viewSourceMessage": "View source message"
    }
  },

  "rates": {
    "controls": {
      "fewerLabel": "{label}, fewer",
      "moreLabel": "{label}, more"
    },
    "copy": {
      "board": {
        "noPrice": "No price",
        "notKept": "Nights this far ahead are not kept on this phone.",
        "pastMonth": "Nights this far back are not kept on this phone.",
        "tapHint": "Tap a night to change it, or a date to change every unit type.",
        "tapHintProperty": "Tap a night to change it, or a date to change every unit type of {propertyName}."
      },
      "changeNights": {
        "bookedWhenClosing": "{count, plural, one {{count} of these nights already has bookings. Closing stops new bookings only.} other {{count} of these nights already have bookings. Closing stops new bookings only.}}",
        "cancel": "Cancel",
        "chooseUnitType": "Choose at least one unit type.",
        "close": "Close",
        "fields": {
          "checkIn": "Check-in",
          "checkOut": "Check-out",
          "maximumStay": "Maximum stay",
          "minimumStay": "Minimum stay",
          "price": "Price",
          "sale": "Sale"
        },
        "firstNight": "First night",
        "firstThenLast": "Tap the first night, then the last",
        "lastNight": "Last night",
        "leaveAsIs": "Leave as is",
        "minFromSeason": "From season",
        "nothingToSend": "Choose something to change.",
        "priceFor": "Price to set for {unitTypeName}",
        "priceToSet": "Price to set",
        "priceUseSeasonOrBase": "Use season or base",
        "saveLabel": "Save",
        "setAPrice": "Set a price instead",
        "tapForSpan": "Tap a second night for a span.",
        "tapToWiden": "Tap a second night for a span, or another row to add it.",
        "title": "Change nights",
        "toWord": "to",
        "useSeasonOrBaseInstead": "Use the season or base price instead",
        "was": "Was {reads}."
      },
      "changes": {
        "sendAgain": "Send again",
        "showTheseNights": "Show these nights",
        "status": "Status",
        "taskId": "Channel reference",
        "title": "Rate changes",
        "undo": "Undo this change",
        "whatChanged": "What changed",
        "whatWasSent": "What was sent",
        "who": {
          "automatic": "Automatic",
          "automaticAt": "Automatic, {time}",
          "bySupport": "Vidimo support for {actor}",
          "inTheApp": "{name}, {time}, in the app",
          "onBehalf": "{agent} (Vidimo support) for {actor}",
          "unknown": "Unknown"
        }
      },
      "delivery": {
        "awaitingFullSync": "Sending with the next full sync",
        "notConnected": "No booking site is connected, so it stayed in Vidimo",
        "notMapped": "Not sent: this unit type is not linked to your channels",
        "notSent": "Not sent to your channels",
        "passedUnanswered": "Your channels did not confirm this change before its nights passed",
        "sending": "Sending to your channels",
        "sent": "Sent to your channels",
        "sentAt": "Sent to your channels at {time}",
        "unmapped": "{count, plural, one {{unitTypes} is not linked to your channels, so it was not sent.} other {{unitTypes} are not linked to your channels, so they were not sent.}}"
      },
      "discard": {
        "body": "You chose nights or typed a value. Discard this change?",
        "discard": "Discard",
        "forTapOn": "Start a change on {propertyName}? What you typed here will be discarded.",
        "keep": "Keep editing"
      },
      "editor": {
        "closedOn": "{of, plural, one {{on} of {of} nights closed} other {{on} of {of} nights closed}}",
        "detailsKept": "Details of a change are kept for 90 days.",
        "lastChanged": "Last changed by {who}, {when}.",
        "notAllowedOn": "{of, plural, one {Not allowed on {on} of {of} nights} other {Not allowed on {on} of {of} nights}}",
        "varies": "Varies"
      },
      "errors": {
        "belowLowest": "The lowest price for {unitTypeName} is {price}.",
        "conflict": "These nights changed on another device since you last saw them. Look again, then send once more.",
        "lowestNotAbove0": "Enter a lowest price above 0.",
        "lowestOverBase": "The lowest price cannot be above the base rate.",
        "offline": "You are offline, so this was not saved. Save again when you are back.",
        "priceAbove0": "Enter a price above 0.",
        "priceToType": "Type the price to set.",
        "priceUnreadable": "Type a price like {example, number}.",
        "pricedUnder": "{which, select, nights {{nights, plural, one {{nights} night of {unitTypeName} is priced under {amount}. Raise it first, then set the lowest price.} other {{nights} nights of {unitTypeName} are priced under {amount}. Raise them first, then set the lowest price.}}} seasons {{seasons, plural, one {{seasons} season of {unitTypeName} is priced under {amount}. Raise it first, then set the lowest price.} other {{seasons} seasons of {unitTypeName} are priced under {amount}. Raise them first, then set the lowest price.}}} other {{nights, plural, one {{nights} night} other {{nights} nights}} and {seasons, plural, one {{seasons} season} other {{seasons} seasons}} of {unitTypeName} are priced under {amount}. Raise them first, then set the lowest price.}}",
        "staysContradict": "Minimum stay is longer than maximum stay, so no stay can start on this night."
      },
      "heldBack": {
        "basePrice": "The base price is already {price}, so nothing changes for {unitTypeName}.",
        "seasonMinimum": "The season minimum is already {nights}, so nothing changes.",
        "seasonPrice": "Season {seasonName} already gives {price}, so nothing changes for {unitTypeName}.",
        "seasonPriceUnnamed": "The season price is already {price}, so nothing changes for {unitTypeName}."
      },
      "hold": {
        "sendNow": "Send now",
        "waiting": "{changes, plural, one {{changes} change goes} other {{changes} changes go}} to your channels in {seconds, plural, one {{seconds} s} other {{seconds} s}}"
      },
      "night": {
        "allowed": "Allowed",
        "checkIn": "Check-in",
        "checkOut": "Check-out",
        "closed": "Closed",
        "fallBackToBase": "Use base price ({price})",
        "fallBackToSeason": "Use season {name} ({price})",
        "maximumStay": "Maximum stay",
        "minFromSeason": "{count, plural, one {{count} from season} other {{count} from season}}",
        "minimumStay": "Minimum stay",
        "noLimit": "No limit",
        "noMinimum": "No minimum",
        "notAllowed": "Not allowed",
        "notForSale": "No price, so not for sale",
        "open": "Open",
        "price": "Price",
        "priceFromBase": "Base price",
        "priceFromBaseAt": "Base price ({price})",
        "priceFromSeason": "From season {name}",
        "priceFromSeasonAt": "From season {name} ({price})",
        "priceRange": "{low}–{high}",
        "priceSetForNight": "Set for this night",
        "priceSetForNights": "Set for these nights",
        "sale": "Sale",
        "seeTheChange": "See the change.",
        "unitsFree": "{total, plural, one {{free} of {total} units free} other {{free} of {total} units free}}"
      },
      "nights": "{count, plural, one {{count} night} other {{count} nights}}",
      "planned": {
        "checkInAllowed": "{position, select, first {Check-in allowed} other {check-in allowed}}",
        "checkInNotAllowed": "{position, select, first {Check-in not allowed} other {check-in not allowed}}",
        "checkOutAllowed": "{position, select, first {Check-out allowed} other {check-out allowed}}",
        "checkOutNotAllowed": "{position, select, first {Check-out not allowed} other {check-out not allowed}}",
        "chooseNights": "Choose the nights to change",
        "chooseSomething": "Choose something to change",
        "chooseUnitType": "Choose at least one unit type",
        "close": "{position, select, first {Close} other {close}}",
        "maxStay": "{position, select, first {{nights, plural, one {Set maximum stay to {nights}} other {Set maximum stay to {nights}}}} verb {{nights, plural, one {set maximum stay to {nights}} other {set maximum stay to {nights}}}} other {{nights, plural, one {maximum stay to {nights}} other {maximum stay to {nights}}}}}",
        "maxStayCleared": "{position, select, first {No maximum stay} other {no maximum stay}}",
        "minStay": "{position, select, first {{nights, plural, one {Set minimum stay to {nights}} other {Set minimum stay to {nights}}}} verb {{nights, plural, one {set minimum stay to {nights}} other {set minimum stay to {nights}}}} other {{nights, plural, one {minimum stay to {nights}} other {minimum stay to {nights}}}}}",
        "minStayCleared": "{position, select, first {Minimum stay from season} other {minimum stay from season}}",
        "price": "{position, select, first {Set price to {price}} verb {set price to {price}} other {price to {price}}}",
        "priceCleared": "{position, select, first {Use season or base price} other {use season or base price}}",
        "reopen": "{position, select, first {Reopen} other {reopen}}",
        "sentence": "{changes} on {unitTypes}, {span} ({count, plural, one {{count} night} other {{count} nights}})."
      },
      "sent": {
        "checkInAllowed": "check-in allowed",
        "checkInNotAllowed": "check-in not allowed",
        "checkOutAllowed": "check-out allowed",
        "checkOutNotAllowed": "check-out not allowed",
        "closed": "closed",
        "maxStay": "{nights, plural, one {max stay {nights}} other {max stay {nights}}}",
        "maxStayCleared": "no maximum stay",
        "minStay": "{nights, plural, one {min stay {nights}} other {min stay {nights}}}",
        "minStayCleared": "min stay from season",
        "priceCleared": "price back to season or base",
        "reopened": "reopened"
      },
      "summary": {
        "closedFor": "Closed {span} for {unitTypes}",
        "line": "{unitTypes} {fields} on {span}",
        "lineNights": "{unitTypes} {fields} on {span} ({count, plural, one {{count} night} other {{count} nights}})",
        "reopenedFor": "Reopened {span} for {unitTypes}",
        "undone": "Undone: {body}",
        "unitTypesHeadline": "{types, plural, one {{types} unit type, {span}} other {{types} unit types, {span}}}",
        "unitsFreeHeadline": "Units free sent",
        "unitsFreeLine": "{free, plural, one {{unitType} {free} on {span}} other {{unitType} {free} on {span}}}",
        "unitsFreeSent": "Units free sent: {lines}. {trigger, select, nightly_refresh {Nightly refresh.} other {After a booking or block.}}"
      },
      "toast": {
        "nothingConnected": "No booking site is connected, so this changes your rates in Vidimo only.",
        "saved": "Saved",
        "undo": "Undo",
        "undone": "Undone",
        "waiting": "Your last change is still being saved. Save again in a moment."
      },
      "viewMenu": {
        "rates": "Rates",
        "staff": "Staff",
        "units": "Units"
      },
      "words": {
        "and": "{head} and {last}",
        "sentences": "{head}. {next}",
        "series": "{head}, {next}"
      }
    },
    "rateChangeDetailPage": {
      "awaitingFullSync": "{what}: your channels have not confirmed them yet, so they go with the next full sync.",
      "changedLine": "{unitType}, {span} ({count}): {changes}",
      "copied": "Copied",
      "copy": "Copy",
      "copyFailed": "Couldn't copy",
      "fieldCheckIn": "check-in",
      "fieldCheckOut": "check-out",
      "fieldMaxStay": "maximum stay",
      "fieldMinStayArrival": "minimum stay on arrival",
      "fieldMinStayThrough": "minimum stay passing through",
      "fieldPrice": "price",
      "fieldSale": "sale",
      "fieldUnitsFree": "units free",
      "loading": "Loading…",
      "noValueChanged": "No value changed",
      "notFound": "Change not found.",
      "notSent": "{what}: your channels did not take them.",
      "notSentBecauseConnection": "Vidimo had lost access to this property on your channels.",
      "notSentBecauseValues": "Check these values, then send again.",
      "passedUnanswered": "{what}: your channels did not confirm them before these nights passed.",
      "pushedLine": "{unitType} {span}: {fields}",
      "saved": "Saved {time}.",
      "sending": "{what}: sending.",
      "sent": "{what}, sent to your channels",
      "sentAt": "{what}, sent to your channels at {time}",
      "taskIdAwaiting": "{taskId}: arrives once sent",
      "wasNow": "{field} was {before}, now {after}",
      "whatRates": "Rates and rules",
      "whatUnitsFree": "Units free"
    },
    "ratesBoard": {
      "cellLabel": "{rowName}, {day}: {price}",
      "cellLabelClosed": "{rowName}, {day}: {price}, closed",
      "dateTapLabel": "All unit types on {day}",
      "dateTapPropertyLabel": "All unit types of {propertyName} on {day}",
      "units": "{count, plural, one {# unit} other {# units}}"
    },
    "ratesView": {
      "emptyDescription": "Add units to this property before setting prices.",
      "emptyTitle": "No units yet",
      "nextMonth": "Next month",
      "previousMonth": "Previous month",
      "thisMonth": "This month"
    }
  },

  "reservations": {
    "assignUnitSelect": {
      "checking": "Checking which units are free…",
      "errorNotAssigned": "Couldn't assign that unit. Try again.",
      "errorUnitTaken": "Another stay already has that unit on some of these nights. Pick another unit.",
      "noneFree": "No unit is free for every night",
      "placeholder": "Assign a unit"
    },
    "cancelReservationAction": {
      "cancelAction": "Cancel reservation",
      "cancelAndRelease": "Cancel and release hold",
      "cancelBody": "{guestName}'s booking is called off and the unit is freed for those nights.",
      "cancelHoldNote": "The {amount} deposit held on {guestName}'s card is released straight away. This can't be undone: to charge for damage or a late cancellation, capture it from the folio first.",
      "cancelTitle": "Cancel this reservation?",
      "cancelToast": "Reservation cancelled",
      "cancelToastReleased": "Reservation cancelled · deposit hold released",
      "checkingHold": "Checking for a deposit held on {guestName}'s card…",
      "declineAction": "Decline request",
      "declineAndRelease": "Decline and release hold",
      "declineBody": "{guestName}'s request is turned down and the unit stays free for those nights.",
      "declineHoldNote": "The {amount} deposit held on {guestName}'s card is released straight away. This can't be undone.",
      "declineTitle": "Decline this request?",
      "declineToast": "Request declined",
      "declineToastReleased": "Request declined · deposit hold released",
      "errorCancel": "Couldn't cancel the reservation. Try again.",
      "errorDecline": "Couldn't decline the request. Try again.",
      "errorUndoCancel": "Couldn't undo. The reservation is still cancelled.",
      "errorUndoDecline": "Couldn't undo. The request is still declined.",
      "keepIt": "Keep it",
      "undo": "Undo"
    },
    "checkInInviteCard": {
      "deliveryBounced": "Bounced: the address didn't accept it",
      "deliveryComplained": "Marked as spam by the recipient",
      "deliveryDelivered": "Delivered",
      "deliverySent": "Sent, awaiting confirmation",
      "deliverySuppressed": "Not attempted: the address is on a suppression list",
      "errorNotSent": "Couldn't send the invitation",
      "errorPreview": "Couldn't load the preview",
      "noInvitation": "No invitation for this booking",
      "notSentYet": "No invitation has been sent for this booking yet.",
      "previewEmail": "Preview email",
      "sendAgain": "Send again",
      "sendInvitation": "Send invitation",
      "sentTo": "Sent to {email} on {date}{count, plural, =0 {} =1 {} one {} other { ({count} times)}}.",
      "sentToast": "Check-in invitation sent to {email}",
      "title": "Check-in invitation",
      "unavailableNoDates": "Add check-in and check-out dates first.",
      "unavailableNoEmail": "This booking came through without an email address.",
      "unavailableNotActive": "This booking is cancelled, so there is nothing to send.",
      "unavailableNotFound": "We couldn't find this booking."
    },
    "checkInLinkCard": {
      "copied": "Copied",
      "copy": "Copy",
      "description": "Send it to your guest and their check-in opens with nothing to sign in to. Preview shows you what they see.",
      "errorCreate": "Couldn't create the check-in link",
      "errorNotCopied": "Couldn't copy the link",
      "noLink": "No link for this booking",
      "preview": "Preview",
      "title": "Self check-in link",
      "toastCopied": "Link copied",
      "unavailableNoDates": "Add check-in and check-out dates first.",
      "unavailableNotActive": "This booking is cancelled, so there is nothing to check into.",
      "unavailableNotFound": "We couldn't find this booking."
    },
    "checkInsSection": {
      "checkInLaterArrival": "Check in a later arrival",
      "guests": "{count, plural, one {# guest} other {# guests}}",
      "title": "Check-ins"
    },
    "checkInView": {
      "arrived": "Arrived together",
      "back": "Back",
      "checkedInAt": "Checked in {when}",
      "checkedInAtBy": "Checked in {when} by {name}",
      "checkIn": "Check in",
      "checkInAndSend": "Check in and send to {register}",
      "checkInMore": "Check in more guests",
      "done": "Done",
      "errorAdultsUnknown": "Set the number of adults on the booking before checking it in.",
      "errorBookingChanged": "This booking changed on another device. Check who's here again, then send.",
      "errorIdMissing": "No ID is on file for this stay for {names}. Scan their ID, then send again.",
      "errorNotActive": "This booking no longer takes check-ins.",
      "errorNotSent": "The check-in wasn't sent. Try again.",
      "errorNotWaiting": "{names} was already checked in or left the booking. Check the list and send again.",
      "errorTooEarly": "This booking doesn't arrive yet. Check its guests in from their arrival day.",
      "everyoneCheckedIn": "Everyone on this booking is checked in. Scan or type the ID of anyone else who's here.",
      "idMissing": "{count, plural, one {{names} has no ID on file yet.} other {{names} have no ID on file yet.}}",
      "missing": "This check-in isn't on this device.",
      "needsConnection": "Sending a check-in needs a connection.",
      "nobodyLinked": "Nobody is on this booking yet. Scan or type the ID of each guest who's here, or check the booking in on its own.",
      "recordTitle": "Check-in",
      "scanId": "Scan ID",
      "stillSyncing": "This check-in was sent and is still reaching this device. It shows here once it arrives.",
      "title": "Check in",
      "typeId": "Type ID",
      "whoIsHere": "Who's here"
    },
    "collectPaymentSheet": {
      "amountLabel": "Amount ({currency})",
      "channelWarning": "This booking came through a channel that usually collects the room rate. Charging it again would double-charge the guest — collect extras only.",
      "copied": "Copied",
      "copy": "Copy",
      "createLink": "Create payment link",
      "creating": "Creating…",
      "errorCopy": "Couldn't copy — select the link and copy it manually.",
      "errorCreateLink": "Could not create the link. Try again.",
      "errorNoAmount": "Enter an amount to collect.",
      "holdNotice": "The guest's card reserves the amount — the money stays theirs and nobody is charged until you capture it. Vidimo keeps the hold in place until the guest checks out, and tells you if a card can't be held.",
      "linkCopied": "Payment link copied",
      "pendingUntilPaid": "The line shows as pending on the folio until the guest completes payment.",
      "presetBalance": "Full balance",
      "presetDeposit": "30% deposit",
      "presetTouristTax": "Tourist tax",
      "sendHoldLink": "Send this to the guest. It places a hold on their card — the money stays theirs until you capture it.",
      "sendLink": "Send this to the guest. The folio updates as soon as they pay.",
      "title": "Collect payment"
    },
    "confirmMoneyAction": {
      "cancel": "Cancel",
      "working": "Working…"
    },
    "editGuestForm": {
      "avatarAlt": "Guest",
      "backToGuests": "Back to guests",
      "emailLabel": "Email",
      "emailPlaceholder": "guest@example.com (required if no name/phone)",
      "errorNotSaved": "Couldn't save the guest. Try again.",
      "firstNameLabel": "First Name",
      "firstNamePlaceholder": "Enter first name (optional if phone/email set)",
      "lastNameLabel": "Last Name",
      "lastNamePlaceholder": "Enter last name (optional if phone/email set)",
      "nationalityLabel": "Nationality",
      "nationalityPlaceholder": "Select nationality",
      "notFound": "Guest not found",
      "phoneLabel": "Phone",
      "phonePlaceholder": "(required if no name)",
      "saved": "Guest details saved.",
      "title": "Edit guest"
    },
    "editReservationForm": {
      "accessibilityLabel": "Accessibility",
      "accessibilityPlaceholder": "e.g. ground-floor preferred, wheelchair access",
      "adultsLabel": "Adults",
      "arrivalTimeLabel": "Expected Arrival Time",
      "backToCalendar": "Back to calendar",
      "beforeCreating": "Before creating",
      "beforeSaving": "Before saving",
      "boardLabel": "Board",
      "boardPlaceholder": "Not set",
      "channelCancelledNote": "Cancelled on {source} — only the channel can reinstate it",
      "channelDatesNote": "Dates are managed by {source} — change them there and they'll sync in",
      "channelManagedNote": "Synced from {source}. Stay dates and cancellations are managed on the channel and sync in automatically — guest details, notes, and the unit stay editable here.",
      "checkInTimeLabel": "Check-in time",
      "checkOutTimeLabel": "Check-out Time",
      "checkingAvailability": "Checking availability…",
      "childrenLabel": "Children",
      "create": "Create",
      "datesLabel": "Check-in – Check-out",
      "dietaryLabel": "Dietary",
      "dietaryPlaceholder": "e.g. vegetarian welcome basket, nut allergy",
      "emailLabel": "Email",
      "emailPlaceholder": "jane@example.com",
      "errorAdultsRequired": "Set the number of adults to check a guest in",
      "errorCheckInDateRequired": "Check-in date is required",
      "errorCheckInTimeInvalid": "Check-in time must be a time like 13:00",
      "errorCheckOutBeforeCheckIn": "Check-out must be after check-in",
      "errorCheckOutDateRequired": "Check-out date is required",
      "errorCheckOutTimeRequired": "Check-out time is required",
      "errorFirstNameRequired": "Guest first name is required",
      "errorNotCreated": "Couldn't create this reservation. Your details are still here — try again.",
      "errorNotSaved": "Couldn't save this reservation. Your changes are still here — try again.",
      "errorPropertyRequired": "Property is required",
      "errorRoomRequired": "Pick a room for this booking",
      "firstNameLabel": "First name",
      "firstNamePlaceholder": "Jane",
      "groupBookingNote": "This booking spans several units; unit changes aren't supported here yet",
      "guestHeading": "Guest",
      "hasPetsLabel": "Travelling with a pet",
      "infantsLabel": "Infants",
      "lastNameLabel": "Last name",
      "lastNamePlaceholder": "Doe",
      "notFound": "Reservation not found",
      "petNotesLabel": "Pet notes",
      "petNotesPlaceholder": "e.g. 1 small dog (Buddy)",
      "phoneLabel": "Phone",
      "propertyLabel": "Property",
      "propertyLocked": "Property cannot be changed after reservation creation",
      "propertyPlaceholder": "Select a property",
      "save": "Save",
      "statusLabel": "Status",
      "stayDetailsHeading": "Stay details",
      "titleEdit": "Edit reservation",
      "titleNew": "New reservation",
      "toastCreated": "Reservation created.",
      "toastSaved": "Reservation saved.",
      "unitConflict": "This unit is already booked {checkIn} – {checkOut}. Adjust the dates or pick another unit.",
      "unitConflictBy": "This unit is already booked by {name} {checkIn} – {checkOut}. Adjust the dates or pick another unit.",
      "unitConflictByWithRef": "This unit is already booked by {name} {checkIn} – {checkOut} (ref {reference}). Adjust the dates or pick another unit.",
      "unitConflictWithRef": "This unit is already booked {checkIn} – {checkOut} (ref {reference}). Adjust the dates or pick another unit.",
      "unitLabel": "Unit",
      "unitPlaceholder": "Select a room",
      "unitsFree": "{free, plural, one {{free} of {total} free} other {{free} of {total} free}}"
    },
    "guestRegistrationStatus": {
      "authorityQuote": "“{reason}”",
      "authorityQuoteAt": "— {when}",
      "cancelAction": "Cancel this report",
      "cancelConfirm": "Cancel report",
      "cancelHint": "Only if this guest isn't staying here: a no-show, or a report filed for the wrong property. It can't be undone.",
      "cancelKeep": "Keep the report",
      "cancelTitle": "Cancel this report with {authority}?",
      "cancelledToast": "Report cancelled with {authority}.",
      "cancelledWith": "Report cancelled with {authority}",
      "cancelledWithOn": "Report cancelled with {authority} on {when}",
      "errorCancel": "Couldn't cancel the report. Try again.",
      "errorCancelRefused": "The report was not cancelled.",
      "errorDownloadReceipt": "Couldn't download the receipt. Try again.",
      "errorMarkFiled": "Couldn't mark the filing. Try again.",
      "errorRetry": "Couldn't retry the filing. Try again.",
      "errorRetryFailedAgain": "The filing failed again.",
      "fixAndRefile": "Fix and refile",
      "headlineAuthRefused": "{authority} refused this property's credentials",
      "headlineAuthUnused": "This property's {authority} credentials could not be used",
      "headlineFiledByHost": "You filed this guest's other report with {authority} yourself",
      "headlineIncomplete": "{authority} could not complete this registration",
      "headlineMissingData": "{authority} needs details this registration doesn't have",
      "headlineNoConnector": "Vidimo isn't filing this one with {authority}",
      "headlineNotReached": "This registration hasn't reached {authority}",
      "headlineOtherFacility": "{authority} has this guest under another RNO number",
      "headlineUnattributed": "{authority} may already have this registration",
      "headlineValidation": "{authority} rejected this registration",
      "lastTried": "Last tried {when}",
      "legalDeadline": "Legal deadline · {deadline}",
      "markFiledAction": "Mark as filed manually",
      "markFiledConfirm": "Mark as filed",
      "markFiledDescription": "Only once this guest is registered with {authority}: you filed them yourself, or you found them on its portal. Vidimo will not file this registration afterwards.",
      "markFiledNotYet": "Not yet",
      "markFiledTitle": "Mark this registration as filed?",
      "markedFiledToast": "Marked as filed.",
      "nextStepAuth": "Reconnect the property's credentials, then retry.",
      "nextStepFiledByHost": "File this one yourself too, before the deadline, then mark it filed here.",
      "nextStepMissingData": "Complete the missing details, then save to refile.",
      "nextStepNoConnector": "File this guest with the authority yourself before the deadline, then mark it filed here.",
      "nextStepOtherFacility": "If the guest stayed at the facility behind that RNO number, finish the record there on the authority's portal. If not, cancel it there and file the guest under the current number. Then mark it filed here. If the property's RNO number was changed by mistake, change it back and retry.",
      "nextStepTransient": "Retrying automatically.",
      "nextStepUnattributed": "We sent this guest's registration, but couldn't confirm that the authority recorded it. Check its portal: if the guest is there, tap Mark as filed manually; if not, tap Retry.",
      "nextStepValidation": "Correct the details below and save. It is refiled for you.",
      "notFiledByVidimoBody": "Vidimo has no record of reporting this guest for this stay. If you reported them yourself, the record is on the authority's portal.",
      "notFiledYetBody": "Nothing has been sent for this stay yet.",
      "openPortal": "Open {authority}",
      "receipt": "Receipt",
      "receiptCheckInAria": "Download the check-in receipt",
      "receiptCheckOutAria": "Download the check-out receipt",
      "reconnectCredentials": "Reconnect credentials",
      "reportAccepted": "Accepted {when}",
      "reportAfterCheckIn": "Will be sent once the guest is checked in",
      "reportCancelledOn": "Cancelled {when}",
      "reportCheckIn": "Check-in report",
      "reportCheckOut": "Check-out report",
      "reportEntryAria": "{name}'s report to {authority}: {status}",
      "reportFiledByYou": "Filed by you",
      "reportNeedsYou": "Needs your attention",
      "reportScheduled": "Scheduled for {when}",
      "reportSending": "Sending",
      "reportSent": "Sent {when}, awaiting confirmation",
      "reportTo": "Report to {authority}",
      "retry": "Retry",
      "retrySubmittedToast": "Filing submitted.",
      "withdrawDescription": "{authority} will mark the record cancelled, so this guest is no longer reported as staying here. Use this when they are not: a no-show, or a stay filed against the wrong property. It cannot be undone from Vidimo, and Vidimo will not file this guest again afterwards.",
      "withdrawnBody": "The record stays in their register marked as cancelled. This guest is not reported as staying here."
    },
    "mergeConfirmView": {
      "cancel": "Cancel",
      "confirm": "Confirm merge",
      "description": "{source}'s details will be added to {target}'s profile.",
      "source": "Source",
      "target": "Target",
      "title": "Confirm merge"
    },
    "registrationScreen": {
      "correctDetails": "Correct details",
      "idDocument": "ID document",
      "noIdOnFile": "No ID on file yet.",
      "scanAgain": "Scan the document again",
      "scanId": "Scan ID",
      "stayLine": "{property} · {dates}",
      "title": "Registration",
      "typeId": "Type ID"
    },
    "reservationFolioCard": {
      "add": "Add",
      "addCharge": "Add charge",
      "addChargeTitle": "Add charge",
      "amountPlaceholder": "Amount ({currency})",
      "balanceDue": "Balance due",
      "breakfastControlLabel": "Breakfast is set on the stay's mornings — go to Breakfast",
      "breakfastControlTitle": "Set on the stay's mornings, in Breakfast",
      "cancel": "Cancel",
      "capture": "Capture",
      "captureConfirm": "Capture {amount}",
      "captureDescription": "{amount} moves from the guest's card into your Stripe account. This is the whole hold — you can refund it afterwards, but you can't capture the rest later.",
      "captureTitle": "Capture this hold?",
      "chargeKind": "Charge type",
      "chipFailed": "failed",
      "chipHoldExpired": "hold expired",
      "chipOnHold": "on hold",
      "chipPending": "pending",
      "chipRefunded": "refunded",
      "chipReleased": "released",
      "collectPayment": "Collect payment",
      "collectedByChannelName": "Collected by {channel}",
      "complimentary": "Complimentary",
      "descriptionPlaceholder": "Description",
      "errorChargeNotAdded": "Couldn't add the charge. Try again.",
      "errorChargeRemoveRolledBack": "Couldn't remove the charge. It's back on the folio.",
      "errorEnterAmount": "Enter an amount",
      "errorMoneyActionFailed": "That didn't go through. Try again.",
      "errorPaymentNotRecorded": "Couldn't record the payment. Try again.",
      "errorPaymentRemoveRolledBack": "Couldn't remove the payment. It's back on the folio.",
      "fromChannel": "From channel",
      "fromChannelName": "From {channel}",
      "holdCaptured": "Hold captured",
      "holdReleased": "Hold released",
      "inTheRate": "In the rate",
      "kindAccommodation": "Room rate",
      "kindAdjustment": "Adjustment",
      "kindDiscount": "Discount",
      "kindFee": "Fee",
      "kindTax": "Tax",
      "methodBankTransfer": "Bank transfer",
      "methodCard": "Card",
      "methodCash": "Cash",
      "methodChannelCollected": "Collected by channel",
      "methodDeposit": "Deposit",
      "methodGiftVoucher": "Gift voucher",
      "methodOther": "Other",
      "noCharges": "No charges yet.",
      "notTaken": "Not taken",
      "partyAdults": "{count, plural, one {# adult} other {# adults}}",
      "partyAdultsAndChildren": "{adults, plural, one {# adult} other {# adults}} · {children, plural, one {# child} other {# children}}",
      "partyChildren": "{count, plural, one {# child} other {# children}}",
      "partyCovers": "{count, plural, one {# cover} other {# covers}}",
      "paymentMethod": "Payment method",
      "quantityPlaceholder": "Qty",
      "rateAdultsAndChildren": "Adults {adult} · Children {child}",
      "ratePerPerson": "{amount} per person",
      "record": "Record",
      "recordPayment": "Record payment",
      "recordPaymentTitle": "Record payment",
      "referencePlaceholder": "Reference (optional)",
      "refund": "Refund",
      "refundConfirm": "Refund {amount}",
      "refundDescription": "{amount} goes back to the guest from your Stripe account. Stripe does not return its processing fee on a refund.",
      "refundIssued": "Refund issued",
      "refundTitle": "Refund this payment?",
      "release": "Release",
      "releaseConfirm": "Release {amount}",
      "releaseDescription": "The {amount} hold on the guest's card is let go and you can't capture it afterwards. Placing a new one means asking the guest to pay again.",
      "releaseTitle": "Release this hold?",
      "removeCharge": "Remove charge",
      "removePayment": "Remove payment",
      "title": "Folio",
      "total": "Total",
      "touristTax": "Tourist tax",
      "voucherCodePlaceholder": "Voucher code (optional)"
    },
    "reservationSummary": {
      "guest": "Guest"
    },
    "reservationTaxCard": {
      "filedThrough": "Filed through {system}",
      "guestNumber": "Guest {number}",
      "guestShare": "{band} · {nights, plural, one {# night} other {# nights}}",
      "needsBirthDates": "{count, plural, =0 {Add the guests' birth dates} one {Add the birth date for # guest} other {Add birth dates for # guests}}",
      "needsCategory": "Pick the property's category",
      "needsGuests": "Add how many guests are staying to see this tax",
      "needsIntegration": "Set up {system} to see this tax",
      "needsMunicipality": "Pick the property's municipality to see this tax",
      "needsPrice": "Add the room charges to see this tax",
      "needsRegistration": "Set up guest registration to see this tax",
      "noLines": "No tourist tax worked out for this stay yet.",
      "notCovered": "Not covered yet",
      "paysFree": "Free",
      "paysFull": "Full rate",
      "paysHalf": "Half rate",
      "paysPercent": "{percent} of the rate",
      "ratePercent": "{percent} of the price, at most {cap}",
      "ratePerNight": "{rate} per night",
      "ratePerNightFrom": "From {date}: {rate} per night",
      "rateWithSurcharge": "{rate} + {surcharge} {label}",
      "title": "Tourist tax",
      "zone": "Rate for {zone}"
    },
    "reservationTaxNote": {
      "add": "Add a tax note",
      "cancel": "Cancel",
      "edit": "Edit",
      "help": "What staff know about this stay's tourist tax that the booking doesn't say, e.g. the guest showed a spa referral. Only staff see this note.",
      "label": "Tax note",
      "placeholder": "e.g. Guest showed a spa referral from their doctor",
      "save": "Save note",
      "saveFailed": "Couldn't save the tax note. Try again."
    },
    "reservationUnitDetails": {
      "adults": "{count, plural, one {{count} adult} other {{count} adults}}",
      "blockedChannelCancelled": "Cancelled on the channel — only the channel can reinstate it.",
      "blockedPermission": "You don't have permission to change this reservation's status.",
      "blockedPreparing": "This property is preparing, so its current system still runs this stay. It can't be changed, cancelled or sent a check-in link here yet.",
      "boardLabel": "Board",
      "bookedVia": "Booked via",
      "bookerTitle": "Booker",
      "bookingReference": "Booking reference",
      "call": "Call",
      "callAriaLabel": "Call {name}",
      "checkInLabel": "Check-in",
      "checkOutLabel": "Check-out",
      "children": "{count, plural, one {{count} child} other {{count} children}}",
      "copyRoomLinkLabel": "Copy a link to room {room}",
      "duration": "{count, plural, one {{count} night} other {{count} nights}}",
      "durationLabel": "Duration",
      "expectedArrivalLabel": "Expected arrival",
      "guestSummary": "{occupancy} · {idsOnFile} of {count, plural, one {{count} ID} other {{count} IDs}} on file",
      "guestsTitle": "Guests",
      "houseRulesAccepted": "Accepted {date}",
      "houseRulesLabel": "House Rules",
      "infants": "{count, plural, one {{count} infant} other {{count} infants}}",
      "moreGuestsExpected": "{count, plural, one {{count} more guest expected} other {{count} more guests expected}}",
      "notGiven": "Not given",
      "notOnBookingYet": "Not on the booking yet · scan their ID to add them",
      "notSpecified": "Not specified",
      "occupancyLabel": "Occupancy",
      "openGuestLabel": "Open {name}",
      "reportSummary": "{accepted} of {count, plural, one {{count} guest} other {{count} guests}} reported to {authority}",
      "reservationInformation": "Reservation Information",
      "room": "Room {room}",
      "scanBooker": "Scan ID",
      "scanBookerAriaLabel": "Scan {name}'s ID",
      "scanId": "Scan ID",
      "specialRequest": "Special request",
      "taskWithUnit": "{task} · Unit {unit}",
      "tasksTitle": "Tasks",
      "typeId": "Type ID",
      "unassigned": "{count, plural, one {Unassigned} other {# unassigned}}",
      "unitLabel": "Unit",
      "unitsLabel": "Units",
      "unknownUnit": "Unknown Unit",
      "unscheduled": "Unscheduled"
    },
    "stayAction": {
      "checkIn": "Check in",
      "checkInGuest": "Check in {guestName}",
      "checkOut": "Check out",
      "checkOutGuest": "Check out {guestName}"
    },
    "unitOptions": {
      "booked": "Booked"
    },
    "useStayAction": {
      "errorNotUpdated": "Couldn't update the stay. Try again."
    }
  },

  "settings": {
    "accessSection": {
      "checkInModeInPerson": "In person",
      "checkInModeInPersonDescription": "Staff check guests in at arrival. Where the property registers guests with an authority, a guest nobody checks in is never registered automatically, and you're reminded before their deadline.",
      "checkInModeLabel": "Check-in",
      "checkInModeSelf": "Self check-in",
      "checkInModeSelfDescription": "Guests check themselves in. Where the property registers guests with an authority, anyone staff haven't checked in is registered on the booking's arrival day.",
      "doorCode": "Door code",
      "doorCodeDescription": "Guests get a keypad code on arrival day",
      "label": "Access method",
      "lockbox": "Lockbox",
      "lockboxDescription": "Guests take the key from a coded box",
      "placeholder": "Select access method",
      "receptionCloses": "Reception closes",
      "receptionOpens": "Reception opens",
      "smartLock": "Smart lock",
      "smartLockDescription": "Guests unlock with a code or app",
      "staffedReception": "Staffed reception",
      "staffedReceptionDescription": "Guests pick up keys at the front desk"
    },
    "account": {
      "interfaceLanguage": {
        "automatic": "Automatic ({language})",
        "description": "Menus, buttons and screens are shown in this language.",
        "title": "Interface language"
      }
    },
    "accountDeletion": {
      "genericFailure": "Could not delete your account. Try again.",
      "protectedAccount": "This account is protected and cannot be deleted.",
      "soleOwner": "You are the only owner of {properties}. Make someone else an owner, or delete {count, plural, one {the property} other {the properties}}, before deleting your account."
    },
    "accountPassword": {
      "genericFailure": "Could not set your password. Try again.",
      "sessionStale": "For your security, sign out and back in before setting a password."
    },
    "accountView": {
      "appearanceDescription": "Changes apply immediately on this device.",
      "appearanceTitle": "Appearance",
      "errorNameRequired": "Name is required",
      "errorPhotoNotSaved": "Could not save your photo. Try again.",
      "hapticsDescription": "A short buzz when a check-in, a scan or a turnover lands, so you can keep your eyes on the guest. Applies immediately on this device.",
      "hapticsTitle": "Haptics",
      "hapticsToggle": "Vibrate on confirmations",
      "languageArabic": "Arabic",
      "languageDefault": "Default (English)",
      "languageChinese": "Chinese",
      "languageEnglish": "English",
      "languageFrench": "French",
      "languageGerman": "German",
      "languageItalian": "Italian",
      "languageJapanese": "Japanese",
      "languagePortuguese": "Portuguese",
      "languageSlovenian": "Slovenian",
      "languageSpanish": "Spanish",
      "nameDescription": "Shown to your team and on the messages you send.",
      "namePlaceholder": "Enter your name",
      "nameTitle": "Full name",
      "phoneDescription": "Your professional number.",
      "phoneTitle": "Phone number",
      "photoAlt": "Profile",
      "photoCaption": "Tap to change profile photo",
      "subtitle": "Manage your profile and information",
      "themeDark": "Dark",
      "themeLight": "Light",
      "themeSystem": "System",
      "title": "Account",
      "translationLanguageDescription": "Messages in other languages are translated to this one.",
      "translationLanguageTitle": "Translation language"
    },
    "addressSection": {
      "countryLabel": "Country",
      "hint": "Search and select the property's address. We use it to pin the location and fill in the country.",
      "label": "Address",
      "placeholder": "Search the property address…"
    },
    "availabilityDisplay": {
      "availableDuring": "Available {summary}",
      "awayOn": "Away {date}",
      "awayRange": "Away {range}",
      "awayThrough": "Away through {end}",
      "awayToday": "Away today",
      "awayTomorrow": "Away tomorrow",
      "outsideAvailability": "Outside availability"
    },
    "breakfastPage": {
      "adult": "Adult",
      "child": "Child",
      "errorSave": "Couldn't save the breakfast settings. Try again.",
      "from": "From",
      "inclusionCharged": "Charged",
      "inclusionChargedDetail": "Guests pay for it, unless their stay's board includes breakfast.",
      "inclusionComplimentary": "Complimentary",
      "inclusionComplimentaryDetail": "Free for every guest, whatever rate they booked. Nothing lands on the bill.",
      "inclusionIncluded": "Included in the rate",
      "inclusionLabel": "How it is paid for",
      "placeLabel": "Usually served",
      "priceHint": "Per person, per morning, in {currency}. Who counts as a child comes from the booking, so a channel stay uses the channel's own age rule.",
      "priceLabel": "Price",
      "save": "Save",
      "saved": "Saved",
      "serveBreakfast": "Serve breakfast",
      "serveBreakfastHint": "Off means no mornings are planned and nothing appears on Today.",
      "serviceHint": "Guests see these hours. Where it is served can be changed for any room on the morning itself.",
      "serviceLabel": "Service",
      "title": "Breakfast",
      "unavailableDescription": "Vidimo can't load it on this device. Try again; this reloads the app.",
      "unavailableTitle": "Breakfast can't be changed right now",
      "until": "Until"
    },
    "cancellationSection": {
      "flexible": "Flexible",
      "hint": "{policyDescription} Guests booking on your public page see this before they pay, and refunds follow it.",
      "label": "Cancellation policy",
      "moderate": "Moderate",
      "nonRefundable": "Non-refundable",
      "placeholder": "Select cancellation policy",
      "strict": "Strict"
    },
    "channelCards": {
      "announced": "Connect {label} to keep availability and prices in sync both ways, and pull new reservations straight into Vidimo.",
      "cancel": "Cancel",
      "comingSoon": "{label} connections are coming soon.",
      "connectButton": "Connect {label}",
      "connectTitle": "Connect {label}",
      "connecting": "Connecting…",
      "continue": "Continue",
      "errorConnect": "Couldn't connect the channel. Try again.",
      "errorOpenSetup": "Couldn't open the channel setup. Try again.",
      "errorSync": "Couldn't sync. Try again.",
      "explainerLogin": "You'll finish on a secure setup page, so keep your {label} login handy.",
      "explainerOwnerOnly": "Only the listing's owner account can connect {label}, not a co-host.",
      "explainerSync": "Your availability and prices stay in step with {label} both ways, and new reservations arrive in Vidimo.",
      "noUnits": "Add a unit to this property first.",
      "opening": "Opening…",
      "setUpChannels": "Set up {label}",
      "syncAction": "Sync availability & prices",
      "syncDone": "Availability and prices re-synced with {label}.",
      "syncSlow": "{label} is responding slowly. The sync will finish automatically.",
      "syncStarted": "Sync started. It'll finish in the background.",
      "syncing": "Syncing…",
      "warnings": {
        "delayed": "Sync is delayed. We're retrying; you don't need to do anything.",
        "ourSide": "Something went wrong on our side with this channel. We've been alerted.",
        "unlinkedRoom": "We couldn't match a new booking. Check this channel's setup."
      },
      "whichUnits": "Which units list on {label}?"
    },
    "cleaningChecklistEditor": {
      "addStep": "Add step",
      "alwaysLast": "· always last",
      "guestNeedsHint": "Guest needs from the booking, like a baby cot or a pet, are added just above the final walkthrough.",
      "listFull": "{count, plural, one {A checklist holds up to # steps.} other {A checklist holds up to # steps.}}",
      "moveDown": "Move step {position} down",
      "moveUp": "Move step {position} up",
      "remove": "Remove step {position}",
      "saveList": "Save checklist",
      "saving": "Saving…",
      "stepBlank": "Fill in this step or remove it.",
      "stepLabel": "Step {position}",
      "stepLength": "{length} / {max}",
      "stepPlaceholder": "Describe the step",
      "stepTooLong": "{count, plural, one {Too long by {count} characters.} other {Too long by {count} characters.}}",
      "unsavedChanges": "Unsaved changes"
    },
    "cleaningPage": {
      "allRooms": "All rooms",
      "assignHeading": "Who it goes to",
      "discard": "Discard",
      "discardDescription": "This checklist has edits you haven't saved. Switching now throws them away.",
      "discardDescriptionReload": "You have unsaved changes. Reloading the app now throws them away.",
      "discardTitle": "Discard your changes?",
      "errorReset": "Couldn't change the checklist. Try again.",
      "errorSave": "Couldn't save the checklist. Try again.",
      "giveOwnList": "Give {unitName} its own checklist",
      "hintPostCheckout": "A guest has left and no one is arriving that day.",
      "hintRefresh": "Reception readies the cleaned room just before each guest arrives.",
      "hintTurnover": "Someone leaves and someone else arrives the same day.",
      "inheritedPostCheckoutFromProperty": "{unitName} uses the property's post-checkout checklist:",
      "inheritedPostCheckoutFromStandard": "{unitName} uses the standard post-checkout checklist:",
      "inheritedPreCheckinRefreshFromProperty": "{unitName} uses the property's pre-arrival refresh checklist:",
      "inheritedPreCheckinRefreshFromStandard": "{unitName} uses the standard pre-arrival refresh checklist:",
      "inheritedTurnoverFromProperty": "{unitName} uses the property's turnover checklist:",
      "inheritedTurnoverFromStandard": "{unitName} uses the standard turnover checklist:",
      "intro": "These decide who each cleaning task Vidimo creates goes to, and the steps it starts with. Whoever you assign by hand always wins, and tasks that already exist keep what they started with.",
      "keepEditing": "Keep editing",
      "kindLabel": "Kind of clean",
      "loading": "Loading your checklists…",
      "ownListCreated": "{name} now has its own checklist. Edit it below.",
      "refreshError": "Couldn't change the refresh. Try again.",
      "refreshHint": "Reception readies each room after its clean, just before the guest arrives. Applies only to bookings added once it's on.",
      "refreshLabel": "Refresh before every arrival",
      "resetLabelProperty": "Use the property's checklist",
      "resetLabelStandard": "Reset to the standard checklist",
      "resetToProperty": "{name} now uses the property's checklist.",
      "resetToStandard": "Back to the standard checklist.",
      "saveAndSwitch": "Save and switch",
      "saveFirstDescription": "This checklist has edits you haven't saved. Save them before switching, or discard them.",
      "saveFirstTitle": "Save your changes?",
      "saved": "Checklist saved. Cleaning tasks Vidimo creates from now on will use it.",
      "scopeHint": "Give a room its own checklist only where it differs, like a balcony or a hot tub.",
      "scopeLabel": "Applies to",
      "stepsHeading": "Checklist",
      "thisRoom": "This room",
      "title": "Cleaning",
      "unavailableDescription": "Vidimo can't load them on this device. Try again; this reloads the app.",
      "unavailableTitle": "Checklists can't be changed right now",
      "undo": "Undo"
    },
    "createPage": {
      "created": "Property created",
      "createdPendingSync": "Property created. It will appear once your connection catches up.",
      "description": "Set up a new property to manage guests and staff.",
      "errorNotCreated": "Couldn't create the property. Try again.",
      "title": "Create a property"
    },
    "createPropertyForm": {
      "addressHint": "Search and select the address to pin the location and fill in the country. You can add the address later.",
      "addressLabel": "Address",
      "addressNoCountry": "That address has no country. Choose it below.",
      "addressPlaceholder": "Search the property address…",
      "cancel": "Cancel",
      "countryHint": "Decides the property's guest registration, tourist tax and VAT.",
      "countryLabel": "Country *",
      "countryPlaceholder": "Select the country",
      "nameLabel": "Property name *",
      "namePlaceholder": "Enter property name",
      "submit": "Continue"
    },
    "credentialHealth": {
      "accepted": "{system} accepted your sign-in and a test record on {checkedAt}. The check files nothing.",
      "badge": {
        "enterAgain": "Enter again",
        "keyRefused": "Key refused",
        "noAnswer": "No answer",
        "refusedAccount": "Account refused",
        "signInRefused": "Sign-in refused",
        "works": "Account works"
      },
      "enterAgain": "Since {since}, Vidimo cannot use the credentials on file, so nothing was sent to {system}. Enter them again.",
      "keyRefused": "Since {since}, {system} refuses this {key}.{said} Generate a new one and enter it with Update credentials. {help}",
      "noAnswer": "{system} did not answer Vidimo's check on {checkedAt}.{streak} Vidimo checks again within a day.",
      "recordRefused": "Your sign-in works. On {checkedAt} {system} refused Vidimo's test record, which is ours to fix, not yours.{said} Nothing was filed.",
      "refusedAccount": "Since {since}, {system} accepts the sign-in but refuses the check for this account.{said} Check that the web service is enabled for this account and that any apartment or account number below is right.",
      "said": " It said: “{message}”.",
      "signInRefused": "Since {since}, {system} refuses the sign-in with these credentials.{said} Check the username and password.",
      "streak": " It has given no verdict since {since}.",
      "unanswered": "{system} returned an error instead of a verdict on {checkedAt}: “{message}”.{streak} Vidimo checks again within a day."
    },
    "customDomainView": {
      "addDomain": "Add domain",
      "copied": "Copied to clipboard",
      "copyRecordValue": "Copy {type} record value",
      "dnsInstructions": "Add these records at your domain registrar. DNS changes can take a few minutes to propagate.",
      "domainAdded": "Domain added — configure the DNS records to verify it",
      "domainLabel": "Your domain",
      "domainLive": "Your domain is live",
      "domainPlaceholder": "your-hotel.com",
      "domainRemoved": "Custom domain removed",
      "errorAdd": "Couldn't add the domain",
      "errorCopy": "Couldn't copy to clipboard",
      "errorRemove": "Couldn't remove the domain",
      "intro": "Serve your property's Places site from your own domain, e.g. <example>www.your-hotel.com</example>. Guests never see the vidimo.app address.",
      "loadFailedBody": "Check your connection and try again.",
      "loadFailedTitle": "Couldn't load domain settings",
      "openSite": "Open site",
      "primary": "primary",
      "remove": "Remove",
      "retry": "Retry",
      "siteLiveBody": "Guests can reach you at {url}.",
      "siteLiveTitle": "Your site is live",
      "statusActive": "Active",
      "statusError": "Error",
      "statusPendingDns": "Pending DNS",
      "statusVerifying": "Verifying",
      "stillWaiting": "Still waiting on DNS — this can take a few minutes",
      "title": "Custom domain",
      "verificationFailedBody": "Check the DNS records below and try again.",
      "verificationFailedTitle": "Verification failed",
      "verify": "Verify"
    },
    "deleteAccountSection": {
      "confirmPhrase": "permanently delete",
      "description": "Permanently delete your account and personal data, including your profile, your team chat messages, and your access to every property you belong to. This cannot be undone.",
      "errorLoad": "Couldn't check this account. Check your connection and try again.",
      "errorNotDeleted": "Could not delete your account. Try again.",
      "errorOffline": "You're offline, so this account can't be checked right now.",
      "title": "Delete account"
    },
    "deleteConfirmDialog": {
      "cancel": "Cancel",
      "confirmNamePrompt": "To confirm, please type: <strong>{entityName}</strong>",
      "confirmPhrasePrompt": "To confirm the deletion of <strong>{entityName}</strong>, please type <strong>\"{expectedValue}\"</strong>",
      "deleting": "Deleting...",
      "placeholder": "Type \"{expectedValue}\""
    },
    "deleteDangerSection": {
      "checking": "Checking…"
    },
    "disconnectIntegration": {
      "cancel": "Cancel",
      "disconnect": "Disconnect",
      "disconnected": "{channel} disconnected",
      "disconnecting": "Disconnecting…",
      "error": "Couldn't disconnect {channel}. Try again.",
      "title": "Disconnect {channel}?"
    },
    "editableSettingCard": {
      "errorNotSaved": "Could not save. Try again.",
      "save": "Save",
      "saved": "Saved",
      "saving": "Saving..."
    },
    "emailPreviewSheet": {
      "frameTitle": "Email preview",
      "loading": "Loading…",
      "sampleNote": "An example, with your property's name and address. The dates, guest and booking reference are made up.",
      "subject": "Subject",
      "title": "Preview"
    },
    "facilityNumber": {
      "addedWithLogin": "You add the {field} when you set up the login below.",
      "elsewhere": "The register lists this {field} in {other}, not in this municipality. Check the number, or the property's municipality.",
      "errorSave": "Couldn't save the {field}. Try again.",
      "listed": "Listed in the register for this municipality.",
      "listedNamed": "The register lists {name} under this number.",
      "neededForTax": "The tourist tax here depends on where your accommodation stands, what kind it is or who runs it, so Vidimo needs this number to work it out.",
      "notListed": "The register lists no active facility under this {field} in this municipality. A facility registered today shows up the next day.",
      "registerIncomplete": "The register doesn't yet say enough about this facility to work out its tourist tax. Vidimo shows the tax once it does.",
      "save": "Save",
      "saved": "{field} saved",
      "saving": "Saving…"
    },
    "guestPortalForm": {
      "cancel": "Cancel",
      "errorNotSaved": "Couldn't save the guest portal. Try again.",
      "intro": "Guests read these on their stay page, and AI reply drafts answer from them. Drafts are never told the WiFi password or door codes.",
      "parking": "Parking",
      "parkingSummary": "{count, plural, =0 {Not set up yet} one {# spot} other {# spots}}",
      "save": "Save",
      "subtitle": "What guests read on their stay page",
      "title": "Guest portal"
    },
    "guestPortalPage": {
      "title": "Guest portal"
    },
    "guestPreviewPage": {
      "desktopUnavailable": "The preview opens in the web app and the phone and tablet apps.",
      "title": "Preview as guest"
    },
    "guestRegistryPage": {
      "bornOn": "b. {date}",
      "document": "{type} {number}",
      "documentIdCard": "ID card",
      "documentOther": "Document",
      "documentPassport": "Passport",
      "documentWithIssuer": "{type} {number} ({country})",
      "emptyDescription": "Guests appear here once they check in.",
      "emptyFilteredDescription": "No registry entries match these filters.",
      "emptyTitle": "No entries",
      "errorLoad": "Couldn't load the registry. Try again.",
      "loadMore": "Load more",
      "loadingMore": "Loading…",
      "noDocument": "No document",
      "occupancy": "{adults, plural, one {# ad.} other {# ad.}}",
      "occupancyUnknownAdults": "? ad.",
      "occupancyUnknownAdultsWithChildren": "? ad. · {children, plural, one {# ch.} other {# ch.}}",
      "occupancyWithChildren": "{adults, plural, one {# ad.} other {# ad.}} · {children, plural, one {# ch.} other {# ch.}}",
      "title": "Guest registry"
    },
    "guestRegistryParams": {
      "statusAll": "All stays",
      "statusCheckedIn": "In house",
      "statusCheckedOut": "Departed"
    },
    "guestRegistryRegistryFilterBar": {
      "allTime": "All time",
      "count": "{count, plural, one {{count} entry} other {{count} entries}}",
      "countPartial": "{shown} of {total, plural, one {{total} entries} other {{total} entries}}",
      "customRange": "Custom range",
      "exportCsv": "Export CSV",
      "exporting": "Exporting…",
      "intro": "The legal record of who stayed, captured at check-in. Entries are append-only; viewing and exporting never change them.",
      "rangePlaceholder": "Select date range",
      "searchPlaceholder": "Search guest name…",
      "statusFilterLabel": "Filter by stay status",
      "yearFilterLabel": "Filter by year"
    },
    "guestRegistryUseGuestRegistry": {
      "errorExport": "Couldn't export the registry.",
      "errorLoadMore": "Couldn't load more entries."
    },
    "houseRulesSection": {
      "houseInfoHint": "How the place works: heating, bins, appliances, quiet hours.",
      "houseInfoLabel": "House info",
      "houseInfoPlaceholder": "Heating is on the panel by the door.\nBins go out on Tuesday evening.",
      "houseRulesHint": "One rule per line. Guests read these in their portal and agree to them once at check-in; leave it empty to skip that step.",
      "houseRulesLabel": "House rules",
      "houseRulesPlaceholder": "No smoking anywhere in the building.\nQuiet hours 22:00 to 08:00.",
      "localTipsHint": "Your picks nearby: food, transport, what not to miss.",
      "localTipsLabel": "Local tips",
      "localTipsPlaceholder": "Best coffee: the bakery on the corner.\nThe 6 bus goes straight to the old town."
    },
    "importsPage": {
      "applyChange": "Use {source}'s",
      "brief": "{guest} · {dates} · {rooms}",
      "briefBlock": "Blocked · {dates} · {rooms}",
      "briefCancelled": "{brief} · cancelled",
      "candidate": "Earlier booking {number}",
      "changes": "{added} added · {amended} updated · {cancelled} cancelled · {unchanged} unchanged",
      "current": "In Vidimo",
      "detail": "{field}: {value}",
      "detailNone": "none",
      "details": {
        "adults": "Adults",
        "amountMinor": "Total",
        "children": "Children",
        "email": "Email",
        "infants": "Infants",
        "notes": "Notes",
        "phone": "Phone",
        "reason": "Reason",
        "source": "Source",
        "status": "Status"
      },
      "emptyDescription": "Vidimo already runs this property, so no bookings can be imported into it. Imports are only for a property that is still preparing.",
      "emptyTitle": "No bookings imported",
      "errorLoad": "Couldn't load your imports. Try again in a moment.",
      "held": "{count, plural, one {# booking needs your decision} other {# bookings need your decision}}",
      "heldReason": {
        "host_changed": "You changed booking {number} in Vidimo, or recorded guests on a room {source} now has it out of, and {source} has changed it since. Yours stays until you choose.",
        "host_deleted": "You deleted booking {number} in Vidimo, and {source} has changed it since. It stays deleted until you choose.",
        "possible_match": "Booking {number} in {source} may be one an earlier import added under another number. It wasn't added, so nothing is doubled."
      },
      "heldRoomRemoved": "Its room has been removed from Vidimo, so {source}'s version can't be used here.",
      "heldUntilNext": "Decide before your AI app runs its next import: it closes these and asks again about any that are still unclear.",
      "how": {
        "connect": "Add Vidimo to Claude or ChatGPT as a connector, and leave {importLabel} ticked when Vidimo asks.",
        "copied": "Copied",
        "copy": "Copy prompt",
        "copyFailed": "Couldn't copy. Select the prompt and copy it yourself.",
        "guide": "Read the guide",
        "paste": "Paste this prompt into a new chat. Your AI app helps you add anything that's missing, asks a few questions and copies the bookings.",
        "prompt": "I want to copy my bookings from the system I use today into my Vidimo property {property}. Before anything else, check that you have the two things this needs. If either is missing, stop, tell me which, and walk me through setting it up.\n\n1. Vidimo's tools, such as getImportPlaybook. Without them, Vidimo is either switched off for this chat or not added to this app yet. First ask me to look in this app's connectors: if Vidimo is there, I switch it on. If it isn't, help me add it as a custom connector with the address {connectorUrl}. In Claude, that's Customize, Connectors, Add, Add custom connector. In ChatGPT, it's Plugins, Add, Add custom MCP server. When Vidimo asks, I sign in and leave {importLabel} ticked. Then tell me to start a new chat and paste this prompt again, since a chat only gets the connectors it started with. If you can open web pages, the steps are also at {guideUrl}.\n\n2. A browser you can use for me, where I sign in to my system and you read its pages, such as Claude in Chrome or ChatGPT's Work mode. Web search isn't enough, since my system needs me signed in. If you can't use one in this chat, tell me how to get one in this app.\n\nOnce you have both, call getImportPlaybook and follow it.",
        "signIn": "In the browser your AI app uses, open your current system and sign in.",
        "title": "Import your bookings with your AI app"
      },
      "ignore": "Don't add",
      "intro": "Each import your AI app ran, checked against your current system's own totals where it shows them.",
      "introUndo": "While this property is preparing, you can undo an import to remove the bookings it added.",
      "keep": "Keep it",
      "keepDeleted": "Keep it deleted",
      "keepMine": "Keep mine",
      "matches": "Matches {source}: the bookings each month and every room's nights agree.",
      "mismatch": "Doesn't match {source}",
      "missingInVidimo": "{room}, nights of {nights}: booked in {source}, empty in Vidimo",
      "monthDifference": "{month}: {pms} arriving in {source}, {vidimo} in Vidimo",
      "noTotals": "{source}'s totals weren't sent with this import, so Vidimo can't confirm it missed nothing. Compare it with {source} yourself.",
      "notInPms": "{room}, nights of {nights}: booked in Vidimo, empty in {source}",
      "notSent": "{count, plural, one {# booking from an earlier import wasn't in this one. It was left as it is, not cancelled.} other {# bookings from earlier imports weren't in this one. They were left as they are, not cancelled.}}",
      "problems": "{count, plural, one {# thing to look at} other {# things to look at}}, as your AI app reported when it finished",
      "proposed": "In {source}",
      "resolveFailed": "Couldn't save your choice. Try again in a moment.",
      "resolveRefused": "That choice can't be applied as it is: the booking changed since, no longer fits its dates or rooms, or would remove guests you recorded on a room. Check the booking in Vidimo, then choose again.",
      "restore": "Restore from {source}",
      "runTitle": "From {source}",
      "sameBooking": "It's this booking",
      "separateBooking": "Add as a new booking",
      "status": {
        "finished": "Finished",
        "open": "Importing",
        "undone": "Undone"
      },
      "stillImporting": "Still importing. When it finishes, it's checked against {source}'s totals where your AI app can send them.",
      "title": "Imported bookings",
      "superseded": "A later import from {source} has finished since, so this import's check no longer counts: see the later one.",
      "totals": "{source}: {pmsBookings, plural, one {# booking} other {# bookings}} arriving, {pmsNights, plural, one {# room night} other {# room nights}}. Vidimo: {vidimoBookings, plural, one {# booking} other {# bookings}}, {vidimoNights, plural, one {# room night} other {# room nights}}.",
      "totalsFrom": "Checked against {source}'s totals as of {date}.",
      "undo": "Undo import",
      "undoAmended": "Changes it made to bookings earlier imports added stay.",
      "undoBody": "This removes from Vidimo {reservations, plural, one {the booking} other {the # bookings}}{blocks, plural, =0 {} one { and # blocked room} other { and # blocked rooms}} this import copied from {source}. Nothing changes in {source}, and bookings you made yourself, or other imports added, stay.",
      "undoFailed": "Couldn't undo the import. Try again in a moment.",
      "undoGuestDetails": "{count, plural, one {# of them holds guests you recorded: those records go too, the guest profiles stay.} other {# of them hold guests you recorded: those records go too, the guest profiles stay.}}",
      "undoNothingAdded": "Nothing this import added is still in Vidimo, so undoing it removes nothing. It's marked undone, and the bookings it still held for you are closed.",
      "undoOpenBody": "This import is still running. Undoing it stops it and removes from Vidimo every booking it has copied from {source}, {reservations} so far. Nothing changes in {source}, and bookings you made yourself, or other imports added, stay.",
      "undoRefusedActive": "Vidimo runs this property now, so an import can't be undone. Change its bookings one by one.",
      "undoTitle": "Undo this import?",
      "undone": "Import undone: {reservations, plural, one {# booking} other {# bookings}}{blocks, plural, =0 {} one { and # blocked room} other { and # blocked rooms}} removed.",
      "undoneOn": "Undone on {date}. The bookings it added were removed.",
      "unknownRoom": "A removed room"
    },
    "infoEdit": {
      "errorNotDeleted": "Couldn't delete the property. Try again."
    },
    "inviteMemberDrawer": {
      "emailHint": "We'll email them a link to join, plus an invite code they can enter in the app.",
      "emailLabel": "Email",
      "emailPlaceholder": "name@example.com",
      "errorFailed": "Invite failed",
      "noPermission": "You don't have permission to invite members at this property.",
      "roleLabel": "Role",
      "submit": "Send invitation",
      "submitPending": "Sending…",
      "title": "Invite a member"
    },
    "joinPage": {
      "description": "Enter the invite code you received to join your team.",
      "title": "Join a property"
    },
    "joinPropertyForm": {
      "cancel": "Cancel",
      "codeLabel": "Invite code",
      "codePlaceholder": "Enter your invite code",
      "submit": "Join"
    },
    "linkError": {
      "alreadyLinkedToDifferentUser": "That account is already connected to a different Vidimo account. Disconnect it there first.",
      "emailDoesNotMatch": "That account uses a different email address. You can only connect one that matches this account's email.",
      "emailNotFound": "That provider didn't share an email address, so it can't be matched to this account.",
      "generic": "That account couldn't be connected. Try again.",
      "unableToLinkAccount": "That account couldn't be connected. Make sure its email address is verified with the provider, then try again."
    },
    "linkSocialAccount": {
      "linkFailed": "Could not link your {provider} account"
    },
    "membersAvailability": {
      "notFound": "Member not found"
    },
    "membersMembers": {
      "errorNotResent": "Couldn't re-send the invitation. Try again.",
      "errorNotWithdrawn": "Couldn't withdraw the invitation. Try again.",
      "resent": "Invitation re-sent to {email}",
      "withdrawn": "Invitation withdrawn"
    },
    "connectRefusal": {
      "account_claimed": "This account is connected to another property, so it can't be connected here.",
      "contactSupport": "Contact support",
      "number_claimed": "This number is connected to another property, so it can't be connected here.",
      "numberClaimedBy": "This number is connected to {property}, so it can't be connected here.",
      "property_preparing": "This property is preparing, so nothing can be connected yet. Connecting could take over a service your current system runs.",
      "setup_broken": "This setup can't go any further. The Vidimo team can sort it out.",
      "subscription_required": "Connecting a channel needs an active subscription."
    },
    "messagingCards": {
      "addressCopied": "Address copied",
      "checking": "Checking…",
      "codeAccepted": "Code accepted. Finishing the connection.",
      "codeHint": "WhatsApp sends it by text or by an automated call. It can take a couple of minutes to arrive.",
      "codeLabel": "Enter the code WhatsApp sent you",
      "codeLabelSentTo": "Enter the code sent to {e164}",
      "comingSoon": "Coming soon",
      "connectFailed": "Couldn't connect. Try again.",
      "connectInstagram": "Connect Instagram",
      "connectWhatsApp": "Connect WhatsApp",
      "copyEmailAddress": "Copy email address",
      "disconnectInstagramDescription": "New direct messages will stop reaching Vidimo, and the account is released so it can be connected again here or on another property. Your existing conversations stay in Chats.",
      "disconnectWhatsAppDescription": "Guest messages to this number will stop reaching Vidimo. Your existing conversations stay in Chats.",
      "emailDescription": "Guests can email this address. Replies land here in Chats — no setup, no forwarding.",
      "errorCode": "That code didn't work. Check it and try again.",
      "errorConnectInstagram": "Could not start Instagram connect",
      "errorCopyAddress": "Couldn't copy the address",
      "errorLinkPhone": "Couldn't link the number. Try again.",
      "errorReachWhatsApp": "Couldn't reach WhatsApp. Try again in a moment.",
      "errorStartConnection": "Couldn't start the connection. Try again.",
      "instagramConnected": "Feed and direct messages are connected.",
      "instagramPitch": "Show your feed and answer DMs from the inbox.",
      "instagramReplyRule": "Instagram only lets you reply after a guest messages you first.",
      "linkPhone": "Link Phone",
      "linking": "Linking…",
      "manageWhatsApp": "Manage on WhatsApp Business",
      "number": "Number: <number>{e164}</number>",
      "numberConnected": "Connected number: <number>{e164}</number>",
      "numberConnecting": "Connecting number: <number>{e164}</number>",
      "opening": "Opening…",
      "phoneLinked": "Phone number linked",
      "phoneNumberLabel": "Phone number (E.164)",
      "phoneSubtitle": "Twilio voice + SMS for this property",
      "reconnectInstagram": "Reconnect Instagram",
      "reconnecting": "Reconnecting…",
      "retryConnection": "Retry connection",
      "senderOffline": {
        "displayNameRejected": "WhatsApp didn't approve the display name for this number. Pick a different name in WhatsApp Manager, then retry the connection.",
        "numberReassigned": "This number is now registered to a different WhatsApp account, so guest messages no longer reach this property.",
        "numberRemoved": "This number was removed from WhatsApp Business. Retry the connection to set it up again.",
        "policyRestricted": "WhatsApp has restricted this number for breaking its business policy. Check WhatsApp Manager for what to fix.",
        "unrecognised": "WhatsApp turned this number off. Retry the connection to set it up again, or check WhatsApp Manager for details."
      },
      "statusActive": "Active",
      "submit": "Submit",
      "twilioSidLabel": "Twilio Number SID (optional)",
      "update": "Update",
      "whatsAppEmpty": "Connect a WhatsApp Business number to receive guest messages on this property.",
      "whatsAppNumberHeld": "WhatsApp is still holding this number. Disconnect it, then connect it again.",
      "whatsAppNumberHint": "Use the same number in Meta's signup, which opens next.",
      "whatsAppNumberLabel": "WhatsApp number",
      "whatsAppReconnected": "WhatsApp reconnected",
      "whatsAppSettingUp": "Usually a few minutes. You can leave this screen: it finishes on its own.",
      "whatsAppSettingUpTitle": "Setting up your number with WhatsApp",
      "whatsAppSubtitle": "Guest messages on the property's own number",
      "whatsAppUnavailable": "Connecting WhatsApp isn't available on this environment."
    },
    "loadErrorRetry": {
      "retry": "Try again"
    },
    "municipalitySection": {
      "countryPending": "The property's country just changed. Its municipalities show here once the change reaches Vidimo.",
      "loadFailed": "Couldn't load the municipality. Check your connection.",
      "noCountry": "Add the property's address and country in <link>General</link> first.",
      "noMatch": "No municipality matches",
      "notListed": "Vidimo doesn't hold this country's list of municipalities yet.",
      "pickFailed": "Couldn't save the municipality. Try again.",
      "placeholder": "Pick your municipality",
      "retired": "This municipality is no longer on the official list. Pick the one it became.",
      "retry": "Try again",
      "searchFailed": "Couldn't search. Check your connection.",
      "searchLabel": "Search municipalities",
      "searching": "Searching…",
      "source": "{method, select, host {Picked by you} address_register {From your address} other {Set for this property}}",
      "title": "Municipality",
      "typeToSearch": "Type a name to search"
    },
    "notificationsView": {
      "complianceDescription": "Guest registrations that stopped and need you, with the reason and their deadline, and guests nobody has checked in as their deadline nears",
      "complianceLabel": "Registration deadlines",
      "messagesDescription": "New messages from guests and your team",
      "messagesLabel": "Messages",
      "reservationsDescription": "New bookings, guests arriving, cancellations, and card holds that ended before checkout",
      "reservationsLabel": "Reservations",
      "tasksDescription": "Tasks assigned to you, rooms free to clean or ready to refresh, and your rooms not ready for an arrival",
      "tasksLabel": "Tasks",
      "title": "Notifications"
    },
    "operationalState": {
      "badge": "Preparing",
      "blocked": "This property is preparing, so Vidimo doesn't run it yet. Your current system still handles its reservations and guests.",
      "description": "Your current system still runs it. Set it up and look around freely: nothing you do here reaches guests, channels or the authorities yet.",
      "importBookings": "Import your bookings",
      "noConnections": "Channels, WhatsApp, Instagram and phone numbers can't be connected.",
      "noFilings": "No guest registrations or statistics are filed.",
      "noGuestContact": "Guests get no messages, check-in links or payment requests.",
      "noReservations": "Reservations can't be made, changed or cancelled.",
      "privateWebsite": "Your website and booking page stay private.",
      "title": "This property is preparing"
    },
    "parkingEditor": {
      "addParking": "Add parking",
      "addPhotos": "Add photos",
      "cancel": "Cancel",
      "checkOnMap": "Check on map",
      "delete": "Delete this parking",
      "directionsLabel": "Directions",
      "directionsPlaceholder": "Enter from Slovenska cesta. Take a ticket at the barrier; we validate it at reception.",
      "errorUpload": "Couldn't upload that photo.",
      "linkErrorNoLocation": "We couldn't find a location in that link. In Google Maps, drop a pin on the spot, tap Share, and paste that link here.",
      "linkErrorNotGoogle": "Only Google Maps links work here. Open the spot in Google Maps, tap Share, and paste that link.",
      "linkErrorTooLong": "{count, plural, one {That link is too long to keep (over {count} characters). Drop a pin in Google Maps and share it instead.} other {That link is too long to keep (over {count} characters). Drop a pin in Google Maps and share it instead.}}",
      "linkErrorUnreadable": "Couldn't read that link. Check your connection and try again.",
      "locationLabel": "Location",
      "mapsLinkHint": "For a spot with no street address, drop a pin in Google Maps and paste its link. Optional: leave it empty if the directions say it all.",
      "mapsLinkLabel": "Google Maps link",
      "mapsLinkPlaceholder": "Or paste a Google Maps link",
      "nameLabel": "Name",
      "namePlaceholder": "Garage on Kongresni trg",
      "photoAlt": "Parking {number}",
      "photosHint": "{count, plural, one {The entrance, the barrier or the bay: up to # photos. Screenshots work too.} other {The entrance, the barrier or the bay: up to # photos. Screenshots work too.}}",
      "photosLabel": "Photos",
      "pinnedAt": "Pinned at {latitude}, {longitude}",
      "removeLocation": "Remove location",
      "removePhoto": "Remove photo {number}",
      "save": "Save",
      "searchAddress": "Search an address",
      "searchDifferentAddress": "Search a different address",
      "uploading": "Uploading…",
      "useLink": "Use link"
    },
    "parkingEditorPage": {
      "deleted": "{label} deleted.",
      "deleting": "Deleting…",
      "errorDelete": "Couldn't delete the parking. Try again.",
      "errorRestore": "Couldn't restore the parking. Add it again.",
      "errorSave": "Couldn't save the parking. Try again.",
      "newTitle": "New parking",
      "notFound": "This parking was deleted or never existed.",
      "saved": "Parking saved.",
      "title": "Parking",
      "undo": "Undo"
    },
    "parkingPage": {
      "add": "Add parking",
      "emptyDescription": "Add the garage, street or field your guests use, with directions and a photo of the entrance.",
      "emptyTitle": "No parking yet",
      "errorReorder": "Couldn't change the order. Try again.",
      "intro": "Tell guests where to leave the car. They see this before they arrive, so they can plan the drive, and throughout their stay.",
      "loading": "Loading your parking…",
      "moveDown": "Move {label} down",
      "moveUp": "Move {label} up",
      "photoCount": "{count, plural, one {{count} photo} other {{count} photos}}",
      "pinnedLocation": "Pinned location",
      "title": "Parking"
    },
    "passwordDialog": {
      "cancel": "Cancel",
      "changeDescription": "Enter your current password, then choose a new one. You'll stay signed in here; other devices are signed out.",
      "changeSubmit": "Change password",
      "changeTitle": "Change password",
      "confirmPasswordLabel": "Confirm new password",
      "confirmPasswordPlaceholder": "Re-enter your password",
      "currentPasswordLabel": "Current password",
      "errorCurrentRequired": "Enter your current password",
      "errorMismatch": "Passwords do not match",
      "errorNotSaved": "Could not save your password. Try again.",
      "errorTooShort": "Password must be at least {count, plural, one {# character} other {# characters}}",
      "newPasswordLabel": "New password",
      "newPasswordPlaceholder": "Minimum {count, plural, one {# character} other {# characters}}",
      "setDescription": "Choose a password so you can also sign in with your email address. Your existing sign-in methods keep working.",
      "setSubmit": "Set password",
      "setTitle": "Set a password",
      "submitPending": "Saving…"
    },
    "paymentsCard": {
      "subtitle": "Take guest card payments through your own Stripe account",
      "subtitleSettles": "Stripe · settles in {currency}",
      "subtitleSettlesAccountCurrency": "Stripe · settles in your account currency",
      "title": "Card payments"
    },
    "paymentsPage": {
      "title": "Payments"
    },
    "paymentsView": {
      "checkAgain": "Check again",
      "checkingWithStripe": "Checking with Stripe",
      "connectStripe": "Connect Stripe account",
      "continueStripeSetup": "Continue Stripe setup",
      "depositChargeBody": "Take the money up front. It lands in your Stripe balance and giving it back is a refund.",
      "depositChargeLabel": "Charge it",
      "depositHoldBody": "Reserve it on the guest's card without taking it. Capture what you need or release the rest. Vidimo keeps the hold in place until checkout.",
      "depositHoldLabel": "Hold it on the card",
      "depositsTitle": "Deposits",
      "description": "Take card payments from guests through your own Stripe account. Money goes straight to you — Vidimo takes no cut.",
      "errorLoad": "Failed to load settings",
      "errorOpenStripe": "Could not open Stripe",
      "errorReachStripe": "Could not reach Stripe",
      "errorSave": "Could not save",
      "finishingSetup": "Finishing setup with Stripe. This usually takes a few seconds.",
      "loadFailed": "We couldn't load your payment settings. Your Stripe account and any payments already taken are unaffected.",
      "offHint": "Leave this off to keep recording payments by hand, as you do today.",
      "openStripe": "Open Stripe",
      "payoutsEnabled": "Payouts are enabled.",
      "payoutsEnabledSettles": "Payouts are enabled. Settles in {currency}.",
      "payoutsNotEnabled": "Payouts aren't enabled yet.",
      "payoutsNotEnabledSettles": "Payouts aren't enabled yet. Settles in {currency}.",
      "statusActive": "Ready to take payments",
      "statusDisabled": "Disabled by Stripe",
      "statusNotStarted": "Not connected",
      "statusPending": "Setup unfinished",
      "statusRestricted": "Action needed",
      "stripeAccount": "Stripe account",
      "stripeDashboardHint": "Refunds, payouts and disputes are handled in your own Stripe dashboard.",
      "title": "Card payments",
      "tryAgain": "Try again",
      "unavailable": "Card collection isn't available on this environment yet."
    },
    "propertyActivityView": {
      "emptyDescription": "Changes to rates, reservations, tasks and guests will be listed here as they happen.",
      "emptyTitle": "Nothing yet",
      "errorLoad": "Could not read the activity. Pull to try again.",
      "intro": "Who changed rates, reservations, tasks and guests here, and when. Rate changes say whether your channels took them.",
      "loading": "Loading…",
      "ratesChanged": "Changed rates or rules on {nights}",
      "ratesChangedSpan": "Changed rates or rules on {nights}, {span}",
      "title": "Activity",
      "unitsFreeUpdated": "Units free updated on {nights}",
      "unitsFreeUpdatedSpan": "Units free updated on {nights}, {span}"
    },
    "propertyBlocksView": {
      "emptyDescription": "Nothing is held off sale. Add a block above to close dates.",
      "emptyTitle": "No blocked dates",
      "errorAdd": "Couldn't add the block. Try again.",
      "errorRemoveRolledBack": "Couldn't remove the block. It's back.",
      "everyUnitType": "Every {unitType}",
      "firstNight": "First night",
      "fromSource": "· from {source}",
      "intro": "Hold nights off sale without a booking — an owner stay, maintenance, or a manual close. Blocked nights stop being sold here and on your connected channels.",
      "lastNight": "Last night",
      "reason": "Reason",
      "removeBlock": "Remove block starting {firstNight}",
      "submit": "Block dates",
      "targetLabel": "What to hold",
      "targetPlaceholder": "Pick a unit or unit type",
      "title": "Blocked dates",
      "unknownUnit": "Unknown unit"
    },
    "propertyColorPicker": {
      "customPlaceholder": "#RRGGBB (custom)",
      "hint": "Visual cue used across the app to identify this property. Leave empty to pick a stable color automatically from the property id.",
      "label": "Color",
      "reset": "Reset to auto",
      "swatchLabel": "Set color to {color}"
    },
    "propertyEmailsView": {
      "bookingConfirmationDescription": "Sent when a guest books and pays on your own site. Bookings that arrive through a channel are confirmed by the channel, not by us.",
      "bookingConfirmationLabel": "Booking confirmation",
      "checkInInviteDescription": "Sent once when a booking lands, asking the guest to check in online. Turning this off also stops the guest details your registration filings need from arriving before check-in.",
      "checkInInviteLabel": "Check-in invitation",
      "errorNotLoaded": "Couldn't load your email settings",
      "errorNotSaved": "Couldn't save that. Try again.",
      "errorPreviewNotLoaded": "Couldn't load the preview",
      "intro": "These go to your guests automatically, from your property's own address so a reply reaches you in Chats. Tap Preview on any of them to read what your guest gets.",
      "paymentsNeeded": "Nothing to send yet: this goes out when a guest pays on your own site, which needs <link>card payments</link> set up first.",
      "preview": "Preview",
      "signInLinkNote": "Guests can also request a sign-in link for their stay. That one is a guest asking to get back into their own booking, so it always sends. Anything you write yourself in Chats goes when you send it.",
      "title": "Guest emails"
    },
    "propertyForm": {
      "avatarFallbackName": "Property",
      "cancel": "Cancel",
      "confirmPhrase": "delete",
      "deleteDescription": "Permanently remove this property and all of its associated data (units, reservations, tasks). Unpaid payment links stop working and deposits held on guests' cards are released, so capture what you need first. This action is irreversible.",
      "deleteTitle": "Delete property",
      "descriptionHint": "This description will be visible to guests and users",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Describe this property",
      "errorNotSaved": "Couldn't save the property. Try again.",
      "imageCaption": "Tap to change property image",
      "nameLabel": "Property name",
      "namePlaceholder": "Enter property name",
      "readOnlyNotice": "This property has no active subscription, so its details can't be changed.",
      "save": "Save",
      "shortCodeHintAuto": "Auto-filled from the property name. Type to override; clear the field to re-enable auto-fill.",
      "shortCodeHintManual": "Used as a compact label across calendars and badges. Clear this field to follow the property name automatically.",
      "shortCodeLabel": "Short code",
      "subtitle": "Manage property details and branding",
      "title": "General"
    },
    "propertyIntegrationsView": {
      "communicationSubtitle": "Channels for {name}",
      "communicationTitle": "Guest communication",
      "distributionSubtitle": "Where {name} takes bookings",
      "distributionTitle": "Distribution channels",
      "loading": "Loading…",
      "paymentsSubtitle": "How {name} gets paid",
      "paymentsTitle": "Payments"
    },
    "propertyMembersView": {
      "cancelInvitation": "Cancel invitation",
      "codeCopied": "Invite code copied",
      "copyCode": "Copy invite code",
      "errorCodeNotCopied": "Couldn't copy — select the code to copy it manually.",
      "invite": "Invite",
      "invitedAs": "Invited as {role}",
      "memberCount": "{count, plural, one {# member} other {# members}}",
      "moreActions": "More actions",
      "noMatches": "No members match your search.",
      "pendingInvitations": "Pending invitations",
      "removeConfirm": "Remove {name} from {property}?",
      "removeFromProperty": "Remove from property",
      "resend": "Resend",
      "searchPlaceholder": "Search members...",
      "title": "Members"
    },
    "propertyNotFound": {
      "notFound": "Property not found",
      "syncing": "Syncing property…"
    },
    "propertyPhotosView": {
      "addPhotos": "Add photos",
      "added": "{count, plural, one {Photo added} other {# photos added}}",
      "addedSome": "{total, plural, one {Added {added} of # photo.} other {Added {added} of # photos.}}",
      "addedSomeWithReason": "{total, plural, one {Added {added} of # photo. {reason}} other {Added {added} of # photos. {reason}}}",
      "descriptionHint": "Read aloud by screen readers, and the only text search engines get for this image.",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "e.g. The terrace at dusk",
      "emptyDescription": "Add photos of the property and its rooms. Until you do, your public page stays out of search results.",
      "emptyTitle": "No photos yet",
      "errorDescriptionNotSaved": "Could not save the description",
      "errorNotAdded": "Could not add the photo",
      "errorNotMoved": "Could not move the photo",
      "errorNotRemoved": "Could not remove the photo",
      "errorNotReordered": "Could not reorder the photos",
      "intro": "These appear on your property's public page. The first photo leads the gallery and is used when the page is shared.",
      "mainGallery": "Main gallery",
      "moveEarlier": "Move earlier",
      "moveLater": "Move later",
      "removePhoto": "Remove photo",
      "removed": "Photo removed",
      "showsOn": "Shows on",
      "title": "Photos",
      "uploading": "Uploading…"
    },
    "propertyRatesView": {
      "addSeason": "Add season",
      "basePerNight": "Base / night",
      "cancel": "Cancel",
      "editSeason": "Edit season {name}",
      "editingSeason": "Editing \"{name}\"",
      "ensureFailedDescription": "We couldn't create your rate plans. Check your connection and try again.",
      "ensureFailedTitle": "Couldn't set up pricing",
      "errorBaseRateRolledBack": "Couldn't save the nightly price. Try again.",
      "errorFloorRolledBack": "Couldn't save the lowest price. Try again.",
      "errorRemoveSeasonRolledBack": "Couldn't remove the season. It's back.",
      "errorSaveSeason": "Couldn't save the season. Try again.",
      "firstNight": "First night",
      "floorHint": "No night, season or base rate can go below it.",
      "floorLabel": "Lowest price",
      "floorOwnerOnly": "Only the owner can change it.",
      "intro": "Set a base rate per unit type and price stretches of nights with seasons. Changes sync to your connected channels.",
      "lastNight": "Last night",
      "minStay": "Min stay",
      "minStayPlaceholder": "Any",
      "noFloor": "No lowest price set",
      "noFloorChoice": "No lowest price",
      "noSeasons": "No seasons. Nights fall back to the base rate above.",
      "noUnitsDescription": "Add units to this property before setting prices.",
      "noUnitsTitle": "No units yet",
      "none": "None",
      "noneFor": "{label}, none",
      "notSet": "Not set",
      "occupancyReduction": "Per guest under",
      "occupancyReductionHint": "Taken off the nightly rate for each guest below the unit type's capacity. Direct bookings only; the channels are sold at the full rate.",
      "openRates": "See and change nightly rates",
      "pricePerNight": "Price / night",
      "pricePlaceholder": "Base",
      "priority": "Priority",
      "removeSeason": "Remove season {name}",
      "saveChanges": "Save changes",
      "savedFloor": "Saved: {amount}",
      "savedNoFloor": "Saved: no lowest price",
      "seasonBaseRate": "base rate",
      "seasonDates": "{start} to {end}",
      "seasonLabel": "Season",
      "seasonMinStay": "{count, plural, one {· min {count} night} other {· min {count} nights}}",
      "seasonOccupancyReduction": "· −{amount} per guest under capacity (direct)",
      "seasonPlaceholder": "Summer 2027",
      "seasonPriority": "· priority {priority}",
      "seasonShortStaySurcharge": "{count, plural, one {· +{amount} under {count} night (direct)} other {· +{amount} under {count} nights (direct)}}",
      "seasonsExplain": "A season prices a range of dates in place of the base rate, and a night you change on the Calendar keeps its own price. <link>How seasons work</link>",
      "seasonsHeading": "Seasons",
      "seasonsPriorityHint": "Highest priority wins where ranges overlap",
      "settingUp": "Setting up…",
      "shortStayUnder": "Short stay under",
      "surcharge": "Surcharge",
      "surchargeHint": "Added to a stay shorter than the nights above. Direct bookings only: the channel payload has one flat rate per night and cannot express it.",
      "title": "Pricing",
      "tryAgain": "Try again",
      "useBaseRate": "Use base rate ({price})"
    },
    "propertyRegistrationView": {
      "asksBeforeSubmitting": "Your credentials stay on file. Vidimo will ask you before it submits anything with them.",
      "checkAgainAfter": "You can check again after {time}.",
      "checkBusy": "A check is already running.",
      "checkFailed": "Couldn't run the check. Please try again.",
      "checkNow": "Check now",
      "checkRefused": "These credentials were refused. Update them to check again.",
      "checkTooOften": "Checked too often. Try again later.",
      "checking": "Checking…",
      "confirmDisconnect": "Disconnect these credentials? We will remove them from your account.",
      "confirmDisconnectChecked": "Disconnect these credentials? We will remove them from your account and stop checking them.",
      "confirmDisconnectFiling": "Disconnect these credentials? We will stop filing with this system until you reconnect.",
      "confirmDisconnectWaiting": "Disconnect these credentials? We will remove them from your account, and setup will not reopen until automatic submission is ready.",
      "connectToCheck": "Connect to check",
      "connectToCheckLine": "Connect your account now and Vidimo checks it works. The check files nothing.",
      "credentialsDisconnected": "Credentials disconnected",
      "credentialsStay": "Your credentials stay on file and we will start submitting once it is ready.",
      "disconnect": "Disconnect",
      "disconnecting": "Disconnecting…",
      "errorDisconnect": "Couldn't disconnect. Please try again.",
      "errorLoadCredentials": "Couldn't load credentials.",
      "fileEachGuestYourself": "File each guest yourself before the deadline.",
      "filesFrom": "Vidimo files guests arriving from {date}. An earlier stay it has not reported is yours to file.",
      "inPreparationConnector": "Vidimo prepares your {system} reports. Submitting them automatically is still in preparation.",
      "onFileSecret": "{label}: ••••",
      "onFileValue": "{label}: {value}",
      "setUp": "Set up",
      "setupOpensLater": "Credential setup opens here once that's ready.",
      "tryAgain": "Try again",
      "updateCredentials": "Update credentials"
    },
    "propertySettingsView": {
      "activityDescription": "Who changed rates and reservations, and when",
      "activityTitle": "Activity",
      "blockedDatesDescription": "Hold nights off sale for owner stays, maintenance or a manual close",
      "blockedDatesTitle": "Blocked dates",
      "breakfastDescription": "Hours, price and where it is served",
      "breakfastTitle": "Breakfast",
      "cleaningDescription": "Who each cleaning task goes to, and the steps it starts with",
      "cleaningTitle": "Cleaning",
      "complianceDescription": "Guest registration, statistics, tourist tax and the guest registry",
      "complianceTitle": "Compliance",
      "customDomainDescription": "Serve your Places site from your own domain",
      "customDomainTitle": "Custom domain",
      "generalDescription": "Name, address, description and details",
      "generalTitle": "General",
      "groupAccount": "Account",
      "groupGuests": "Guests",
      "groupProperty": "Property",
      "guestEmailsDescription": "What we email your guests automatically, and from where",
      "guestEmailsTitle": "Guest emails",
      "guestPortalDescription": "What guests read on their stay page, with a preview: access, house rules, WiFi",
      "guestPortalTitle": "Guest portal",
      "guestPreviewDescription": "See the stay page as a guest does, from before arrival to after check-out",
      "guestPreviewTitle": "Preview as guest",
      "guestRegistryDescription": "Legal record of who stayed, with CSV export",
      "guestRegistryTitle": "Guest registry",
      "importsDescription": "Bookings your AI app copied from your current system, checked against its totals where it shows them",
      "importsTitle": "Imported bookings",
      "membersDescription": "Manage who has access to this property",
      "membersTitle": "Members",
      "messagingDescription": "Where guests reach you, and the emails we send for you",
      "messagingTitle": "Messaging",
      "notFoundTitle": "Property",
      "parkingDescription": "Where guests park, shown before and during their stay",
      "parkingTitle": "Parking",
      "photosDescription": "Photos shown on your property's public page",
      "photosTitle": "Photos",
      "pricingDescription": "Nightly rates, minimum stay and closed nights for your units",
      "pricingTitle": "Pricing",
      "roomsDescription": "Units, prices, blocked nights and the channels they sync to",
      "roomsTitle": "Rooms & rates",
      "sectionExtras": "Extras",
      "sectionHousekeeping": "Housekeeping",
      "sectionInventory": "What you sell",
      "sectionMoving": "Moving to Vidimo",
      "sectionPeople": "People",
      "sectionPublicPage": "Public page",
      "sectionRecords": "Records",
      "sectionSentAutomatically": "Sent automatically",
      "sectionStayPage": "Stay page",
      "siteDescription": "Your public page: its content, photos and domain, and card payments",
      "siteTitle": "Website",
      "stayDescription": "What guests read before and during their stay, parking and breakfast",
      "stayTitle": "Guest stay",
      "teamDescription": "Members, cleaning rules and checklists, and who changed what",
      "teamTitle": "Team",
      "title": "Settings",
      "unitsDescription": "Manage property units and unit types",
      "unitsTitle": "Units",
      "websiteDescription": "Story, highlights, reviews and FAQs for your public page",
      "websiteTitle": "Page content"
    },
    "propertyUnitsView": {
      "clearSearch": "Clear search",
      "createUnit": "Create unit",
      "emptyDescription": "Create your first unit to get started.",
      "emptyTitle": "No units yet",
      "maxGuests": "{count, plural, one {{count} guests} other {{count} guests}}",
      "noMatchDescription": "Try a different search term or clear the search.",
      "noMatchTitle": "No units match your search",
      "searchPlaceholder": "Search units...",
      "title": "Units"
    },
    "propertyWebsiteView": {
      "activitiesIntroLabel": "Intro",
      "activitiesIntroPlaceholder": "What is there to do nearby?",
      "activityBlurbPlaceholder": "On the emerald river",
      "activityTitlePlaceholder": "Kayaking",
      "addActivity": "Add an activity",
      "addDistance": "Add a distance",
      "addHighlight": "Add a highlight",
      "addQuestion": "Add a question",
      "addReview": "Add a review",
      "defaultsToPropertyName": "Defaults to the property name",
      "enquiryLabel": "Show a WhatsApp enquiry button",
      "errorImageNotUploaded": "Could not upload the image",
      "errorNotLoaded": "Could not load your website content",
      "errorNotSaved": "Could not save your changes",
      "facebookLabel": "Facebook URL",
      "faqAnswerPlaceholder": "Answer",
      "faqQuestionPlaceholder": "Question",
      "headlineLabel": "Headline override",
      "highlightIconPlaceholder": "Icon (e.g. waves)",
      "highlightLabelPlaceholder": "Swimming pool",
      "highlightSublabelPlaceholder": "Open May to November",
      "instagramLabel": "Instagram handle",
      "instagramPlaceholder": "yourhotel",
      "intro": "Everything here appears on your property's public page. Leave a section blank to hide it.",
      "loadFailed": "We couldn't load your website content.",
      "locationIntroLabel": "Location intro",
      "locationIntroPlaceholder": "What's nearby, in a sentence or two",
      "nearbyLabelPlaceholder": "Town square",
      "nearbyValuePlaceholder": "2 min walk",
      "off": "Off",
      "on": "On",
      "remove": "Remove",
      "removeImage": "Remove image",
      "replacePhoto": "Replace photo",
      "reviewAuthorPlaceholder": "Name",
      "reviewLocationPlaceholder": "City (optional)",
      "reviewQuotePlaceholder": "What the guest said",
      "reviewRatingPlaceholder": "Rating 1–5",
      "reviewSourcePlaceholder": "TripAdvisor (optional)",
      "saveChanges": "Save changes",
      "saved": "Website updated",
      "sectionEnquiries": "Enquiries",
      "sectionFaqs": "FAQs",
      "sectionHero": "Hero",
      "sectionHighlights": "Highlights",
      "sectionLocation": "Location",
      "sectionReviews": "Reviews",
      "sectionSearch": "Search (SEO)",
      "sectionSocial": "Social",
      "sectionStory": "Story",
      "sectionThingsToDo": "Things to do",
      "seoDescriptionLabel": "Meta description",
      "seoDescriptionPlaceholder": "One or two sentences for search results",
      "seoTitleLabel": "Page title override",
      "storyImageLabel": "Story image",
      "storyLabel": "Your story",
      "storyPlaceholder": "How this place came to be…",
      "taglineLabel": "Tagline",
      "taglinePlaceholder": "A short line that sells the stay",
      "tiktokLabel": "TikTok URL",
      "title": "Page content",
      "tryAgain": "Try again",
      "uploadPhoto": "Upload photo",
      "viewPublicPage": "View public page"
    },
    "registrationCards": {
      "comingBody": "Vidimo is adding support for guest registration and tourist tax country by country. Until your property's country is covered, keep handling them as you do today. Tell us you need it for {name} and we'll let you know as soon as it's ready.",
      "comingTitle": "Coming to more countries",
      "filesGuests": "guest registration",
      "filesStatistics": "statistics",
      "filesTouristTax": "tourist tax",
      "pickMunicipality": "Pick your municipality to set up integrations.",
      "registrationSubtitle": "Reporting guests to the authorities for {name}",
      "registrationTitle": "Guest registration",
      "statisticsNotCovered": "Vidimo doesn't file tourism statistics for your municipality's region yet, so keep sending them to your region's office yourself.",
      "statisticsSubtitle": "Tourism statistics reports for {name}",
      "statisticsTitle": "Statistics"
    },
    "registrationCredentialForm": {
      "beforeYouStart": "Before you start",
      "checkNotice": "When you save, Vidimo signs in to {system} and checks a test record. The check files nothing.",
      "checkNoticeAsks": "When you save, Vidimo signs in to {system} and checks a test record. The check files nothing, and Vidimo will ask you before it submits any guest.",
      "chooseFile": "Choose file",
      "connect": "Connect",
      "errorInvalid": "Couldn't save. Check the values you entered and try again.",
      "errorPlaceChanged": "Couldn't save: {system} isn't offered where your property is now. Check its municipality.",
      "errorReadFile": "Couldn't read that file.",
      "errorSave": "Couldn't save credentials. Please try again.",
      "fileOnFile": "on file",
      "fileOnFileNamed": "{name} on file",
      "noFileSelected": "No file selected",
      "openAuthority": "Open {authority}",
      "replaceFile": "Replace file",
      "saved": "Credentials saved",
      "savedAlreadyRefused": "Saved. {system} already refused these, so they were not checked again",
      "savedNoAnswer": "Saved. {system} did not answer the check",
      "savedNotChecked": "Saved. Not checked yet",
      "savedRefused": "Saved, but {system} refused them",
      "savedRefusedAccount": "Saved, but {system} refused the check for this account",
      "savedUnreadable": "Saved, but Vidimo could not read them",
      "savedWorks": "Saved. Your account works",
      "secretOnFilePlaceholder": "•••••••• on file. Leave blank to keep.",
      "update": "Update"
    },
    "integrationPage": {
      "changeMunicipality": "Change the municipality on Compliance",
      "deadline": "Deadline",
      "deadlineFromArrival": "{hours, plural, one {{hours}h from arrival} other {{hours}h from arrival}}",
      "deadlineFromArrivalWithDeparture": "{hours, plural, one {{hours}h from arrival; departure also filed} other {{hours}h from arrival; departure also filed}}",
      "deadlineShortStay": "{hours, plural, one {{hours}h} other {{hours}h}} if the stay is {maxStayHours, plural, one {{maxStayHours}h} other {{maxStayHours}h}} or less",
      "disconnectAccount": "You can disconnect the account set up earlier.",
      "lawRequires": "What the law requires",
      "loginTitle": "{system} login",
      "municipality": "Municipality",
      "noMunicipality": "Pick your property's municipality so Vidimo knows {system} applies there.",
      "notFound": "Integration not found",
      "notOffered": "{system} isn't offered in your property's country. Check the property's address.",
      "notPicked": "Not picked yet",
      "pickMunicipality": "Pick the municipality on Compliance",
      "propertyTitle": "This property in {system}",
      "regionMoved": "These credentials are for {onFile}, but your municipality reports to {current}. Update them with your {current} login.",
      "regionNotCovered": "Vidimo doesn't file statistics for your municipality's region yet.",
      "reportsTo": "Reports to",
      "requiredFields": "Required for each reported guest",
      "requiredOfHead": "{field} (party head)",
      "scopeAllGuests": "All guests",
      "scopeForeignGuestsOnly": "Foreign guests only",
      "setBy": "Set by <bases></bases>",
      "who": "Who"
    },
    "roleSelect": {
      "changeRoleFrom": "Change role from {role}",
      "title": "Change role"
    },
    "searchSortBar": {
      "sortAscending": "Sort A-Z (click for Z-A)",
      "sortDescending": "Sort Z-A (click for A-Z)"
    },
    "settingsRowStates": {
      "breakfastOff": "Off",
      "breakfastOn": "On",
      "members": "{count, plural, one {# person} other {# people}}",
      "parking": "{count, plural, =0 {None yet} one {# spot} other {# spots}}",
      "photos": "{count, plural, =0 {None yet} one {# photo} other {# photos}}",
      "units": "{count, plural, =0 {None yet} one {# unit} other {# units}}"
    },
    "signInMethods": {
      "apple": "Apple",
      "credential": "Email & password",
      "google": "Google"
    },
    "signInSecuritySection": {
      "changePassword": "Change password",
      "connect": "Connect",
      "description": "The ways you can open this account. Add a second one so you're never locked out if a provider is unavailable.",
      "errorLoad": "Couldn't load your sign-in methods. Check your connection and try again.",
      "errorOffline": "You're offline, so your sign-in methods can't be loaded right now.",
      "errorPasswordNotChanged": "Could not change your password. Try again.",
      "errorSessionNotFresh": "For your security, sign out and back in before removing a sign-in method.",
      "errorUnlinkFailed": "Could not remove that sign-in method.",
      "errorWrongCurrentPassword": "That's not your current password. Try again.",
      "loading": "Loading your sign-in methods…",
      "remove": "Remove",
      "setPassword": "Set password",
      "statusConnected": "Connected",
      "statusNoPassword": "No password set",
      "statusNotConnected": "Not connected",
      "statusOnlyMethod": "Your only way to sign in",
      "statusPasswordSet": "Password set",
      "title": "Sign-in & security"
    },
    "staffAvailabilityForm": {
      "addTimeOff": "Add time off",
      "addWindow": "Add window",
      "dayLabel": "Day",
      "endLabel": "End <optional>(optional)</optional>",
      "errorTimeOffNotAdded": "Couldn't add the time off. Try again.",
      "errorTimeOffNotRemoved": "Couldn't remove the time off. It's back.",
      "errorWindowNotAdded": "Couldn't add the hours. Try again.",
      "errorWindowNotRemoved": "Couldn't remove those hours. They're back.",
      "fromLabel": "From",
      "noTimeOff": "No time off recorded.",
      "noWindows": "No windows yet — {name} shows as unavailable everywhere.",
      "noteLabel": "Note",
      "notePlaceholder": "Optional (e.g. dentist)",
      "removeTimeOff": "Remove time off",
      "removeWindow": "Remove window",
      "startLabel": "Start",
      "timeOffTitle": "Time off",
      "title": "Availability",
      "toLabel": "To",
      "viewOnly": "View only — availability is set by an owner or manager.",
      "weeklyDescription": "{name} is available inside these windows. Anything outside them can still be assigned manually for one-offs.",
      "weeklyTitle": "Weekly availability",
      "windowRange": "{day} {start}-{end}"
    },
    "staffTaskFunctionsForm": {
      "description": "A cleaning rule that asks for one of these only picks someone who has it. You can still assign anyone by hand.",
      "errorNotSaved": "Couldn't save that change. Try again.",
      "title": "What they can do"
    },
    "statisticsFilingsHistory": {
      "description": "Overnight-stays reports filed to your regional tourism-statistics office.",
      "errorRetry": "Couldn't retry the report. Try again.",
      "reference": "Reference: {reference}",
      "retry": "Retry",
      "retryFailedAgain": "The report failed again.",
      "retryFiled": "Statistics report filed.",
      "retryNotWaiting": "This report is no longer waiting on you.",
      "statusActionNeeded": "Action needed",
      "statusCanceled": "Canceled",
      "statusFiled": "Filed",
      "statusFiling": "Filing…",
      "statusRetrying": "Retrying",
      "statusScheduled": "Scheduled",
      "statusSubmitted": "Submitted",
      "title": "Statistics reports"
    },
    "status": {
      "actionNeeded": "Action needed",
      "connected": "Connected",
      "disabled": "Disabled",
      "inPreparation": "In preparation",
      "needsAttention": "Needs attention",
      "notConnected": "Not connected",
      "off": "Off",
      "settingUp": "Setting up",
      "setupUnfinished": "Setup unfinished"
    },
    "stayTimesSection": {
      "checkIn": "Check-in from",
      "checkOut": "Checkout by"
    },
    "taskCalendarFeedSection": {
      "cancel": "Cancel",
      "copyLink": "Copy link",
      "create": "Create calendar link",
      "createPending": "Creating link…",
      "description": "Follow the tasks assigned to you in Google Calendar, Apple Calendar or Outlook.",
      "errorCopy": "Couldn't copy the link",
      "errorCreate": "Couldn't create your calendar link. Try again.",
      "errorLoad": "Couldn't load your calendar link. Check your connection and try again.",
      "errorOffline": "You're offline, so your calendar link can't be loaded right now.",
      "errorRegenerate": "Couldn't make a new link. Try again.",
      "errorTurnOff": "Couldn't turn off your link. Try again.",
      "linkCopied": "Calendar link copied",
      "linkLabel": "Calendar link",
      "loading": "Loading your calendar link…",
      "newLink": "New link",
      "offlineActionsNote": "You're offline. Copy still works; making a new link or turning it off needs a connection.",
      "offlineCreateNote": "You're offline. Creating a link needs a connection.",
      "privacyNote": "Anyone with this link can see your tasks. If it gets out, make a new one.",
      "regenerateConfirm": "Make new link",
      "regenerateDescription": "Your current link stops working straight away, and any calendar using it stops updating until you add the new one.",
      "regeneratePending": "Making link…",
      "regenerateTitle": "Make a new link?",
      "subscribeHelp": "Add it to your calendar app as a calendar from a URL. Calendar apps check for changes on their own schedule, which can take a few hours.",
      "title": "Task calendar",
      "turnOff": "Turn off",
      "turnOffConfirm": "Turn off",
      "turnOffDescription": "Your link stops working straight away, and any calendar using it stops updating. You can create a new link here at any time.",
      "turnOffPending": "Turning off…",
      "turnOffTitle": "Turn off your calendar link?"
    },
    "taskRulesPage": {
      "anyone": "Anyone",
      "assignTo": "Assign to",
      "defaultOperator": "An Operator (default)",
      "defaultReceptionist": "A Receptionist (default)",
      "errorSave": "Couldn't save that rule. Try again.",
      "fallbackOperator": "No Operator here has working hours, so these go to an Owner or Manager working at that time, and stay unassigned when none is. To send them to an Operator instead, give one working hours under Members.",
      "fallbackReceptionist": "No Receptionist here has working hours, so these go to an Owner or Manager working at that time, and stay unassigned when none is. To send them to a Receptionist instead, give one working hours under Members.",
      "formerMember": "Someone who has left this property",
      "functionHint": "Set each person's skills under Members.",
      "functionLabel": "Must be able to do",
      "hintAny": "Every other cleaning task, including ones made by hand.",
      "hintDefaultOperator": "Goes to an Operator working at that time, shared so whoever has the fewest jobs that day gets it. If no Operator is working then, it goes to an Owner or Manager who is. If nobody is, it stays unassigned.",
      "hintDefaultReceptionist": "Goes to a Receptionist working at that time, shared so whoever has the fewest jobs that day gets it. If no Receptionist is working then, it goes to an Owner or Manager who is. If nobody is, it stays unassigned.",
      "hintFollowsAny": "Follows the rule for every other cleaning task, below.",
      "loading": "Loading who each clean goes to…",
      "noOperator": "No Operator, Owner or Manager here has working hours set, so these stay unassigned. Set working hours under Members.",
      "noReceptionist": "No Receptionist, Owner or Manager here has working hours set, so these stay unassigned. Set working hours under Members.",
      "noRuleFollowsAny": "Same as every other cleaning task",
      "noRuleKindDefaults": "Each kind's default",
      "nobodyYet": "Nobody yet",
      "person": "Person",
      "personHasLeft": "They've left this property, so this rule assigns nobody. Pick someone else.",
      "personHint": "They get the task even when they're away — you'll see the warning on the task itself.",
      "summaryOperator": "An Operator",
      "summaryOwnerOrManager": "An Owner or Manager",
      "summaryReceptionist": "A Receptionist",
      "summaryUnassigned": "Unassigned",
      "unavailableDescription": "Vidimo can't load them on this device. Try again; this reloads the app.",
      "unavailableTitle": "Task rules can't be changed right now"
    },
    "taxReturns": {
      "badgeMore": "More to pay",
      "badgeOpen": "To pay",
      "badgePaid": "Paid",
      "badgeRunning": "This month",
      "description": "Each month's tourist tax, promotional tax included, from the stays whose last night falls in it. Pay it to the municipality by the due date, then mark it paid here. Tax a guest paid you before that month is due the month after they paid.",
      "errorMarkPaid": "Couldn't mark it paid. Try again.",
      "markPaid": "Mark paid",
      "markedPaid": "Marked paid.",
      "overpaid": "You paid {amount} more than these stays now owe.",
      "stays": "{count, plural, one {# stay} other {# stays}}",
      "summaryMore": "{amount} more to pay by {date}",
      "summaryOpen": "{amount} to pay by {date}",
      "summaryPaid": "{amount} paid",
      "summaryRunning": "{amount} so far, due {date}",
      "title": "Tourist tax payments",
      "uncomputed": "{count, plural, one {# stay isn't} other {# stays aren't}} worked out yet, so not in the amount."
    },
    "taxRules": {
      "ageFrom": "{age} and over",
      "ageRange": "{from} to {to}",
      "ageUnder": "under {age}",
      "chargesNothing": "No tourist tax is charged here",
      "checked": "Checked {date}",
      "from": "From {date}: {rule}",
      "maxNights": "{count, plural, one {at most # night per stay} other {at most # nights per stay}}",
      "paysFree": "{ages} free",
      "paysHalf": "{ages} half rate",
      "paysPercent": "{ages} pay {percent} of the rate",
      "perPersonNight": "{amounts} per person per night",
      "rateCategory": "{category}: {rate}",
      "ratePercent": "{percent} of the price, at most {cap}",
      "awaitsFacility": "The tourist tax here depends on where your accommodation stands, what kind it is or who runs it. Vidimo reads this from the register behind the {field} on the {system} screen, and shows the tax once the register finds your accommodation.",
      "errorLoad": "Couldn't load the tourist tax. Try again.",
      "notCovered": "Vidimo doesn't know the tourist tax where this property is yet, so its bookings show no tax for now.",
      "source": "Source",
      "withSurcharge": "{rate} + {surcharge} {label}",
      "zone": "Rate for {zone}"
    },
    "timezoneField": {
      "hint": "Used for check-in/check-out times and scheduling",
      "label": "Timezone",
      "placeholder": "Select timezone"
    },
    "unitForm": {
      "amenitiesLabel": "Amenities",
      "amenitiesPlaceholder": "Select amenities",
      "babyCots": "Baby cots",
      "cancel": "Cancel",
      "codeHintAuto": "{count, plural, one {Auto-filled from the unit name. Type to override; clear the field to re-enable auto-fill. Max # characters.} other {Auto-filled from the unit name. Type to override; clear the field to re-enable auto-fill. Max # characters.}}",
      "codeHintManual": "{count, plural, one {Compact label for calendar and task lists. E.g. 101, APH-SV. Clear this field to follow the unit name automatically. Max # characters.} other {Compact label for calendar and task lists. E.g. 101, APH-SV. Clear this field to follow the unit name automatically. Max # characters.}}",
      "codeLabel": "Short code",
      "codePlaceholder": "e.g. 101 or APH",
      "cotsAndExtraBeds": "Cots and extra beds",
      "createSubtitle": "Add a new bookable unit to this property",
      "createTitle": "Create unit",
      "deleteDescription": "Permanently remove this unit. Bookings linked to this unit may need to be updated. This action is irreversible.",
      "deleteLabel": "Delete unit",
      "descriptionHint": "Appears on the room's public page and helps it show up in search.",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Describe this room — the view, the light, what makes it special. Shown on your public room page.",
      "duplicate": "Duplicate unit",
      "editSubtitle": "Manage unit details",
      "editTitle": "Edit unit",
      "errorDelete": "Couldn't delete the unit. Try again.",
      "errorDuplicate": "Couldn't duplicate the unit. Try again.",
      "errorSave": "Couldn't save the unit. Try again.",
      "extraBeds": "Extra beds",
      "maxAdults": "Max adults",
      "maxChildren": "Max children",
      "maxChildrenPayable": "Children (payable rate)",
      "maxGuests": "Max guests",
      "nameLabel": "Name",
      "namePlaceholder": "e.g. Room 101 or Apartment A",
      "occupancy": "Occupancy",
      "save": "Save",
      "sizeLabel": "Size",
      "sizePlaceholder": "e.g. 25",
      "sizeUnitLabel": "Unit",
      "smokingAllowed": "Smoking allowed",
      "smokingLabel": "Smoking policy",
      "smokingNonSmoking": "Non-smoking",
      "smokingPlaceholder": "Select policy",
      "smokingUnknown": "Unknown",
      "unitTypeLabel": "Unit type",
      "unitTypePlaceholder": "Select unit type"
    },
    "unitsEdit": {
      "notFound": "Unit not found"
    },
    "unlinkMethodDialog": {
      "cancel": "Cancel",
      "confirm": "Remove",
      "confirmPending": "Removing…",
      "description": "You'll no longer be able to sign in with {method}. Your other sign-in methods keep working, and you can connect it again from this screen.",
      "title": "Remove {method}?"
    },
    "wifiSection": {
      "hidePassword": "Hide WiFi password",
      "hint": "Shown to guests from arrival day. They see it once both network name and password are set. The password is never included in AI drafts.",
      "label": "WiFi",
      "passwordLabel": "WiFi password",
      "passwordPlaceholder": "Password",
      "revealPassword": "Reveal WiFi password",
      "ssidLabel": "WiFi network name",
      "ssidPlaceholder": "Network name"
    }
  },

  "setup": {
    "setupBookingsStep": {
      "continue": "Continue",
      "description": "Your AI app can copy them into Vidimo, so you don't keep two calendars.",
      "fresh": "No, I'm starting fresh",
      "import": "Yes, bring them over",
      "imported": "Bookings imported from {source}.",
      "openImports": "Open Imported bookings",
      "results": "You can also do this later from a computer. The prompt and your results wait in Settings.",
      "skip": "Skip for now",
      "title": "Do you already take bookings in another system?"
    },
    "setupEmptyState": {
      "calendarDescription": "Finish setting up your property and units to see reservations laid out across your calendar.",
      "calendarTitle": "Your bookings calendar will appear here",
      "chatsDescription": "Finish setting up your property and guest messages, bookings, and AI replies will start flowing in.",
      "chatsTitle": "Your guest conversations will live here",
      "setUp": "Set up your property",
      "skip": "Skip for now",
      "tasksDescription": "Finish setting up your property to assign cleanings, check-ins, and maintenance to your team.",
      "tasksTitle": "Your team's tasks will appear here",
      "todayDescription": "Finish setting up your property and each day's arrivals, departures, and in-house guests will land here.",
      "todayTitle": "Your day will start here"
    },
    "setupEssentialsStep": {
      "addressHint": "Search and select the address to pin the location and fill in the country.",
      "addressLabel": "Address",
      "addressPlaceholder": "Search the property address…",
      "continue": "Save & continue",
      "description": "The basics guests and your team rely on. You can refine everything later in settings.",
      "errorNotSaved": "Couldn't save property details. Try again.",
      "nameLabel": "Property name *",
      "namePlaceholder": "Enter property name",
      "timezoneConfirm": "Confirm",
      "timezoneDetected": "Detected from this device — not saved until you confirm it or pick an address.",
      "timezoneHint": "Used for check-in/check-out times and scheduling.",
      "timezoneLabel": "Timezone",
      "timezonePlaceholder": "Select timezone",
      "title": "Property essentials"
    },
    "setupStepLayout": {
      "back": "Back",
      "saving": "Saving...",
      "skip": "Skip"
    },
    "setupSummaryStep": {
      "addressLabel": "Address",
      "bookingsImported": "Imported from {source}",
      "bookingsLabel": "Bookings",
      "bookingsNone": "None to bring over",
      "bookingsNotYet": "Not yet",
      "descriptionComplete": "You're all set. Your property is ready to run.",
      "descriptionIncomplete": "You can finish now and complete the remaining essentials anytime from settings.",
      "finish": "Finish setup",
      "finishAnyway": "Finish anyway",
      "invitesNone": "No invites yet (optional)",
      "invitesPending": "{count, plural, one {{count} invitation pending} other {{count} invitations pending}}",
      "nameLabel": "Property name",
      "notSet": "Not set yet",
      "teamLabel": "Team",
      "timezoneLabel": "Timezone",
      "title": "Review",
      "unitsAdded": "{count, plural, one {{count} unit added} other {{count} units added}}",
      "unitsLabel": "Units",
      "unitsNone": "Add at least one unit"
    },
    "setupTeamStep": {
      "continue": "Continue",
      "description": "Invite a teammate to help run the property. You can always do this later — it's optional.",
      "emailHint": "We'll email them a link to join, plus an invite code they can enter in the app.",
      "emailLabel": "Email",
      "emailPlaceholder": "name@example.com",
      "errorNotSent": "Couldn't send the invitation.",
      "invitationPending": "{role} · invitation pending",
      "invitationSent": "Invitation sent",
      "noPermission": "You don't have permission to invite members at this property.",
      "roleLabel": "Role",
      "rolePlaceholder": "Select a role",
      "send": "Send invitation",
      "sending": "Sending...",
      "skip": "Skip for now",
      "title": "Invite your team"
    },
    "setupUnitsStep": {
      "add": "Add unit",
      "adding": "Adding...",
      "continue": "Continue",
      "description": "Add the rooms or apartments guests can book. You need at least one; add more anytime in settings.",
      "errorNotAdded": "Couldn't add the unit. Try again.",
      "errorNotRemoved": "Couldn't remove the unit. Try again.",
      "maxGuestsLabel": "Max guests",
      "nameLabel": "Unit name",
      "namePlaceholder": "e.g. Room 101 or Apartment A",
      "remove": "Remove {name}",
      "skip": "Skip for now",
      "title": "Units",
      "typeLabel": "Type",
      "typePlaceholder": "Select type",
      "typeSleeps": "{count, plural, one {{type} · sleeps {count}} other {{type} · sleeps {count}}}",
      "unitFallback": "Unit"
    },
    "setupWizard": {
      "skipSetup": "Skip setup",
      "stepBookings": "Bookings",
      "stepEssentials": "Essentials",
      "stepReview": "Review",
      "stepTeam": "Team",
      "stepUnits": "Units",
      "subtitle": "Get your property ready to run",
      "titleNamed": "Set up {name}",
      "titleUnnamed": "Set up your property"
    }
  },

  "shell": {
    "appHeader": {
      "search": "Search"
    },
    "appNavRail": {
      "label": "Primary"
    },
    "auditFormatting": {
      "fieldLabel": {
        "assignedTo": "assignee",
        "description": "description",
        "endAt": "check-out",
        "expectedArrivalTime": "ETA",
        "linkedGuest": "Guest link",
        "mergedDuplicate": "Merge",
        "startAt": "check-in",
        "status": "status",
        "taxNote": "tax note",
        "title": "title",
        "type": "type",
        "unitId": "unit"
      },
      "fromTo": "{from} to {to}",
      "none": "none",
      "withheldChange": "{kind, select, added {added} removed {removed} other {changed}}",
      "withheldField": "{field} {kind, select, added {added} removed {removed} other {changed}}"
    },
    "auditTimeline": {
      "bySupport": "Vidimo support for {actor}",
      "changeTo": "to",
      "headline": {
        "guestCreate": "Guest added: {summary}",
        "guestDelete": "Guest removed: {summary}",
        "guestUpdate": "Guest changed: {summary}",
        "rateCreate": "Rates added: {summary}",
        "rateDelete": "Rates removed: {summary}",
        "rateUpdate": "Rates changed: {summary}",
        "reservationCreate": "Reservation added: {summary}",
        "reservationDelete": "Reservation removed: {summary}",
        "reservationUpdate": "Reservation changed: {summary}",
        "taskCreate": "Task added: {summary}",
        "taskDelete": "Task removed: {summary}",
        "taskMissTakenBack": "Back to do: the guest isn't in after all",
        "taskMissed": "Missed: the guest arrived before it was done",
        "taskUpdate": "Task changed: {summary}"
      },
      "byVidimo": "Vidimo",
      "onBehalf": "{agent} (Vidimo support) for {actor}",
      "open": {
        "guest": "Open guest",
        "reservation": "Open reservation",
        "task": "Open task"
      },
      "title": "Activity",
      "unknownActor": "Unknown"
    },
    "avatarUpload": {
      "chooseImage": "Choose image",
      "errorUpload": "Couldn't upload the image. Please try again."
    },
    "connectionStatusBanner": {
      "backendUnreachable": "Can't reach Vidimo. Changes will sync when it's back.",
      "changesNotSent": "Some changes haven't been sent yet. Keep the app open while we retry.",
      "deviceOffline": "You're offline. Changes will sync when you're back."
    },
    "copyRecordLink": {
      "copied": "Link copied",
      "errorNotCopied": "Couldn't copy the link"
    },
    "deviceReplica": {
      "clearDatabase": {
        "cancel": "Keep",
        "confirm": "Clear anyway",
        "unsynced": "{count, plural, one {{count} change on this device hasn't synced yet. Clearing now deletes it from this device, and it won't reach Vidimo.} other {{count} changes on this device haven't synced yet. Clearing now deletes them from this device, and they won't reach Vidimo.}}",
        "unsyncedUnknown": "Some changes on this device may not have synced yet. Clearing now deletes them from this device, and they won't reach Vidimo."
      },
      "signOut": {
        "cancel": "Stay signed in",
        "confirm": "Sign out anyway",
        "unsynced": "{count, plural, one {{count} change on this device hasn't synced yet. Signing out now deletes it from this device, and it won't reach Vidimo.} other {{count} changes on this device haven't synced yet. Signing out now deletes them from this device, and they won't reach Vidimo.}}",
        "unsyncedUnknown": "Some changes on this device may not have synced yet. Signing out now deletes them from this device, and they won't reach Vidimo."
      },
      "signOutFailed": "Couldn't sign out. Check your connection and try again.",
      "signOutOffline": "You're offline. Connect to sign out; everything stays on this device until then.",
      "unsyncedTitle": "Unsynced changes"
    },
    "errorBoundary": {
      "description": "Reload the app to carry on.",
      "reload": "Reload App",
      "title": "Something went wrong"
    },
    "loading": "Loading...",
    "mrzScanner": {
      "alreadyOnBooking": "{name} is already on this booking. {outcome}",
      "confirm": "Confirm",
      "correctBody": "Saving sends the corrected details with any report still due or refused; one the authority already accepted is not sent again.",
      "correctionSaved": "Registration details saved.",
      "errorNoReservation": "Couldn't tell which booking this is. Reopen the reservation and try again.",
      "errorNotAccepted": "The details weren't accepted. Check them against the document and try again.",
      "errorNotOnBooking": "This person is no longer on this booking. Reopen the reservation to see who is.",
      "errorPartyFull": "This booking already has everyone it says it is expecting. To add someone, raise its Adults, Children or Infants first. To scan someone already on it, tap the ID card on their row.",
      "errorReservationNotActive": "This reservation no longer accepts check-ins.",
      "errorTimedOut": "This is taking longer than usual and may still save. Check their Registration before saving again.",
      "errorUnreachable": "Couldn't reach the server. Check your connection and try again.",
      "guestPickerLabel": "Whose ID is this?",
      "noGuests": "This reservation has no guests yet — the first scan will add them.",
      "outcomeActionNeeded": "Saved, but the registration still needs attention. Their Registration shows what it needs.",
      "outcomeFiled": "Saved and filed. The authority confirmed it.",
      "outcomeNone": "Document saved to guest.",
      "outcomeSubmitted": "Saved and submitted. Awaiting confirmation.",
      "savedBlockedAuth": "Saved. The filing still needs the property's government credentials reconnected.",
      "savedBlockedFiledByHost": "Saved. You filed this guest's other report yourself, so file this one with the authority yourself too.",
      "savedBlockedMissingData": "Saved, but the filing still needs details this registration does not have yet.",
      "savedBlockedNoConnector": "Saved. Vidimo isn't filing this guest, so please file them with the authority before the deadline.",
      "savedBlockedOtherFacility": "Saved. This guest's record is under another RNO number. If the guest didn't stay at that facility, cancel it on the authority's portal and file the guest under the current number. Otherwise, finish it there.",
      "savedBlockedUnknown": "Saved, but the filing still needs attention.",
      "savedBlockedValidation": "Saved, but the authority still rejected it.",
      "scanner": {
        "back": "Back",
        "cameraFailed": "Couldn't start the camera. Check its permissions and retry.",
        "cancelScan": "Cancel scan",
        "checkingRequirements": "Checking what registering this stay requires…",
        "chooseOneOf": "Choose {choices}.",
        "chooseWho": "Choose who is checking in.",
        "close": "Close",
        "countryClear": "Clear",
        "documentNumberPlaceholder": "Document number",
        "doubleCheck": "Please double-check: {fields}",
        "failedBody": "Happens all the time. Pick whichever is easiest:",
        "failedTitle": "Couldn't read that ID",
        "guestFallback": "Guest {id}",
        "manualBody": "Copy these from the document, they need to match exactly.",
        "manualSubmit": "Save details",
        "manualTitle": "Type in the ID details",
        "missingLicense": "Document scanning isn't available right now. Please contact your host.",
        "noCamera": "No camera? Enter the details by hand",
        "openingCamera": "Opening the camera…",
        "optional": "Optional",
        "personalNumberPlaceholder": "As on the document",
        "pickGuest": "Choose who these details are for.",
        "regimeFieldsIntro": "Required to register the stay here, and not printed on the document.",
        "required": "Required",
        "retake": "Retake scan",
        "reviewBody": "Read from the document, on your phone. Fix anything that looks off, it must match exactly.",
        "reviewTitle": "Check it matches the ID",
        "scanBody": "Hold the photo page inside the frame. It reads by itself, nothing to press.",
        "scanButton": "Scan passport or ID",
        "scanEyebrow": "Scan an ID",
        "scanTarget": "For",
        "scanTitle": "Scan the guest's passport or ID card",
        "scanned": "✓ Scanned",
        "select": "Select",
        "selectSex": "Select sex",
        "submitFailed": "Couldn't submit your check-in.",
        "submitting": "Submitting…",
        "tryAgainSub": "More light, less glare, hold it flat",
        "tryAgainTitle": "Try again",
        "typeInsteadSub": "Enter what's printed on the document",
        "typeInsteadTitle": "Type the details instead",
        "view": {
          "cameraAccessDenied": "Camera access denied",
          "closeScanner": "Close scanner",
          "holdSteady": "Hold steady...",
          "loadImageFailed": "Failed to load image",
          "positionMRZ": "Position MRZ within the frame",
          "rotateDevice": "Please rotate your device to portrait mode",
          "scanSuccess": "MRZ scanned ✓",
          "switchCamera": "Switch camera",
          "toggleFlash": "Toggle flash"
        }
      }
    },
    "notFound": {
      "description": "This link doesn't lead anywhere in Vidimo. It may be old or mistyped.",
      "goToToday": "Go to Today",
      "title": "Page not found"
    },
    "osHelpers": {
      "cancel": "Cancel",
      "settings": "Settings"
    },
    "pageHeader": {
      "back": "Back"
    },
    "parkedDrawerBar": {
      "close": "Close details",
      "reopen": "Reopen {name}"
    },
    "paywallGate": {
      "errorOwnerOnly": "Only the property owner can set up billing.",
      "lapsedNativeDescription": "This property is paused. Nothing has been deleted, and access returns as soon as the subscription is active again.",
      "lapsedNotice": "This property's subscription has lapsed. Ask the owner to renew.",
      "lapsedTitle": "Your subscription has ended",
      "noSubscriptionDescription": "It needs an active subscription. Your data stays safe until then.",
      "noSubscriptionTitle": "This property isn't active yet",
      "pastDueNative": "Payment failed. Access may end soon.",
      "propertySettings": "Property settings",
      "signOut": "Sign out",
      "trialActive": "Free trial active.",
      "trialDaysLeft": "Free trial: {days, plural, one {# day} other {# days}} left."
    },
    "persisted": {
      "lateRollback": "A change you saved a moment ago didn't stick. Check it and try again."
    },
    "placePicker": {
      "errorDetails": "Could not load that address. Try another result.",
      "errorLookup": "Address lookup failed. Check your connection.",
      "poweredByGoogle": "Powered by Google",
      "searching": "Searching…",
      "unavailable": "Address search unavailable"
    },
    "powersyncUploadFeedback": {
      "breakfastAlreadySetUp": "Breakfast was already set up on another device, so your change wasn't saved.",
      "discarded": "Some changes couldn't be saved and were reverted.",
      "discardedEntity": "Some changes to your {label} couldn't be saved and were reverted.",
      "labels": {
        "availability": "availability",
        "breakfast": "breakfast setup",
        "charge": "charge",
        "conversation": "conversation",
        "guest": "guest",
        "message": "message",
        "payment": "payment",
        "pricing": "pricing",
        "property": "property",
        "reaction": "reaction",
        "reservation": "reservation",
        "suggestion": "suggestion",
        "task": "task",
        "timeOff": "time off",
        "unit": "unit"
      },
      "revertAfterFiling": "These guests' arrival was already sent to the register, so the booking can't go back to before check-in."
    },
    "prerenderRoutes": {
      "signupMetaDescription": "Create a Vidimo account to manage your properties, reservations, guest messaging and check-ins from one place.",
      "signupTitle": "Create an account · Vidimo"
    },
    "primaryTabs": {
      "calendar": "Calendar",
      "chats": "Chats",
      "guests": "Guests",
      "tasks": "Tasks",
      "today": "Today"
    },
    "propertyFacet": {
      "addProperty": "Add property",
      "allProperties": "All properties",
      "colorLabel": "Property color for {name}",
      "empty": "No properties available.",
      "only": "Only",
      "onlyLabel": "Show only {name}",
      "settingsLabel": "Settings for {name}",
      "title": "Your properties"
    },
    "rowPending": {
      "syncing": "{kind, select, guest {Syncing guest…} member {Syncing member…} parking {Syncing parking…} reservation {Syncing reservation…} staffMember {Syncing staff member…} task {Syncing task…} unit {Syncing unit…} other {Syncing…}}"
    },
    "scopeChip": {
      "allProperties": "All properties",
      "clearFilters": "Clear<suffix> {count, plural, one {# filter} other {# filters}}</suffix>",
      "clearFiltersLabel": "Clear {count, plural, one {# filter} other {# filters}}",
      "noProperties": "No properties",
      "propertyCount": "{count, plural, one {# property} other {# properties}}",
      "scopeLabel": "Scope: {label}",
      "scopeLabelFiltered": "Scope: {label} ({count, plural, one {# filter} other {# filters}} active)"
    },
    "scopeDrawer": {
      "title": "Scope"
    },
    "searchOverlay": {
      "close": "Close search",
      "emptyDescription": "Search for guests, staff, reservations, and tasks",
      "guestFallback": "Guest",
      "noResultsDescription": "Try a different search term",
      "noResultsTitle": "No results",
      "placeholder": "Search guests, staff, reservations, tasks...",
      "reservationFallback": "Reservation",
      "taskSubtitle": "Task",
      "taskSubtitleAssigned": "Task • {assignee}",
      "title": "Search"
    },
    "staffFacet": {
      "allStaff": "All staff",
      "empty": "No staff available.",
      "meSuffix": "(me)",
      "only": "Only",
      "onlyLabel": "Show only {name}",
      "title": "Staff"
    },
    "stillLooking": {
      "description": "It may still be syncing. If it doesn't appear, it may have been removed, or it belongs to a property you don't have access to.",
      "title": "{kind, select, guest {Still looking for this guest} member {Still looking for this member} parking {Still looking for this parking} reservation {Still looking for this reservation} staffMember {Still looking for this staff member} task {Still looking for this task} unit {Still looking for this unit} other {Still looking for this}}"
    },
    "supportSession": {
      "ended": {
        "description": "The customer's data is cleared from this tab. You can close it.",
        "title": "Support session ended"
      },
      "failed": {
        "description": "Check the connection, then open a new one from the CRM.",
        "title": "Couldn't open the session"
      },
      "invalid": {
        "description": "Each link opens one session and works for a minute. Open a new one from the CRM.",
        "title": "This link has expired or was already used"
      },
      "opening": "Opening the customer's app…"
    },
    "supportSessionBanner": {
      "exit": "Exit",
      "viewingAs": "Viewing as {name}, Vidimo support"
    },
    "syncingState": {
      "defaultLabel": "Syncing your conversations…",
      "retry": "Try again",
      "retrying": "Retrying…",
      "slow": "Sync is taking longer than usual…",
      "unreachableDescription": "Your data will load as soon as the connection is restored. Check your internet connection, or try again in a moment.",
      "unreachableTitle": "Can't reach the sync server"
    },
    "useAcceptInvitation": {
      "errorInvitationNotFound": "That invite code isn't valid any more — it may have expired or been withdrawn. Ask for a new one.",
      "errorNotJoined": "Couldn't join the property. Check your invite code and try again.",
      "errorSupportSession": "Joining a property isn't available in a support session.",
      "errorWrongRecipient": "This invitation was sent to a different email address. Sign in with that address to accept it.",
      "joined": "Joined property"
    },
    "useDirtyGuard": {
      "discardPrompt": "You have unsaved changes. Discard them?"
    },
    "userDrawer": {
      "account": "Account",
      "accountDescription": "Profile, appearance and task calendar",
      "accountSection": "Account",
      "contactSupport": "Contact support",
      "contactSupportDescription": "Message the Vidimo team",
      "help": "Help",
      "helpDescription": "Guides for using Vidimo",
      "joinProperty": "Join a property",
      "joinPropertyDescription": "Use an invite code from a teammate",
      "legalSection": "Legal",
      "notifications": "Notification settings",
      "notificationsDescription": "Messages, groups and call sounds",
      "privacy": "Privacy policy",
      "privacyDescription": "How Vidimo handles your data",
      "signOut": "Sign out",
      "signedIn": "Signed in",
      "supportSection": "Support",
      "terms": "Terms of service",
      "termsDescription": "The agreement covering your use of Vidimo",
      "trigger": "User menu",
      "triggerWithNews": "User menu, with something new in What's new",
      "whatsNew": "What's new",
      "whatsNewDescription": "What changed in Vidimo, release by release",
      "whatsNewUnseen": "New entry"
    }
  },

  "stayPreview": {
    "stayPreviewFrame": {
      "frameTitle": "Guest stay page preview",
      "loadFailed": "The preview didn't load.",
      "tryAgain": "Try again"
    },
    "stayPreviewHost": {
      "preview": "Preview",
      "title": "Preview as guest"
    },
    "stayPreviewPanel": {
      "copyLink": "Copy link",
      "errorCopyFailed": "Couldn't copy the link",
      "linkCopied": "Preview link copied",
      "phaseAfter": "After check-out",
      "phaseArrivalDay": "Arrival day",
      "phaseBefore": "Before arrival",
      "phaseGroupLabel": "Stay phase",
      "phaseInStay": "During the stay",
      "qrCodeLabel": "QR code to open this preview on your phone",
      "sampleNotice": "A sample stay: the dates, guests and door code are examples.",
      "scanHint": "Scan to open this preview on your phone. It shows what you have saved."
    }
  },

  "tasks": {
    "completed": {
      "completeFailed": "Couldn't complete the task. Try again.",
      "title": "Task completed",
      "undo": "Undo",
      "undoFailed": "Couldn't undo. The task is still completed."
    },
    "completionNote": {
      "dictate": "Dictate a note",
      "hint": "Note anything that needs follow-up.",
      "optional": "Optional",
      "placeholder": "Type a note…",
      "save": "Save note",
      "saveFailed": "Couldn't save the note. Try again.",
      "saved": "Saved",
      "stopRecording": "Stop recording",
      "title": "Add a note to task",
      "transcribeFailed": "Couldn't transcribe the recording. Please try again.",
      "transcribing": "Transcribing…"
    },
    "editTaskForm": {
      "assignedTo": "Assigned To",
      "back": "Back",
      "backToTasks": "Back to tasks",
      "cancel": "Cancel",
      "create": "Create",
      "created": "Task created.",
      "dateLabel": "Date <hint>(optional — leave empty for a loose chore)</hint>",
      "delete": "Delete",
      "deleteDescription": "It disappears for everyone. Completing a task is usually the better way to close work out, so delete is for one that should never have existed.",
      "deleteTask": "Delete task",
      "deleteTitle": "Delete this task?",
      "deleted": "Task deleted",
      "deleting": "Deleting…",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Task description (optional)",
      "endTimeLabel": "End Time",
      "errorNotDeleted": "Couldn't delete this task. Please try again.",
      "errorNotSaved": "Couldn't save the task. Try again.",
      "notFound": "Task not found",
      "priorityHigh": "High",
      "priorityLabel": "Priority",
      "priorityLow": "Low",
      "priorityMedium": "Medium",
      "propertyLabel": "Property",
      "propertyPlaceholder": "Select a property",
      "save": "Save",
      "startTimeLabel": "Start Time",
      "statusLabel": "Status",
      "titleEdit": "Edit task",
      "titleLabel": "Title",
      "titleNew": "New task",
      "titlePlaceholder": "Task title",
      "typeCleaning": "Cleaning",
      "typeLabel": "Type",
      "typeMaintenance": "Maintenance",
      "unitLabel": "Unit",
      "unitNeedsProperty": "Please select a property first",
      "updated": "Task updated."
    },
    "staffAssigneeSelect": {
      "assigned": "Assigned",
      "cancel": "Cancel",
      "confirm": "Assign anyway",
      "confirmDescription": "They're flagged as unavailable for this slot. You can still assign them if it's urgent.",
      "confirmDescriptionReason": "They're flagged as unavailable for this slot — {reason}. You can still assign them if it's urgent.",
      "confirmTitle": "Assign {name} anyway?",
      "filteringNote": "{taskFunction, select, check_in {Showing staff who can do check-in work.} check_out {Showing staff who can do check-out work.} cleaning {Showing staff who can do cleaning work.} concierge {Showing staff who can do concierge work.} maintenance {Showing staff who can do maintenance work.} other {Showing staff who can do {taskFunction} work.}}",
      "noFunction": "{taskFunction, select, check_in {No check-in function} check_out {No check-out function} cleaning {No cleaning function} concierge {No concierge function} maintenance {No maintenance function} other {No {taskFunction} function}}",
      "showEveryone": "Show everyone",
      "showQualified": "Show only qualified staff",
      "unassigned": "Unassigned"
    },
    "taskCues": {
      "label": {
        "infant": "Set up baby cot — infant",
        "pet": "Travelling with a pet",
        "petWithNotes": "Pet: {notes}"
      },
      "short": {
        "accessibility": "Access",
        "dietary": "Dietary",
        "infant": "Baby cot",
        "pet": "Pet"
      }
    },
    "taskDetails": {
      "accessibility": "Accessibility",
      "afterCheckout": "After checkout at {checkOut}",
      "afterCheckoutBeforeCheckIn": "After checkout at {checkOut} · Before check-in at {checkIn}",
      "assignedTo": "Assigned to",
      "assignment": "Assignment",
      "beforeCheckIn": "Before check-in at {checkIn}",
      "checkIn": "Check-in",
      "cleaningUpAfter": "Cleaning up after <guest>{name}</guest>",
      "completionNote": "Completion note",
      "description": "Description",
      "dietary": "Dietary",
      "eta": "· ETA ~{eta}",
      "markDone": "Mark done",
      "notScheduled": "Not scheduled",
      "openLiveView": "Open live view",
      "pets": "Pets",
      "prepFor": "Prep for",
      "specialRequests": "Special requests",
      "startTask": "Start task",
      "travellingWithPet": "Travelling with a pet",
      "unassigned": "Unassigned",
      "unitCode": "Unit {code}",
      "unitCodeAndName": "Unit {code} — {name}",
      "unknownUnit": "Unknown unit",
      "via": "via",
      "viewFullReservation": "View full reservation",
      "viewSummary": "View summary",
      "when": "When",
      "where": "Where"
    },
    "taskLiveView": {
      "allStepsDone": "{total, plural, one {All {total} steps done} other {All {total} steps done}}",
      "assignment": "Assignment",
      "back": "Back",
      "backToTasks": "Back to tasks",
      "checkInFrom": "Guest check-in from {time}",
      "checkInFromWithEta": "Guest check-in from {time} · ETA {eta}",
      "checklistTitle": "Clean to standard",
      "compactCheckIn": "Check-in {time}",
      "compactEta": "ETA {time}",
      "edit": "Edit",
      "errorComplete": "Couldn't complete the task. Try again.",
      "errorStart": "Couldn't start the task. Try again.",
      "errorStepUpdate": "Couldn't update that step. Try again.",
      "errorUpdate": "Couldn't update the task. Try again.",
      "finishAnyway": "Finish anyway",
      "finishHintTask": "Finish the task when the room's ready — no rush.",
      "finishHintTurnover": "Finish the turnover when the room's ready — no rush.",
      "missedHint": "The guest arrived before this was done. If it was done, set it to Completed from the task, then set the room to Clean.",
      "missedHintAskManager": "The guest arrived before this was done. If it was done, set it to Completed from the task, and ask an owner or manager to set the room to Clean.",
      "finishPostCheckout": "Finish post-checkout",
      "finishPreCheckinRefresh": "Finish pre-arrival refresh",
      "finishTurnover": "Finish turnover",
      "finished": "Finished",
      "guestNames": "— {names}",
      "headerTitle": "Task",
      "headingKindUnit": "{kind} — {unit}",
      "keepGoing": "Keep going",
      "kindCleaning": "Cleaning",
      "kindComplete": "{kind} complete",
      "kindMaintenance": "Maintenance",
      "markComplete": "Mark complete",
      "markedComplete": "Marked complete",
      "missing": "This task isn't available.",
      "notScheduled": "Not scheduled",
      "notesQuote": "“{notes}”",
      "pause": "Pause",
      "prepFor": "Prep for · next guests",
      "resume": "Resume",
      "someStepsDone": "{total, plural, one {{done} / {total} steps done} other {{done} / {total} steps done}}",
      "startTask": "Start task",
      "started": "Started",
      "startedAt": "Started {time}",
      "stepsLeftDescription": "Not ticked yet:",
      "stepsLeftTitle": "{left, plural, one {Finish with {left} step left?} other {Finish with {left} steps left?}}",
      "task": "Task",
      "taskComplete": "Task complete",
      "todayBefore": "Today, anytime before {time}",
      "upNext": "Up next",
      "upNextFor": "Up next · {name}",
      "when": "When",
      "where": "Where"
    },
    "taskPrep": {
      "adults": "{count, plural, one {# adult} other {# adults}}",
      "children": "{count, plural, one {# child} other {# children}}",
      "guests": "{count, plural, one {# guest} other {# guests}}",
      "infants": "{count, plural, one {# infant} other {# infants}}"
    },
    "tasksView": {
      "completeTask": "Complete {title}",
      "createTask": "Create new task",
      "dateAt": "{date} • {time}",
      "emptyDescription": "Create a task to get started",
      "emptyTitle": "No tasks found",
      "hideCompleted": "Hide completed tasks",
      "needsOwner": "needs an owner",
      "openTask": "Open {title}",
      "sectionCompleted": "Completed",
      "sectionMissed": "Missed",
      "sectionOverdue": "Overdue",
      "sectionToday": "Today",
      "sectionUnscheduled": "Unscheduled",
      "sectionUpcoming": "Upcoming",
      "showCompleted": "Show completed tasks",
      "switchToColumns": "Switch to column view",
      "switchToList": "Switch to list view",
      "syncing": "Syncing your tasks…",
      "taskCount": "{count, plural, one {{count} task} other {{count} tasks}}",
      "taskCountNeedsOwner": "{count, plural, one {{count} task • needs an owner} other {{count} tasks • needs an owner}}",
      "title": "Tasks",
      "unassigned": "Unassigned",
      "unavailableDescription": "Vidimo can't load your tasks on this device. Try again; this reloads the app.",
      "unavailableTitle": "Tasks can't be shown right now"
    },
    "waitsForClean": {
      "detail": "The room is still dirty. Start the refresh once it's been cleaned.",
      "title": "Waits for the clean"
    }
  }
}
